import { useState, useEffect, useCallback, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { bindActionCreators, } from "redux";
import { Helmet } from "react-helmet-async";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useLocation,
  NavLink,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import $ from "jquery";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box, Modal } from "@mui/material";
import { format } from "date-fns";
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from "../../utils/cryptoUtils";
import { agent } from "../../utils/agent";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../common.scss";
import * as leadActions from "../../actions/leadActions";
import LeadCommunication from "./LeadCommunication";
import LeadChecklists from "./LeadChecklists";
import Questionnaire from "./Questionnaire";
import LeadQuestionnaire from "./LeadQuestionnaire";
import SummaryInfo from "./SummaryInfo";
import AccessDenied from "../common/AccessDenied";
import IncidentReporteCreate from "../incidentReporte/IncidentReporteCreate";
import * as incidentReporteActions from "../../actions/incidentReporteActions";
import CoApplicant from "./CoApplicant";
import Guarantor from "./Guarantor";
import UploadBankStatement from "./UploadBankStatement";
import UploadITR from "./UploadITR";
import UploadGST from "./UploadGST";
import NoteHistoryPage from "./NoteHistoryPage";
import * as groupsUsersActions from "../../actions/groupsUsersActions";
import * as leadGstActions from "../../actions/leadGstActions";
import * as leadItrActions from "../../actions/leadItrActions";
import * as leadBankStatementActions from "../../actions/leadBankStatementActions";
import * as campaignsActions from "../../actions/campaignsActions";
import UploadDocument from "./UploadDocument";
import LeadUploadAcivity from "./LeadUploadAcivity";
import LeadChecklistScore from "./LeadChecklistScore";
import LeadChecklistDynamicScore from "./LeadChecklistDynamicScore";
import ManageShipmentByLeadListingPage from "../manage_shipment/ManageShipmentByLeadListingPage";
import * as masterAction from "../../actions/masterAction";
import * as moduleAction from "../../actions/moduleAction";
import FiDetils from "./FiDetils";
import BankStatementParser from "./BankStatementParser";
import CamPage from "./CamPage";
import LeadChecklistTvr from './LeadChecklistTvr';
import SanctionLetter from "./SanctionLetter";
import DeliveryOrder from "./DeliveryOrder";
 import DisbursementStage from "./DisbursementStage";
 import PostDisbursalDocument from "./PostDisbursalDocument";
 import ApplicationDetails from "./ApplicationDetails";
 import CaseManagementSystem from "./CaseManagementSystem";
 import RepaymentSchedule from "./RepaymentSchedule";
 import LeadTasks from "./LeadTasks";
 import ReFIReview from "./ReFIReview";
import Communication from "./Communication";
import CallToLead from "./CallToLead";
import BeatPlanTab from "./BeatPlanTab";
 // ----------------------------------------------------------------------

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    position: 'relative',
    width: '80%',
    height: '80%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 15,
    fontSize: '24px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
};

const confirmModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2000,
  },
  box: {
    background: '#fff',
    borderRadius: '10px',
    padding: '30px 40px',
    width: '420px',
    maxWidth: '90%',
    textAlign: 'center',
    boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
  },
  iconWrap: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    border: '3px solid #f8bb86',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 15px',
  },
  icon: { fontSize: '30px', color: '#f8bb86', fontWeight: 'bold' },
  title: { fontSize: '22px', fontWeight: 600, marginBottom: '10px' },
  message: { fontSize: '15px', color: '#545454', marginBottom: '20px' },
  btnRow: { display: 'flex', justifyContent: 'center', gap: '10px' },
  yesBtn: {
    background: '#3085d6', color: '#fff', border: 'none',
    padding: '8px 22px', borderRadius: '5px', cursor: 'pointer', fontSize: '14px',
  },
  noBtn: {
    background: '#d33', color: '#fff', border: 'none',
    padding: '8px 22px', borderRadius: '5px', cursor: 'pointer', fontSize: '14px',
  },
};

// ----------------------------------------------------------------------
const AddEditLeadV2Page = (props) => {
  const { id, actionName ,incidentReportId} = useParams();
  const location = useLocation();
  const {
    actions,
    leadsData,
    leadInfo,
    usersData,
    basicLeadInfo,
    sourceData,
    masterProfileData,
    leadChecklistData,
    interactionTypeData,
    leadStatusData,
    getUserModuleData,
    incidentReporteData,
    leadGstByLeadData,
    leadItrByLeadData,
    leadBankStatementByLeadData,
  } = props;
  const [allLeads, setAllLeads] = useState([]);
  const [open, setOpen] = useState(false);
  const [openQue, setOpenQue] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [viewModalInfo, setViewModalInfo] = useState([]);
  const [showLeadDetails, setShowLeadDetails] = useState(false);
  const [leadId, setLeadId] = useState(""); 
  const [allUsers, setAllUsers] = useState([]);
  const [camLatestStatus, setCamLatestStatus] = useState(""); 
  const [deliveryOrderVersioningArr, setDeliveryOrderVersioningArr] = useState([]);
  const [sanctionLetterVersioningArr, setSanctionLetterVersioningArr] = useState([]);
  const [selectionVersioningID, setSelectionVersioningID] = useState([]);
  const [aadharDigiAadhaarError, setAadharDigiAadhaarError] = useState([]);
  const [aadharApiResponse, setAadharApiResponse] = useState({});
  const intervalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [iframeSrc , setIframeSrc]  = useState('');
  const [previousTokenVal , setPreviousTokenVal]  = useState('');
  const [fastTrackCaseStatus , setFastTrackCaseStatus]  = useState(false);
  const [greenChannelCaseStatus , setGreenChannelCaseStatus]  = useState(false);

  const [allIncidentTask, setAllIncidentTask] = useState([]);
  const [overrideRequestFlow, setOverrideRequestFlow] = useState(false);
  const [isEditableIncidentCurrentStatus, setIsEditableIncidentCurrentStatus] = useState(false);
  const [isEditableStatus, setIsEditableStatus] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState("");

  const [getIncidentReportId, setIncidentReportId] = useState('');
  const [showIncidentReporte, setShowIncidentReporte] = useState(false);
  const [incidentCurrentStatus, setIncidentCurrentStatus] = useState("");
  const [incidentCreatedBy, setIncidentCreatedBy] = useState("");
  const [getIncidentReport, setIncidentReport] = useState([]);
  const [getComment, setComment] = useState([]); 
  const [dueDate, setDueDate] = useState("");
  const [allIncidentCheckLists, setAllIncidentCheckLists] = useState([]);
   
  const [phoneNumber, setPhoneNumber] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [priority, setPriority] = useState('');
  const [incidetFiles, setIncidetFiles] = useState([]);
  const [commentCount, setCommentCount] = useState(0);
  const [typeTopic, setTypeTopic] = useState("");

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedAssignedUser, setSelectedAssignedUser] = useState('');
  const [ticketNumber, setTicketNumber] = useState('');
  const [incidentCategory, setincIdentCategory] = useState('');
  const [allchildIds, setAllchildIds] = useState([]);
  const [createdBy, setCreatedBy] = useState('');
  const [description, setDescription] = useState('');
  const [selectedAssignTo, setSelectedAssignTo] = useState([]);
  const [numbersArray, setNumbersArray] = useState([]);
  const [communicationAddress, setCommunicationAddress] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const navigate = useNavigate();

  const [showLeadCommunicationDetails, setShowLeadCommunicationDetails] =
    useState(false);
  const [allSourceData, setAllSource] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [allInteractionTypeData, setAllInteractionTypeData] = useState([]);
  const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allInteractions, setAllInteractions] = useState([]);
  const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
  const [pageHeading, setPageHeading] = useState("");
  const [questions, setQuestions] = useState([]);

  const [addModulePermissionStatus, setAddModulePermissionStatus] =
    useState(false);
  const [editModulePermissionStatus, setEditModulePermissionStatus] =
    useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);

  const [panDetailsInfoName, setPanDetailsInfoName] = useState("");
  const [phoneDetailsInfoName, setPhoneDetailsInfoName] = useState("");
  const [panDetailsInfoDoB, setPanDetailsInfoDoB] = useState("");
  const [panDetailsInfoGender, setPanDetailsInfoGender] = useState("");
  const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState("");
  const [leadPanDetails, setLeadPanDetails] = useState("");
  const [showTicketListDetails, setShowTicketListDetails] = useState(false);
  const [allTicketData, setAllTicketData] = useState([]);

  const [showListDetails, setShowListDetails] = useState(false);
  const [allGroupData, setAllGroupData] = useState([]);
  const [getAllUsersListData, setAllUsersListData] = useState([]);
   const [escalationToUsers, setEscalationToUsers] = useState([]);
  const [markLeadAsFastTrack, setMarkLeadAsFastTrack] = useState([]);
  const [markLeadAsGreenChannel, setMarkLeadAsGreenChannel] = useState([]);
  const [leadFiAddressNotifications, setLeadFiAddressNotifications] = useState([]);
  
  const [allLeadGstByLeadData, setAllLeadGstByLeadData] = useState([]);
  const [allLeadItrByLeadData, setAllLeadItrByLeadData] = useState([]);
  const [allLeadBankStatementByLeadData, setAllLeadBankStatementByLeadData] =
    useState([]);
    const [allLeadBankStatementCount, setAllLeadBankStatementCount] =
    useState(0);
  const [userRoleType, setUserRoleType] = useState("User");
  const [loggeInUserID, setLoggeInUserID] = useState("");
  const [isCrifUser, setIsCrifUser] = useState(true);
  const [isExternalUser, setIsExternalUser] = useState(false);

  // Validation states for PAN and Phone
  const [panDuplicateRecords, setPanDuplicateRecords] = useState([]);
  const [phoneDuplicateRecords, setPhoneDuplicateRecords] = useState([]);
  const [validationLoading, setValidationLoading] = useState(false);

  // Duplicate case state management
  const [isDuplicateEdited, setIsDuplicateEdited ] = useState(false);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [duplicateLeadId, setDuplicateLeadId] = useState(null);
  const [duplicateSectionIdentifier, setDuplicateSectionIdentifier] = useState("");

  const [allStates, setAllStates] = useState([]);
  const [allAddressTypes, setAllAddressTypes] = useState([]);
  const [showNote, setShowNote] = useState("");
  const [showNoteNoteByCredit, setShowNoteNoteByCredit] = useState("");

  const [showSentForCAMPreparationNote, setShowSentForCAMPreparationNote] = useState("");
  const [showSentReviewForDoNote, setShowSentReviewForDoNote] = useState("");

   const [showSentForDONote, setShowSentForDONote] = useState(""); 
   const [showNoteBySentForDO, setShowNoteBySentForDO] = useState("");
               
  const [showNoteBySentForCAMPreparation, setShowNoteBySentForCAMPreparation] = useState("");
   
  const [showHistory, setShowHistory] = useState(false);
  const [allPrefillTemplateNameData, setAllPrefillTemplateNameData] = useState(
    []
  );
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [showActionLeadInfo, setShowActionLeadInfo] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedAssignedGroup, setSelectedAssignedGroup] = useState("");
  const [assignedUser, setAssignedUser] = useState("");

  const [isSentToCredit, setIsSentToCredit] = useState(true);
  const [isSentForDO, setIsSentForDO] = useState('no');

  const [allLeadActivity, setAllLeadActivity] = useState([]);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderStatusPhone, setPreloaderStatusPhone] = useState(false);
  const [actionType, setActionType] = useState("");
  const [activeTabName, setActiveTabName] = useState("basic");
  const [activeTab, setActiveTab] = useState("basic");

  const [allLeadCheckListScore, setAllLeadCheckListScore] = useState([]);
  const [allLeadCheckListDynamicScore, setAllLeadCheckListDynamicScore] =
    useState([]);

  const [creditAllLeadCheckLists, setCreditAllLeadCheckLists] = useState([]);
  const [scoreCard, setScoreCard] = useState("");
  const [allShipment, setAllShipment] = useState([]);
  const [leadStatusFlag, setLeadStatusFlag] = useState(false);
  const [outputBefiscHtml, setOutputBefiscHtml] = useState("");
  const [isExternalUserContent, setIsExternalUserContent] = useState("");
  const [mobileReadOnly, setMobileReadOnly] = useState(false);

  const [allOem, setAllOem] = useState([]);
  const [allOemUsage, setAllOemUsage] = useState([]);

  const [allFiSaveHistory, setAllFiSaveHistory] = useState([]);
  const [allReFISaveHistory, setAllReFISaveHistory] = useState([]);
  const [allReFIReviewdHistory, setAllReFIReviewdHistory] = useState([]);

  // lead Type start
  const [getAllChildsData1, setAllChildsData1] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState("");

  const [preloaderAadharStatus, setPreloaderAadharStatus] = useState(false);
  const [preloaderAadharOTPVerifyStatus, setPreloaderAadharOTPVerifyStatus] =
    useState(false);
  const [aadharVerifiedByName, setAadharVerifiedByName] = useState("");
  const [aadharVerifiedDate, setAadharVerifiedDate] = useState("");
  const [leadAadharDetails, setLeadAadharDetails] = useState("");
  const [skipAadharNumberToSave, setSkipAadharNumberToSave] = useState(true);
  const [aadharVerifiedStatus, setAadharVerifiedStatus] = useState(false);
  const [aadharOTPSentStatus, setAadharOTPSentStatus] = useState("0");
  const [aadharRefid, setAadharRefid] = useState("0");
  const [aadharValidationID, setAadharValidationID] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [isNameStyled, setIsNameStyled] = useState(false);
  const [isDobStyled, setIsDobStyled] = useState(false);
  const [isAddressStyled, setIsAddressStyled] = useState(false);
  const [isCityStyled, setIsCityStyled] = useState(false);
  const [isDistrictStyled, setIsDistrictStyled] = useState(false);
  
  const [isPinStyled, setIsPinStyled] = useState(false);
  const [senttoCreditStatus, setSenttoCreditStatus] = useState(false);
  const [enableCamDetailsStatus, setEnableCamDetailsStatus] = useState(false);
  const [vivritiChecklistStatus, setVivritiChecklistStatus] = useState(false);
  const [reFiChecklistStatus, setReFiChecklistStatus] = useState(false);
  const [allDealers, setAllDealers] = useState([]);
  const [allSubDealers, setAllSubDealers] = useState([]);
  const [filteredSubDealers, setFilteredSubDealers] = useState([]);
  const selectRefDO = useRef(null);
  const selectRefSL = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [aadharDigiVerifiedByName, setAadharDigiVerifiedByName] = useState("");
  const [aadharDigiVerifiedDate, setAadharDigiVerifiedDate] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [isBasicInfoLocked, setIsBasicInfoLocked] = useState(false);
  const filledSourceRef = useRef(''); 
  const aadharPrefillHandledRef = useRef(false);
  const [prefillConfirmModal, setPrefillConfirmModal] = useState({
    open: false,
    source: '',
    pendingData: null,
  });

    const userInfo = useSelector((state) => state.userInfo);

    const roleId = userInfo?.roleIdWithName?.[0]?.role_id;

    console.log('user role id', roleId);
    

  const [leadFieldPermissions, setLeadFieldPermissions] = useState({
    intray: { view: false, add: false, edit: false },
    outtray: { view: false, add: false, edit: false },
    bureau: { view: false, add: false, edit: false },
    send_to_credit: { view: false, add: false, edit: false },
    additional_documents: { view: false, add: false, edit: false },
    fi_upload: { view: false, add: false, edit: false },
    resubmit_to_credit: { view: false, add: false, edit: false },
    sanction_letter: { view: false, add: false, edit: false },
    lead_checklist: { view: false, add: false, edit: false },
    scorecard: { view: false, add: false, edit: false },
    vivriti_checklist: { view: false, add: false, edit: false },
    fi_details: { view: false, add: false, edit: false },
    bank_statement: { view: false, add: false, edit: false },
    cam: { view: false, add: false, edit: false },
    delivery_order: { view: false, add: false, edit: false },
    disbursement_stage: { view: false, add: false, edit: false },
    pdd: { view: false, add: false, edit: false },
    application_details: { view: false, add: false, edit: false },
    case_management: { view: false, add: false, edit: false },
    tasks: { view: false, add: false, edit: false },
    communication: { view: false, add: false, edit: false },
    call_log: { view: false, add: false, edit: false },
    beat_plan: { view: false, add: false, edit: false },
    repayment_schedule: { view: false, add: false, edit: false },
    activity: { view: false, add: false, edit: false },
    send_enach: { view: false, add: false, edit: false },
  });


  


  const loggedInRoleName = userInfo?.roleIdWithName?.[0]?.role_name;

  useEffect(() => {
    if (!roleId) return;

    if (loggedInRoleName !== "Partner Logins") {
      setLeadFieldPermissions({
        intray: { view: true, add: true, edit: true },
        outtray: { view: true, add: true, edit: true },
        bureau: { view: true, add: true, edit: true },
        send_to_credit: { view: true, add: true, edit: true },
        additional_documents: { view: true, add: true, edit: true },
        fi_upload: { view: true, add: true, edit: true },
        resubmit_to_credit: { view: true, add: true, edit: true },
        sanction_letter: { view: true, add: true, edit: true },
        lead_checklist: { view: true, add: true, edit: true },
        scorecard: { view: true, add: true, edit: true },
        vivriti_checklist: { view: true, add: true, edit: true },
        fi_details: { view: true, add: true, edit: true },
        bank_statement: { view: true, add: true, edit: true },
        cam: { view: true, add: true, edit: true },
        delivery_order: { view: true, add: true, edit: true },
        disbursement_stage: { view: true, add: true, edit: true },
        pdd: { view: true, add: true, edit: true },
        application_details: { view: true, add: true, edit: true },
        case_management: { view: true, add: true, edit: true },
        tasks: { view: true, add: true, edit: true },
        communication: { view: true, add: true, edit: true },
        call_log: { view: true, add: true, edit: true },
        beat_plan: { view: true, add: true, edit: true },
        repayment_schedule: { view: true, add: true, edit: true },
        activity: { view: true, add: true, edit: true },
        send_enach: { view: true, add: true, edit: true },
      });
      return;
    }

    fetchLeadPermissions().then((result) => {
      if (result?.success === 1 && result?.data) {
        setLeadFieldPermissions(result.data);
      }
    });
  }, [roleId, loggedInRoleName]);
 
  const handleOutCome = () => {
    const params = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(params);
    const response = actions.leadStatusDataAllDropdown(requestData, false);
    response.then((result) => {
      response
        .then((result) => {
           // console.log("result123", result);
          if (result.data) {
            const results = result.data;
            setAllChildsData1(results);
          }
        })
        .catch((error) => {
          //  console.error("Promise rejected -  source data :", error);
        });
    });
  };

  const removeHighlightedFields = () => {
     setIsNameStyled(false);
     setIsDobStyled(false);
     setIsAddressStyled(false);
     setIsCityStyled(false);
     setIsDistrictStyled(false);
     setIsPinStyled(false);
  };

  const applyPrefillData = (source, data) => {
    removeHighlightedFields();
    setFormValues((prev) => ({
      ...prev,
      ...data,
    }));
    filledSourceRef.current = source;

    if (data.name) setIsNameStyled(true);
    if (data.dob) setIsDobStyled(true);
    if (data.full_address) setIsAddressStyled(true);
    if (data.city) setIsCityStyled(true);
    if (data.district) setIsDistrictStyled(true);
    if (data.pin) setIsPinStyled(true);
  };

  // source = 'aadhar' | 'pan', data = fields to prefill
  const handlePrefillDataFromApi = (source, data) => {
    if (filledSourceRef.current === '' || filledSourceRef.current === source) {
      // pehla API ya same source dobara -> seedha apply
      applyPrefillData(source, data);
    } else {
      // dusra (different) source -> popup se confirm lo
      setPrefillConfirmModal({ open: true, source, pendingData: data });
    }
  };

  const handlePrefillConfirmYes = () => {
    const { source, pendingData } = prefillConfirmModal;
    applyPrefillData(source, pendingData);
    setPrefillConfirmModal({ open: false, source: '', pendingData: null });
  };

  const handlePrefillConfirmNo = () => {
    setPrefillConfirmModal({ open: false, source: '', pendingData: null });
  };

  useEffect(() => {
    handleOutCome();
  }, [setSelectionVersioningID]);

  // lead Type end

  const [formValues, setFormValues] = useState({
    name: "",
    created_by: "",
    status: "",
    phone: "",
    email_id: "",
    dob: "",
    full_address: "",
    city: "",
    district :"",
    state: "",
    pin: "",
    // addressTypeId: "",
    aadhar: "",
    pan: "",
    query: "",
    campaign: "",
    user: "",
    lead_profile: "",
    lead_assigned_group: "",
    prefill_template_name: "",
    oem_usage: "",
    oem: "",
    loan_amount: "",
    AgreementNo:"",
    dealer_name: "",
    lead_type_id: "",
    lead_tenure: "6",
    vehicle_type: "New",
    sub_dealer_name: "",
    aadhar_otp: "",
    dst_name:'',
  });

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getUserModuleData(requestData);
    response
      .then((result) => {
        // console.log("Promise resolved -  lead list:", result);
        if (result.data.success === 1) {
          const permissionsData = result.data.data;
          setPermissions(permissionsData);
          const leadPermissions = permissionsData.find(
            (permission) => permission.module_name === "Leads"
          );
          const hasAddPermissions = leadPermissions?.add_permission;
          const hasEditPermissions = leadPermissions?.edit_permission;

          setAddModulePermissionStatus(hasAddPermissions);
          setEditModulePermissionStatus(hasEditPermissions);
          setUserHasPermission(
            id !== undefined ? hasEditPermissions : hasAddPermissions
          );

          if (
            Object.prototype.hasOwnProperty.call(result.data, "user_info") &&
            Object.prototype.hasOwnProperty.call(
              result.data.user_info[0],
              "role_type"
            ) &&
            result.data.user_info[0].role_type !== ""
          ) {

           // alert(result.data.user_info[0].role_type);
          //  setUserRoleType(result.data.user_info[0].role_type); // commented nnsspp
            // alert(result.data.user_info[0].role_type);
            setLoggeInUserID(result.data.user_info[0].user_id);

            setIsCrifUser(result.data.user_info[0].is_crif_user);
          }

          if (
            Object.prototype.hasOwnProperty.call(result.data, "user_info") &&
            Object.prototype.hasOwnProperty.call(
              result.data.user_info[0],
              "is_external_user"
            ) &&
            result.data.user_info[0].is_external_user !== "" &&
            result.data.user_info[0].is_external_user === "1"
          ) {
            setIsExternalUser(true);
            setActiveTabName("basic");
          }
        }
      })
      .catch((error) => {
        // console.error("Promise rejected -  lead list:", error);
      });

    setSelectedCampaign("");
    setAssignedUser("");
    setSelectedAssignedGroup("");

     const objMasters = { 'start': '0', 'length': config.MAX_RECORDS , module: 'lead_details'};
        const requestDataMasters = encryptData(objMasters);
        const responseMasters = actions.masterAllData(requestDataMasters, false);
        responseMasters.then((result) => {
            // console.log("Promise resolved -  master profile data:", result); 

             if (result.data.success === 1) {
                const results = result.data.data;
                const dealerArrData = results?.all_dealers || [];
                setAllDealers(dealerArrData); 

                const subDealerArrData = results?.all_sub_dealers || [];
                setAllSubDealers(subDealerArrData); 
  
            }
        }).catch((error) => {
           // console.log("000000000000000000000 error  = ",error)
        });
  }, [
    setPermissions,
    setUserHasPermission,
    setSelectedCampaign,
    setAssignedUser,
    setSelectedAssignedGroup,
    setIsExternalUser,
  ]);

  useEffect(() => {
    // check user is logged-in or not
    const authToken = localStorage.getItem("authToken");
    const roleName = localStorage.getItem('authUserRoleName'); 
    if (authToken === null) {
      navigate("/login");
    }
 
     if (roleName !== undefined ) {
          setUserRoleType(roleName);
      } 

    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    actions.usersData(requestData, false);
    if (usersData.success) {
      setAllUsers(usersData.data);
    }
  }, [setUserRoleType]);

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.masterProfileData(requestData, false);
    response
      .then((result) => {
        // console.log("Promise resolved -  master profile data:", result);
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          const filteredResultArr = resultArr.filter(
            (item) => item.status === "1"
          );
          const sortedResultArr = filteredResultArr.sort((a, b) =>
            a.lead_profile_name.localeCompare(b.lead_profile_name)
          );
          setAllMasterProfiles(sortedResultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  source data :", error);
      });

    setAllStates([]);
    // setAllAddressTypes([]);
    const objStates = { start: "0", length: config.MAX_RECORDS };
    const requestDataStates = encryptData(objStates);
    const responseStates = actions.masterStatesData(requestDataStates, false);
    responseStates
      .then((result) => {
        // console.log("Promise resolved -  master profile data:", result);
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          setAllStates(resultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  source data :", error);
      });
       
  }, [setAllMasterProfiles, setAllStates]);

  useEffect(() => {
    setAllLeadStatusData(false);
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.leadStatusData(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved -  lead status data :", result);
        if (result.data.success === 1) {
          setAllLeadStatusData(true);
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          const filteredResultArr = resultArr.filter(
            (item) => item.status === "1"
          );
          const sortedResultArr = filteredResultArr.sort((a, b) =>
            a.lead_status.localeCompare(b.lead_status)
          );
          setAllLeadStatusData(sortedResultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  lead status data :", error);
      });
  }, [setAllLeadStatusData]);

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.sourceData(requestData, false);
    response
      .then((result) => {
        // console.log("Promise resolved -  source data:", result);
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results)
            .filter((key) => results[key].status === "1")
            .map((key) => results[key]);
          setAllSource(resultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  source data :", error);
      });
  }, [setAllSource]);

  useEffect(() => {
    setAllPrefillTemplateNameData(false);
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.masterPrefillTemplateNameData(requestData, false);
    response
      .then((result) => {
        // console.log("Promise resolved -  source data:", result);
        if (result.data.success === 1) {
          setAllPrefillTemplateNameData(true);
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);

          // Filter the data with status 1 and set it in the state
          const filteredData = resultArr.filter((item) => item.status === "1");
          setAllPrefillTemplateNameData(filteredData);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  source data :", error);
      });
  }, [setAllPrefillTemplateNameData]);

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.groupData(requestData, false);
    response
      .then((result) => {
        // console.log("Promise resolved -  groupData list:", result);
        if (result.data.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          const filteredResultArr = resultArr.filter(
            (item) => item.status === "1"
          );
          const sortedResultArr = filteredResultArr.sort((a, b) =>
            a.group_name.localeCompare(b.group_name)
          );
          setAllGroupData(sortedResultArr);
        }
      })
      .catch((error) => {
        console.error("Promise rejected -  lead list:", error);
      });
  }, [setAllGroupData]);

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.campaignData(requestData, false);
    response
      .then((result) => {
        //   console.log("Promise resolved -  campaignData:", result);
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          const filteredResultArr = resultArr.filter(
            (item) => item.status === "1"
          );
          const sortedResultArr = filteredResultArr.sort((a, b) =>
            a.campaign_name.localeCompare(b.campaign_name)
          );
          setAllCampaigns(sortedResultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  campaignData :", error);
      });
  }, [setAllCampaigns]);

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getOem(requestData, false);
    response
      .then((result) => {
        //   console.log("Promise resolved -  campaignData:", result);
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          const filteredResultArr = resultArr.filter(
            (item) => item.status === "1"
          );
          const sortedResultArr = filteredResultArr.sort((a, b) =>
            a.oem_name.localeCompare(b.oem_name)
          );
          setAllOem(sortedResultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  campaignData :", error);
      });
  }, [setAllOem]);

  useEffect(() => {
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    const response = actions.getOemUsage(requestData, false);
    response
      .then((result) => {
        //   console.log("Promise resolved -  campaignData:", result);
        if (result.data.success === 1) {
          const results = result.data.data.data;
          const resultArr = Object.keys(results).map((key) => results[key]);
          const filteredResultArr = resultArr.filter(
            (item) => item.status === "1"
          );
          const sortedResultArr = filteredResultArr.sort((a, b) =>
            a.oem_usage_name.localeCompare(b.oem_usage_name)
          );
          setAllOemUsage(sortedResultArr);
        }
      })
      .catch((error) => {
        //  console.error("Promise rejected -  campaignData :", error);
      });
  }, [setAllOemUsage]);

  useEffect(() => {
    // setAllInteractionTypeData(false);
    const obj = { start: "0", length: config.MAX_RECORDS };
    const requestData = encryptData(obj);
    actions.interactionTypeData(requestData, false);
    if (interactionTypeData.success) {
      // setAllInteractionTypeData(true);
      setAllInteractionTypeData(interactionTypeData.data);
    }
  }, []);

  const updateParentState = (newValue) => {
    // console.log("updateParentState = ", newValue);
    setShowLeadDetails(newValue);

    if (id !== undefined && !newValue) {
      const decodedId = atob(id);
      setLeadId(decodedId);
      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
      };
      const requestDataUpdateParentState = encryptData(obj);

      const responseParentState = actions.leadInfo(
        requestDataUpdateParentState,
        false
      );
      responseParentState
        .then((result) => {
          // console.log("Promise resolved -  master profile data:", result);
          if (result.data.success === 1) {
            const leadInfoResult = result.data.data;
           
            if (leadInfoResult.data.length > 0) {
              setShowLeadDetails(true);
              newValue = true;

              setFastTrackCaseStatus(leadInfoResult.data[0]?.fast_track_status === '1');
              setGreenChannelCaseStatus(leadInfoResult.data[0]?.green_channel_status === '1');

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "statusName"
                )
              ) {
                const statusName = leadInfoResult.data[0].statusName;
                setVivritiChecklistStatus(leadInfoResult.data[0]?.vivriti_checklist_status ==='1');

                let ReFIStstus = false;
                if(leadInfoResult.data[0]?.re_fi_checklist_status){
                    ReFIStstus = true;
                } 
                setReFiChecklistStatus(ReFIStstus);
                 if (statusName === "CLOSED") {
                  setLeadStatusFlag(true);
                } else {
                  setLeadStatusFlag(false);
                }
              }

              let panNumber = "";
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "pancard_number"
                ) &&
                leadInfoResult.data[0].pan_number !== "" &&
                leadInfoResult.data[0].pancard_number !== null
              ) {
                panNumber = leadInfoResult.data[0].pancard_number.replace(
                  /"/g,
                  ""
                );
              }

              let adharNumber = "";
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "adhar_number"
                ) &&
                leadInfoResult.data[0].adhar_number !== "" &&
                leadInfoResult.data[0].adhar_number !== null
              ) {
                adharNumber = leadInfoResult.data[0].adhar_number.replace(
                  /"/g,
                  ""
                );
              }

              const initialFormValues = {
                name: leadInfoResult.data[0].name,
                created_by: leadInfoResult.data[0].created_by,
                status: leadInfoResult.data[0].status,
                phone: leadInfoResult.data[0].mobile,
                email_id: leadInfoResult.data[0].email,
                dob: leadInfoResult.data[0].dob,
                full_address: leadInfoResult.data[0].full_address,
                city: leadInfoResult.data[0].city,
                district: leadInfoResult.data[0].district,
                state: leadInfoResult.data[0].state,
                pin: leadInfoResult.data[0].pin,
                aadhar: adharNumber,
                pan: panNumber,
                query: leadInfoResult.data[0].lead_query,
                campaign: leadInfoResult.data[0].campaign,
                // user: leadInfoResult.data[0].lead_assigned,
                lead_profile: leadInfoResult.data[0].lead_profile,
                lead_assigned_group: leadInfoResult.data[0].lead_assigned_group,
                prefill_template_name:
                  leadInfoResult.data[0].prefill_template_name,
                oem_usage: leadInfoResult.data[0].oem_usage,
                oem: leadInfoResult.data[0].oem,
                loan_amount: leadInfoResult.data[0].loan_amount,
                AgreementNo: leadInfoResult.data[0].AgreementNo,
                dealer_name: leadInfoResult.data[0].dealer_name,
                lead_type_id: leadInfoResult.data[0].lead_type_id,
                lead_tenure: leadInfoResult.data[0].lead_tenure,
                vehicle_type: leadInfoResult.data[0].vehicle_type,
                sub_dealer_name: leadInfoResult.data[0].sub_dealer_name,
                dst_name: leadInfoResult.data[0].dst_name,
              };
              
              setIsDuplicateEdited(leadInfoResult.data[0].is_duplicate === "1");  
              setFormValues(initialFormValues);

              // get lead assigned checklists
              const checkListsResults = leadInfoResult.data[0].all_checklists;
              const checkListsResultsArr = Object.keys(checkListsResults).map(
                (key) => checkListsResults[key]
              );
              setAllLeadCheckLists(checkListsResultsArr);

              const creditCheckListsResults =
                leadInfoResult.data[0].credit_all_checklists;
              const creditCheckListsResultsArr = Object.keys(
                creditCheckListsResults
              ).map((key) => creditCheckListsResults[key]);
              setCreditAllLeadCheckLists(creditCheckListsResultsArr);

              const leadScoreResults = leadInfoResult.data[0].lead_score;
              setAllLeadCheckListScore(leadScoreResults);

              const leadDynamicScoreResults =
                leadInfoResult.data[0].lead_dynamic_score;
              setAllLeadCheckListDynamicScore(leadDynamicScoreResults);

              const fiSaveHistory = leadInfoResult.data[0].fiSaveHistory || [];
              setAllFiSaveHistory(fiSaveHistory);

              setCommunicationAddress(leadInfoResult.data[0]?.fi_communication_address || "");

              const fReFIResultArr = fiSaveHistory.filter(
                  (item) => item.actual_checklist_id === "33"
                );
              setAllReFISaveHistory(fReFIResultArr);

              setAllReFIReviewdHistory(leadInfoResult.data[0].ReFIReviewSaveHistory || []);
              

              const leadActivityResults = leadInfoResult.data[0].lead_activity;
              setAllLeadActivity(leadActivityResults);

              const shipmentResults = leadInfoResult.data[0].shipment;
              setAllShipment(shipmentResults);

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "aadhar_otp_sent_status"
                )
              ) {
                setAadharOTPSentStatus(
                  leadInfoResult.data[0].aadhar_otp_sent_status
                );
                setAadharVerifiedStatus(false);
                if (leadInfoResult.data[0].aadhar_otp_sent_status === "2") {
                  setAadharVerifiedStatus(true);
                  setSkipAadharNumberToSave(false);

                  const aadharVerifiedBy =
                    leadInfoResult.data[0]?.aadhar_verified_by;
                  if (aadharVerifiedBy !== "") {
                    setAadharVerifiedByName(aadharVerifiedBy);
                  }
                  const aadharVerifiedOn =
                    leadInfoResult.data[0]?.aadhar_verified_on;
                  if (aadharVerifiedOn !== "") {
                    setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
                  }

                    if (aadharVerifiedBy !== "") {
                      setAadharDigiVerifiedByName(aadharVerifiedBy);
                    } 
                     if (aadharVerifiedOn !== "") {
                      setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                    }

                }   
                 
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "credit_user_answered"
                )
              ) {
                setScoreCard(leadInfoResult.data[0].credit_user_answered);
              }

              setPageHeading(
                `${leadInfoResult.data[0].name} - ${leadInfoResult.data[0].mobile}`
              );

              handleCampaign({
                target: { value: leadInfoResult.data[0].campaign },
              });
              setSelectedCampaign(leadInfoResult.data[0].campaign);

              handleChangeAssignedGroup({
                target: { value: leadInfoResult.data[0].lead_assigned_group },
              });
              setSelectedAssignedGroup(
                leadInfoResult.data[0].lead_assigned_group
              );

              handleAssignedUser({
                target: { value: leadInfoResult.data[0].lead_assigned },
              });
              setAssignedUser(leadInfoResult.data[0].lead_assigned);

              //  alert('karza = 2');
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "pan_details_decrypt"
                ) &&
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0].pan_details_decrypt,
                  "address"
                )
              ) {
                const panDetailsAddress = `${leadInfoResult.data[0].pan_details_decrypt.address.buildingName} ${leadInfoResult.data[0].pan_details_decrypt.address.city} ${leadInfoResult.data[0].pan_details_decrypt.address.country} ${leadInfoResult.data[0].pan_details_decrypt.address.streetName} ${leadInfoResult.data[0].pan_details_decrypt.address.state} ${leadInfoResult.data[0].pan_details_decrypt.address.pinCode}`;

                setPanDetailsInfoName(
                  leadInfoResult.data[0].pan_details_decrypt.name
                );
                setPanDetailsInfoDoB(
                  leadInfoResult.data[0].pan_details_decrypt.dob
                );
                setPanDetailsInfoGender(
                  leadInfoResult.data[0].pan_details_decrypt.gender
                );
                setPanDetailsInfoAddress(panDetailsAddress);

                setLeadPanDetails(leadInfoResult.data[0].pan_details_decrypt);
              }

              setMobileReadOnly(false);

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoResult.data[0],
                  "crif_info"
                ) &&
                leadInfoResult.data[0].crif_info !== ""
              ) {
                const crifInfoRemark =
                  leadInfoResult.data[0].crif_info.crif_remarks;
                if (Number(leadInfoResult.data[0]?.crif_info?.crif_status) === 1) {                  
                  setMobileReadOnly(true);
                } else {
                  setMobileReadOnly(false);
                }
              }

              if (leadInfoResult.data[0]?.versioning?.sanction_letter_versioning?.length > 0) {
                setSanctionLetterVersioningArr(leadInfoResult.data[0].versioning.sanction_letter_versioning );
              }
              
              if (leadInfoResult.data[0]?.versioning?.delivery_order_versioning?.length > 0 ) {
                setDeliveryOrderVersioningArr(leadInfoResult.data[0].versioning.delivery_order_versioning);
              }

            }
          }
        })
        .catch((error) => {
          //  console.error("Promise rejected -  source data :", error);
        });
    }
  };

  const fetchLeads = useCallback((scorecardIdentifier='') => {
    setShowLeadDetails(false);

    setShowNoteNoteByCredit("");
    setShowNote("");
    setShowSentForCAMPreparationNote("");
    setShowSentReviewForDoNote("");
    setShowSentForDONote("");
    setEscalationToUsers([]);
    setMarkLeadAsFastTrack([]);
    setMarkLeadAsGreenChannel([]);
    setLeadFiAddressNotifications([]);

    // console.log("fetchLeads calling ", id, showLeadDetails);
    if (id !== undefined && !showLeadDetails) {
      const decodedId = atob(id);
      setLeadId(decodedId);

      if (decodedId !== "") {
        setActiveTabName("basic");
        if (actionName !== undefined) {
          setActiveTabName("basic");
        }
      }

      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
        "scorecardIdentifier" : scorecardIdentifier
      };
      const requestData = encryptData(obj);
      const response = actions.leadInfo(requestData, false);
      response
        .then((result) => {
          // console.log("Promise resolved -  leadInfo:", result);
          if (result.data.success === 1) {
            const leadInfoData = result.data.data;
            setMobileReadOnly(false);
            if ("data" in leadInfoData && leadInfoData.data.length > 0) {
              setShowLeadDetails(true); 
              
              setFastTrackCaseStatus(leadInfoData.data[0]?.fast_track_status === '1');
              setGreenChannelCaseStatus(leadInfoData.data[0]?.green_channel_status === '1');

              setVivritiChecklistStatus(leadInfoData.data[0]?.vivriti_checklist_status ==='1');

              setEscalationToUsers(leadInfoData.data[0]?.escalationToUsers || []); 

              setMarkLeadAsFastTrack(leadInfoData.data[0]?.markLeadAsFastTrack || []);
              setMarkLeadAsGreenChannel(leadInfoData.data[0]?.markLeadAsGreenChannel || []);
              setLeadFiAddressNotifications(leadInfoData.data[0]?.leadFiAddressNotifications || []);
 
              let ReFIStstus = false;
              if(leadInfoData.data[0]?.re_fi_checklist_status){
                   ReFIStstus = true;
              } 

              setReFiChecklistStatus(ReFIStstus);
              let BefiscHtml = "";
              let BefiscStatus = "";

              if (Object.prototype.hasOwnProperty.call(leadInfoData.data[0],"camLatestStatus") &&
                leadInfoData.data[0].camLatestStatus !== "") {
                    setCamLatestStatus(leadInfoData.data[0].camLatestStatus);
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "crif_info"
                ) &&
                leadInfoData.data[0].crif_info !== ""
              ) {
                const crifInfoRemark =
                  leadInfoData.data[0].crif_info.crif_remarks;

                 if (Number(leadInfoData.data[0]?.crif_info?.crif_status) === 1) {
                   setMobileReadOnly(true);
                } else {
                   setMobileReadOnly(false);
                }
              }
 
              if (leadInfoData.data[0]?.versioning?.sanction_letter_versioning?.length > 0) {
                setSanctionLetterVersioningArr(leadInfoData.data[0].versioning.sanction_letter_versioning );
              }
              
              if (leadInfoData.data[0]?.versioning?.delivery_order_versioning?.length > 0 ) {
                setDeliveryOrderVersioningArr(leadInfoData.data[0].versioning.delivery_order_versioning);
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "befiscApiRunStatus"
                ) &&
                leadInfoData.data[0].befiscApiRunStatus
              ) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0],
                    "mobileage_response"
                  )
                ) {
                  const mobileageObj = leadInfoData.data[0].mobileage_response;

                  if (mobileageObj.length === 0) {
                    BefiscHtml += `<span class="text-danger">Phone Number Age not found.</span>`;
                  } else if (
                    Object.prototype.hasOwnProperty.call(
                      mobileageObj,
                      "result"
                    ) &&
                    Object.prototype.hasOwnProperty.call(
                      mobileageObj.result,
                      "mobile_age"
                    )
                  ) {
                    BefiscHtml += `<div>Mobile Age : ${mobileageObj.result.mobile_age}</div>`;
                    BefiscStatus = "true";
                  }
                }

                if (
                  Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0],
                    "multiple_upi_response"
                  )
                ) {
                  const upiObj = leadInfoData.data[0].multiple_upi_response;

                  if (upiObj.length === 0) {
                    BefiscHtml += `<span class="text-danger">UPI Handle not found.</span>`;
                  } else {
                    if (
                      Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                      Object.prototype.hasOwnProperty.call(
                        upiObj.result,
                        "name"
                      )
                    ) {
                      BefiscHtml += `<div>Name : ${upiObj.result.name}</div>`;
                      BefiscStatus = "true";
                    }

                    if (
                      Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                      Object.prototype.hasOwnProperty.call(
                        upiObj.result,
                        "upi"
                      ) &&
                      Array.isArray(upiObj.result.upi)
                    ) {
                      BefiscHtml += `<div>UPIs : ${upiObj.result.upi.join(
                        ", "
                      )}</div>`;
                      BefiscStatus = "true";
                    }
                  }
                }
              } else {
                BefiscHtml += `<span class="text-danger">UPI Handle and Phone Number API not run.</span><span>Please click the <b>'Get Phone Number Age + UPI Handle'</b> button.</span> `;
              }
              setOutputBefiscHtml(BefiscHtml);
              setPhoneDetailsInfoName(BefiscStatus);

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "statusName"
                )
              ) {
                const statusName = leadInfoData.data[0].statusName;

                if (statusName === "CLOSED") {
                  setLeadStatusFlag(true);
                } else {
                  setLeadStatusFlag(false);
                }
              }

              let panNumber = "";
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "pancard_number"
                ) &&
                leadInfoData.data[0].pan_number !== "" &&
                leadInfoData.data[0].pancard_number !== null
              ) {
                panNumber = leadInfoData.data[0].pancard_number.replace(
                  /"/g,
                  ""
                );
              }

              let adharNumber = "";
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "adhar_number"
                ) &&
                leadInfoData.data[0].adhar_number !== "" &&
                leadInfoData.data[0].adhar_number !== null
              ) {
                adharNumber = leadInfoData.data[0].adhar_number.replace(
                  /"/g,
                  ""
                );
              }

              const initialFormValues = {
                name: leadInfoData.data[0].name,
                created_by: leadInfoData.data[0].created_by,
                status: leadInfoData.data[0].status,
                phone: leadInfoData.data[0].mobile,
                email_id: leadInfoData.data[0].email,
                dob: leadInfoData.data[0].dob,
                full_address: leadInfoData.data[0].full_address,
                city: leadInfoData.data[0].city,
                district: leadInfoData.data[0].district,
                state: leadInfoData.data[0].state,
                pin: leadInfoData.data[0].pin,
                aadhar: adharNumber,
                pan: panNumber,
                query: leadInfoData.data[0].lead_query,
                // campaign: leadInfoData.data[0].campaign,
                // user: leadInfoData.data[0].lead_assigned,
                lead_profile: leadInfoData.data[0].lead_profile,
                // lead_assigned_group: leadInfoData.data[0].lead_assigned_group,
                prefill_template_name:
                  leadInfoData.data[0].prefill_template_name,
                oem_usage: leadInfoData.data[0].oem_usage,
                oem: leadInfoData.data[0].oem,
                loan_amount: leadInfoData.data[0].loan_amount,
                AgreementNo: leadInfoData.data[0].AgreementNo,
                dealer_name: leadInfoData.data[0].dealer_name,
                lead_type_id: leadInfoData.data[0].lead_type_id,
                lead_tenure: leadInfoData.data[0].lead_tenure,
                vehicle_type: leadInfoData.data[0].vehicle_type,
                sub_dealer_name: leadInfoData.data[0].sub_dealer_name,
                dst_name: leadInfoData.data[0].dst_name,
              };

              setIsDuplicateEdited(leadInfoData.data[0].is_duplicate === "1");
              setFormValues(initialFormValues);
 
              // alert('karza = 3');
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "pan_details_decrypt"
                ) &&
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0].pan_details_decrypt,
                  "address"
                )
              ) {
                const panDetailsAddress = `${leadInfoData.data[0].pan_details_decrypt.address.buildingName} ${leadInfoData.data[0].pan_details_decrypt.address.city} ${leadInfoData.data[0].pan_details_decrypt.address.country} ${leadInfoData.data[0].pan_details_decrypt.address.streetName} ${leadInfoData.data[0].pan_details_decrypt.address.state} ${leadInfoData.data[0].pan_details_decrypt.address.pinCode}`;

                setPanDetailsInfoName(
                  leadInfoData.data[0].pan_details_decrypt.name
                );
                setPanDetailsInfoDoB(
                  leadInfoData.data[0].pan_details_decrypt.dob
                );
                setPanDetailsInfoGender(
                  leadInfoData.data[0].pan_details_decrypt.gender
                );
                setPanDetailsInfoAddress(panDetailsAddress);

                setLeadPanDetails(leadInfoData.data[0].pan_details_decrypt);
              }

              // get lead assigned checklists
              const results = leadInfoData.data[0].all_checklists;
              const resultChecklistArr = Object.keys(results).map(
                (key) => results[key]
              );
              setAllLeadCheckLists(resultChecklistArr);

              const creditCheckListsResults =
                leadInfoData.data[0].credit_all_checklists;
              const creditCheckListsResultsArr = Object.keys(
                creditCheckListsResults
              ).map((key) => creditCheckListsResults[key]);
              setCreditAllLeadCheckLists(creditCheckListsResultsArr);

              const leadScoreResults = leadInfoData.data[0].lead_score;
              setAllLeadCheckListScore(leadScoreResults);

              const leadDynamicScoreResults =
                leadInfoData.data[0].lead_dynamic_score;
              setAllLeadCheckListDynamicScore(leadDynamicScoreResults);

              const fiSaveHistory = leadInfoData.data[0].fiSaveHistory || [];
              setAllFiSaveHistory(fiSaveHistory);

              setCommunicationAddress(leadInfoData.data[0]?.fi_communication_address || "");

              const fReFIResultArr = fiSaveHistory.filter(
                  (item) => item.actual_checklist_id === "33"
                );
              setAllReFISaveHistory(fReFIResultArr);

              setAllReFIReviewdHistory(leadInfoData.data[0].ReFIReviewSaveHistory || []);

              const leadActivityResults = leadInfoData.data[0].lead_activity;
              setAllLeadActivity(leadActivityResults);

              const shipmentResults = leadInfoData.data[0].shipment;
              setAllShipment(shipmentResults);

              setPageHeading(
                `${leadInfoData.data[0].name} - ${leadInfoData.data[0].mobile}`
              );

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "_isSentToCredit"
                )
              ) {
                setIsSentToCredit(leadInfoData.data[0]._isSentToCredit === "1");
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "sentForDOStatus"
                )
              ) {
                setIsSentForDO(leadInfoData.data[0].sentForDOStatus);
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "aadhar_otp_sent_status"
                )
              ) {
                setAadharOTPSentStatus(
                  leadInfoData.data[0].aadhar_otp_sent_status
                );
                if (leadInfoData.data[0].aadhar_otp_sent_status === "2") {
                  setAadharVerifiedStatus(true);
                  setSkipAadharNumberToSave(false);

                  const aadharVerifiedBy =
                    leadInfoData.data[0]?.aadhar_verified_by;
                  if (aadharVerifiedBy !== "") {
                    setAadharVerifiedByName(aadharVerifiedBy);
                  }
                  const aadharVerifiedOn =
                    leadInfoData.data[0]?.aadhar_verified_on;
                  if (aadharVerifiedOn !== "") {
                    setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
                  }

                  if (aadharVerifiedBy !== "") {
                    setAadharDigiVerifiedByName(aadharVerifiedBy);
                  } 
                    if (aadharVerifiedOn !== "") {
                    setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                  }
                }
              }

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "credit_user_answered"
                )
              ) {
                setScoreCard(leadInfoData.data[0].credit_user_answered);
              }

              handleCampaign({
                target: { value: leadInfoData.data[0].campaign },
              });
              setSelectedCampaign(leadInfoData.data[0].campaign);

              handleChangeAssignedGroup({
                target: { value: leadInfoData.data[0].lead_assigned_group },
              });
              setSelectedAssignedGroup(
                leadInfoData.data[0].lead_assigned_group
              );

              handleAssignedUser({
                target: { value: leadInfoData.data[0].lead_assigned },
              });
              setAssignedUser(leadInfoData.data[0].lead_assigned);

              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "lead_credit"
                )
              ) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0].lead_credit,
                    "created_date"
                  ) &&
                  leadInfoData.data[0].lead_credit.created_date
                ) {
                  const note = `Sent to Credit On ${leadInfoData.data[0].lead_credit.created_date} `;
                  setShowNote(note);
                  setShowNoteNoteByCredit("");
                  setShowActionLeadInfo(true);
                }

                if (
                  Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0].lead_credit,
                    "noteAddDate"
                  ) &&
                  leadInfoData.data[0].lead_credit.noteAddDate
                ) {
                  const noteByCredit = `Note added by Credit On ${leadInfoData.data[0].lead_credit.noteAddDate} `;
                  setShowNoteNoteByCredit(noteByCredit);
                  setShowNote("");
                  setShowActionLeadInfo(true);
                }
              }


              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "sentForCamPreparationInfo"
                )
              ) {
               
                if ( leadInfoData.data[0]?.sentForCamPreparationInfo !== null && 
                  Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0].sentForCamPreparationInfo,
                    "created_date"
                  ) &&
                  leadInfoData.data[0].sentForCamPreparationInfo.created_date
                ) {
                  const note = `Sent for CAM preparation to User On ${leadInfoData.data[0].sentForCamPreparationInfo.created_date} `;
                  setShowSentForCAMPreparationNote(note);
                  setShowNoteBySentForCAMPreparation("");
                  
                } 
              }
 
               if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "reviewForDoInfo"
                )
              ) {
                
                if ( leadInfoData.data[0]?.reviewForDoInfo !== null &&   Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0]?.reviewForDoInfo,
                    "created_date"
                  ) &&
                  leadInfoData.data[0]?.reviewForDoInfo?.created_date
                ) {
                  const note = `Sent Review For DO to User On ${leadInfoData.data[0]?.reviewForDoInfo?.created_date} `;
                  setShowSentReviewForDoNote(note);
                  
                } 
              }
 
            
              if (
                Object.prototype.hasOwnProperty.call(
                  leadInfoData.data[0],
                  "sentForDOInfo"
                )
              ) {
               
                if ( leadInfoData.data[0]?.sentForDOInfo !== null && 
                  Object.prototype.hasOwnProperty.call(
                    leadInfoData.data[0]?.sentForDOInfo,
                    "created_date"
                  ) &&
                  leadInfoData.data[0]?.sentForDOInfo?.created_date
                ) {
                  
                  const note = `Sent for DO On ${leadInfoData.data[0].sentForDOInfo.created_date} `;
                  setShowSentForDONote(note);
                  setShowNoteBySentForDO("");
                  
                }  
              }

              
            }
          }
        })
        .catch((error) => {
          // console.error("Promise rejected -  leadInfo :", error);
        });
    }
 
    if (id === undefined) {
      const initialFormValues = {
        name: "",
        created_by: "",
        status: "",
        phone: "",
        email_id: "",
        dob: "",
        full_address: "",
        city: "",
        district: "",
        state: "",
        pin: "",
        aadhar: "",
        pan: "",
        query: "",
        campaign: "",
        user: "",
        lead_profile: "",
        lead_assigned_group: "",
        prefill_template_name: "",
        oem_usage: "",
        oem: "",
        loan_amount: "",
        AgreementNo:"",
        dealer_name: "",
        lead_type_id: "",
        lead_tenure: "",
        vehicle_type: "New",
        sub_dealer_name: "",
        dst_name:'',
      };

      setIsDuplicateEdited(false);
      setFormValues(initialFormValues);

      setShowLeadDetails(false);
      setAllLeadCheckLists([]);
      setCreditAllLeadCheckLists([]);
      setAllLeadCheckListScore([]);
      setAllLeadCheckListDynamicScore([]);
      setPageHeading("Add Lead");
      setLeadId("");
      setAllInteractions([]);
      $("#pills-basic-info-tab").click();
      setPanDetailsInfoName("");
      setPanDetailsInfoDoB("");
      setPanDetailsInfoGender("");
      setPanDetailsInfoAddress("");
      setLeadPanDetails("");
      setShowNote("");
      setShowSentForCAMPreparationNote("");
      setShowSentForDONote("");
      
      setShowSentReviewForDoNote("");
      setSelectedCampaign("");
      setSelectedAssignedGroup("");
      setAssignedUser("");
      setActiveTabName("basic");
      setLeadStatusFlag(false);
      setOutputBefiscHtml("");
      setMobileReadOnly(false);
      setAllFiSaveHistory([]);
    }
  }, [
    id,
    setValue,
    setShowLeadDetails,
    setAllLeadCheckLists,
    setPageHeading,
    setSelectedCampaign,
    setSelectedAssignedGroup,
    setAssignedUser,
    setAllLeadActivity,
    setAllLeadCheckListScore,
    setAllLeadCheckListDynamicScore,
    setActiveTabName,
    setCreditAllLeadCheckLists,
    setAllShipment,
    setLeadStatusFlag,
    setOutputBefiscHtml,
    setMobileReadOnly,
    setAllFiSaveHistory,
  ]);


   const onRowClickActionWL = (itemObj, btnAction) => {
        console.log("itemObj = ", itemObj);

        if (userRoleType === "Credit") {
          //  setQuestions(itemObj.credit_questions_data_decoded);
            setQuestions(itemObj.questions_data_decoded);
        } else {
            setQuestions(itemObj.questions_data_decoded);
        }
        setViewModalInfo(itemObj);
        setOpen(true);
    };

    
  const fetchInteractions = useCallback(() => {
    setShowLeadCommunicationDetails(false);
    if (id !== undefined && !showTicketListDetails) {
      const decodedId = atob(id);
      setLeadId(decodedId);
      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
      };
      const requestData = encryptData(obj);
      const response = actions.leadCommunicationInfo(requestData, false);

      response
        .then((result) => { 
          // console.log("Promise resolved:", result);
          if ("data" in result.data) {
            setAllInteractions(result.data.data);

            const  allCommunications =  result.data.data;
           
            // console.log("allCommunications = ",allCommunications);
           
            let sentToCredit = false;
            if (Array.isArray(allCommunications) && allCommunications.length > 0) {
               sentToCredit = allCommunications.some(record => record.lead_status === 'Sent to Credit');
              setSenttoCreditStatus(sentToCredit); 
             // alert('true');
          } else {
              setSenttoCreditStatus(false);  
            //  alert('false');
          }

           // console.log("sentToCredit = ",sentToCredit);

          //  alert(sentToCredit)
               
          }
        })
        .catch((error) => {
          setAllInteractions([]);
          // console.error("Promise rejected:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    }
  }, [id, setAllInteractions,setSenttoCreditStatus]);

  const fetchIncidentReporte = useCallback(() => {
    setShowTicketListDetails(false);
    if (id !== undefined && !showLeadDetails) {
      const decodedId = atob(id);
      setLeadId(decodedId);

      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
      };
      const requestData = encryptData(obj);

      const response = actions.incidentReporteData(requestData, false);
      response
        .then((result) => {
          // console.log("Promise resolved -  incidentReporteData list:", result);
          if (result.data.success === 1) {
            const incidentReporte = result.data.data.data;
            // console.log("incidentReporte = ", incidentReporte);
            setAllTicketData(incidentReporte);
            setShowTicketListDetails(true);
          }
        })
        .catch((error) => {
          console.error("Promise rejected -  incidentReporteData list:", error);
        });
    }
  }, [id, setShowTicketListDetails, setAllTicketData]);

  const fetchLeadIdGst = useCallback(() => {
    if (id !== undefined) {
      const decodedId = atob(id);
      setLeadId(decodedId);

      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
      };
      const requestData = encryptData(obj);

      const response = actions.leadGstByLeadData(requestData, false);
      response
        .then((result) => {
          // console.log("Promise resolved -  leadGstByLeadData list:", result);
          if (result.data.success === 1) {
            const incidentReporte = result.data.data.data;
            // console.log("incidentReporte = ", incidentReporte);
            setAllLeadGstByLeadData(incidentReporte);
          }
        })
        .catch((error) => {
          console.error("Promise rejected -  leadGstByLeadData list:", error);
        });
    }
  }, [id, setAllLeadGstByLeadData]);

  const fetchLeadIdItr = useCallback(() => {
    if (id !== undefined) {
      const decodedId = atob(id);
      setLeadId(decodedId);

      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
      };
      const requestData = encryptData(obj);

      const response = actions.leadItrByLeadData(requestData, false);
      response
        .then((result) => {
          // console.log("Promise resolved -  leadItrByLeadData list:", result);
          if (result.data.success === 1) {
            const leadItrByLeadRes = result.data.data.data;
            setAllLeadItrByLeadData(leadItrByLeadRes);
          }
        })
        .catch((error) => {
          console.error("Promise rejected -  leadItrByLeadData list:", error);
        });
    }
  }, [id, setAllLeadItrByLeadData]);

  const fetchLeadIdBankStatement = useCallback(() => {
    if (id !== undefined) {
      const decodedId = atob(id);
      setLeadId(decodedId);

      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        lead_id: decodedId,
      };
      const requestData = encryptData(obj);

      const response = actions.leadBankStatementByLeadData(requestData, false);
      response
        .then((result) => {
          // console.log("Promise resolved -  leadBankStatementByLeadData list:", result);
          if (result.data.success === 1) { 
            if(result?.data?.data?.data){
               const leadBankStatementByLeadRes = result.data.data.data;
              setAllLeadBankStatementByLeadData(leadBankStatementByLeadRes);
              setAllLeadBankStatementCount(leadBankStatementByLeadRes.length)
            }  
          }
        })
        .catch((error) => {
          console.error(
            "Promise rejected -  leadBankStatementByLeadData list:",
            error
          );
        });
    }
  }, [id, setAllLeadBankStatementByLeadData,setAllLeadBankStatementCount]);

  const checkBasicInfoLockStatus = async () => {

    if (id !== undefined) {

        try {

            const decodedId = atob(id);

            const obj = {
                lead_id: decodedId
            };

            const requestData = encryptData(obj);

            const response = await actions.checkBasicInfoLock(
                requestData,
                false
            );

            if (
                response?.data?.success === 1 &&
                response?.data?.is_locked === true
            ) {

                setIsBasicInfoLocked(true);

            } else {

                setIsBasicInfoLocked(false);
            }

        } catch (error) {

            console.log(error);
        }
    }
};

useEffect(() => {

    checkBasicInfoLockStatus();

}, [id]);

  useEffect(() => {
    fetchInteractions();
    fetchLeads();
    fetchIncidentReporte();
    fetchLeadIdGst();
    fetchLeadIdItr();
    fetchLeadIdBankStatement();
  }, [
    fetchInteractions,
    fetchLeads,
    questions,
    fetchIncidentReporte,
    fetchLeadIdGst,
    fetchLeadIdItr,
    fetchLeadIdBankStatement,
  ]);

  const fetchScoreCardDetails = (scorecardIdentifier='') => {
     fetchLeads(scorecardIdentifier);
  }

  
  const handleSubmitBasicInfo = (data) => {

    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
               position: "top-right",
          });
          return;
    }


   // console.log("COse", data);
    const pinCode = formValues.pin;
    const fullAddress = formValues.full_address;
    const leadProfile = formValues.lead_profile;
    const districtCode = formValues.district;

    // if (!/^\d{10}$/.test(formValues.phone)) {
    //     toast.error('Invalid mobile number.', {
    //         position: "top-right",
    //     });
    //     return;
    // }

   /* if (!aadharVerifiedStatus) {
      toast.error("Please enter and verify the Aadhar Card Number.", {
        position: "top-right",
      });
      return;
    } */
 
    if(formValues.pan !== ''){
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (!panRegex.test(formValues.pan.toUpperCase())) {
        
          toast.error('Invalid PAN number. Please enter a valid alphanumeric PAN (e.g., ABCDE1234F).', {
            position: "top-right",
          });
          return;
      }  
    }

    if (!pinCode) {
      toast.error("Pincode cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!/^\d{6}$/.test(pinCode)) {
      toast.error("Pincode must be a 6-digit number.", {
        position: "top-right",
      });
      return;
    }

    if (!fullAddress) {
      toast.error("Address can not be blank.", {
        position: "top-right",
      });
      return;
    }

    if (fullAddress.length < 10) {
      toast.error("Address is incomplete, please specify fully.", {
        position: "top-right",
      });
      return;
    }

    if (!districtCode) {
      toast.error("District cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.oem_usage) {
      toast.error("Usage cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.oem) {
      toast.error("OEM cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.loan_amount) {
      toast.error("Loan Amount cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (formValues.loan_amount === "0") {
      toast.error("Please enter a valid Loan Amount.", {
        position: "top-right",
      });
      return;
    }


    // alert(formValues.dealer_name);
    if (!formValues.dealer_name) {
      toast.error("Please enter Dealer Name.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.dst_name) {
      toast.error("Please enter DST Name.", {
        position: "top-right",
      });
      return;
    }

    if (!leadProfile) {
      toast.error("Please enter lead Profile.", {
        position: "top-right",
      });
      return;
    }

    const userRoleTypeVal = userRoleType;

    // set logged-in user id if assigned to user id is blank
    if (formValues.user === "") {
      formValues.user = loggeInUserID;
    }

    if (
      formValues.prefill_template_name === "" ||
      formValues.prefill_template_name === "0"
    ) {
      formValues.prefill_template_name = 1;
    }

    // if(skipAadharNumberToSave){
    if (aadharOTPSentStatus < 2) {
      // formValues.aadhar = ''; // skip the aadhar number to save if it is not verified
    }

    // const apiName = aadharApiResponse?.apiName;

    // if (apiName && apiName.trim() !== "") {

    //     const enteredName = (formValues.name || "").trim().toLowerCase();
    //     const aadhaarName = apiName.trim().toLowerCase();

    //     console.log("API Name =", aadhaarName);
    //     console.log("Entered Name =", enteredName);

    //     if (enteredName !== aadhaarName) {

    //         toast.error(
    //             "Entered name does not match the Aadhaar record. Please enter the customer's Aadhaar name.",
    //             {
    //                 position: "top-right",
    //             }
    //         );

    //         return;
    //     }
    // }
    
    // const panApiName = (panDetailsInfoName || "").trim();

    // if (panApiName !== "") {

    //     const enteredName = (formValues.name || "").trim().toLowerCase();
    //     const panName = panApiName.toLowerCase();

    //     if (enteredName !== panName) {
    //         toast.error(
    //             "Entered name does not match the PAN record. Please enter the customer's PAN name.",
    //             {
    //                 position: "top-right",
    //             }
    //         );
    //         return;
    //     }
    // }
const normalizeName = (str) => {
        return (str || "")
            .trim()
            .toLowerCase()
            .replace(/[.,]/g, "")      // dot, comma hata do
            .replace(/\s+/g, " ");     // multiple spaces ko single space kar do
    };

    const apiName = aadharApiResponse?.apiName || "";
    const panApiName = panDetailsInfoName || "";

    const enteredName = normalizeName(formValues.name);
    const aadhaarName = normalizeName(apiName);
    const panName = normalizeName(panApiName);

    const hasAadhaarName = aadhaarName !== "";
    const hasPanName = panName !== "";

    console.log("Entered Name =", enteredName);
    console.log("Aadhaar API Name =", aadhaarName, "hasAadhaarName:", hasAadhaarName);
    console.log("PAN API Name =", panName, "hasPanName:", hasPanName);

    if (hasAadhaarName || hasPanName) {

        const aadhaarMatch = hasAadhaarName && enteredName === aadhaarName;
        const panMatch = hasPanName && enteredName === panName;

        console.log("aadhaarMatch:", aadhaarMatch, "panMatch:", panMatch);

        if (!aadhaarMatch && !panMatch) {

            let errorMsg = "Entered name does not match ";
            if (hasAadhaarName && hasPanName) {
                errorMsg += "the Aadhaar or PAN record. Please enter the customer's Aadhaar/PAN name.";
            } else if (hasAadhaarName) {
                errorMsg += "the Aadhaar record. Please enter the customer's Aadhaar name.";
            } else {
                errorMsg += "the PAN record. Please enter the customer's PAN name.";
            }

            toast.error(errorMsg, {
                position: "top-right",
            });

            return;
        }
    }

    let params = {
      name: formValues.name,
      email: formValues.email_id,
      mobile: formValues.phone,
      full_address: formValues.full_address,
      // communication_address: communicationAddress, 
      adhar_number: formValues.aadhar,
      pancard_number: formValues.pan,
      lead_query: formValues.query,
      campaign: selectedCampaign,
      lead_assigned: assignedUser,
      action_user_id: formValues.created_by,
      lead_created_by: formValues.created_by,
      lead_profile: formValues.lead_profile,
      pan_details: leadPanDetails,
      lead_assigned_group: selectedAssignedGroup,
      user_role_type: userRoleTypeVal,
      city: formValues.city,
      district: formValues.district,
      state: formValues.state,
      pin: formValues.pin,
      dob: formValues.dob,
      prefill_template_name: formValues.prefill_template_name,
      oem_usage: formValues.oem_usage,
      oem: formValues.oem,
      loan_amount: formValues.loan_amount,
      AgreementNo: formValues.AgreementNo,
      lead_type_id: data.lead_type_id,
      lead_tenure: formValues.lead_tenure,
      vehicle_type: formValues.vehicle_type,
      dealer_name: formValues.dealer_name,
      sub_dealer_name: formValues.sub_dealer_name,
      dst_name: formValues.dst_name,
      aadhar_validation_id: aadharValidationID,
      aadhar_verified: aadharOTPSentStatus,
      refid: aadharRefid,
      "referenceId" : referenceId,
      is_duplicate: isDuplicate,
      duplicate_lead_id: duplicateLeadId,
      duplicate_section_identifier: duplicateSectionIdentifier,
    };

    if (leadId !== "") {
      params = {
        name: formValues.name,
        email: formValues.email_id,
        mobile: formValues.phone,
        full_address: formValues.full_address,
        adhar_number: formValues.aadhar,
        pancard_number: formValues.pan,
        lead_query: formValues.query,
        campaign: selectedCampaign,
        lead_assigned: assignedUser,
        action_user_id: formValues.created_by,
        lead_created_by: formValues.created_by,
        lead_profile: formValues.lead_profile,
        lead_id: leadId,
        lead_assigned_group: selectedAssignedGroup,
        user_role_type: userRoleTypeVal,
        city: formValues.city,
        district: formValues.district,
        state: formValues.state,
        pin: formValues.pin,
        dob: formValues.dob,
        prefill_template_name: formValues.prefill_template_name,
        oem_usage: formValues.oem_usage,
        oem: formValues.oem,
        loan_amount: formValues.loan_amount,
        AgreementNo: formValues.AgreementNo,
        lead_type_id: data.lead_type_id,
        lead_tenure: formValues.lead_tenure,
        vehicle_type: formValues.vehicle_type,
        dealer_name: formValues.dealer_name,
        sub_dealer_name: formValues.sub_dealer_name,
        dst_name: formValues.dst_name,
        aadhar_validation_id: aadharValidationID,
        aadhar_verified: aadharOTPSentStatus,
        refid: aadharRefid,
       "referenceId" : referenceId,
       is_duplicate_edited: isDuplicateEdited,
      };
    }

    // console.log("params : ", params);

    const requestData = encryptData(params);
    const response = actions.addEditLead(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        if (result.data.success === 1) {
          toast.success(result.data.message, {
            position: "top-right",
          });
          setTimeout(() => {
            if (leadId === "") {
              const encodedId = btoa(String(result.data.data));
              navigate(`/dashboard/edit-lead/${encodedId}`);
            } else {
              updateParentState(false);
              navigate("/dashboard/leads");
            }
          }, 1000);
        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (
      formValues?.dealer_name &&
      allDealers.length > 0 &&
      allSubDealers.length > 0
    ) {
      const selectedDealer = allDealers.find(
        d => d.name === formValues.dealer_name
      );

      if (selectedDealer) {
        const filtered = allSubDealers.filter(
          sd => Number(sd.dealer_id) === Number(selectedDealer.id)
        );
        setFilteredSubDealers(filtered);
      }
    }
  }, [formValues.dealer_name, allDealers, allSubDealers]);

   
  const handleDealerChange = (e) => {
    const selectedDealerName = e.target.value; 
   // handleChange(e); // existing form handler 
    // Find selected dealer object
    const selectedDealer = allDealers.find(
      d => d.name === selectedDealerName
    );  

    if (selectedDealer) {
      const filtered = allSubDealers.filter(
        sd => Number(sd.dealer_id) === Number(selectedDealer.id)
      );

      console.log("filtered = ",filtered);

      setFilteredSubDealers(filtered);
    } else {
      setFilteredSubDealers([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });

    if( e.target.name === 'dealer_name') {
        handleDealerChange(e);
    }
  };

  // Validation function for PAN Card
  const validatePanCard = async (panValue) => {
    // Only validate during lead creation (leadId is empty)
    if (leadId !== "" || !panValue || panValue.trim() === "") {
      setPanDuplicateRecords([]);
      return;
    }

    try {
      setValidationLoading(true);
      const params = {
        pan: panValue.trim(),
        type: 'pan'
      };
      const requestData = encryptData(params);

      const response = await agent.post('check_lead_duplicate', requestData);

      if (response.data && response.data.success === 1 && response.data.data) {
        const duplicates = [];
        const data = response.data.data;

        // Process duplicantApplicants
        if (data.duplicantApplicants && data.duplicantApplicants.length > 0) {
          data.duplicantApplicants.forEach(record => {
            duplicates.push({
              ...record,
              section_type: 'Applicant'
            });
          });
        }

        // Process duplicantCoApplicants
        if (data.duplicantCoApplicants && data.duplicantCoApplicants.length > 0) {
          data.duplicantCoApplicants.forEach(record => {
            duplicates.push({
              ...record,
              section_type: 'Co-applicant'
            });
          });
        }

        // Process duplicantGuarantor
        if (data.duplicantGuarantor && data.duplicantGuarantor.length > 0) {
          data.duplicantGuarantor.forEach(record => {
            duplicates.push({
              ...record,
              section_type: 'Guarantor'
            });
          });
        }

        setPanDuplicateRecords(duplicates);
      } else {
        setPanDuplicateRecords([]);
      }
    } catch (error) {
      console.error("PAN validation error:", error);
      setPanDuplicateRecords([]);
    } finally {
      setValidationLoading(false);
    }
  };

  // Validation function for Phone Number
  const validatePhoneNumber = async (phoneValue) => {
    // Only validate during lead creation (leadId is empty)
    if (leadId !== "" || !phoneValue || phoneValue.trim() === "") {
      setPhoneDuplicateRecords([]);
      return;
    }

    try {
      setValidationLoading(true);
      const params = {
        phone: phoneValue.trim(),
        type: 'phone'
      };
      const requestData = encryptData(params);

      const response = await agent.post('check_lead_duplicate', requestData);

      if (response.data && response.data.success === 1 && response.data.data) {
        const duplicates = [];
        const data = response.data.data;

        // Process duplicantApplicants
        if (data.duplicantApplicants && data.duplicantApplicants.length > 0) {
          data.duplicantApplicants.forEach(record => {
            duplicates.push({
              ...record,
              section_type: 'Applicant'
            });
          });
        }

        // Process duplicantCoApplicants
        if (data.duplicantCoApplicants && data.duplicantCoApplicants.length > 0) {
          data.duplicantCoApplicants.forEach(record => {
            duplicates.push({
              ...record,
              section_type: 'Co-applicant'
            });
          });
        }

        // Process duplicantGuarantor
        if (data.duplicantGuarantor && data.duplicantGuarantor.length > 0) {
          data.duplicantGuarantor.forEach(record => {
            duplicates.push({
              ...record,
              section_type: 'Guarantor'
            });
          });
        }

        setPhoneDuplicateRecords(duplicates);
      } else {
        setPhoneDuplicateRecords([]);
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setPhoneDuplicateRecords([]);
    } finally {
      setValidationLoading(false);
    }
  };

  // Handle blur event for PAN Card
  const handlePanBlur = (e) => {
    const panValue = e.target.value;
    validatePanCard(panValue);
  };

  // Handle blur event for Phone Number
  const handlePhoneBlur = (e) => {
    const phoneValue = e.target.value;
    validatePhoneNumber(phoneValue);
  };

  // Handle "Use" button click to prefill form with duplicate record data
  const handleUseDuplicateRecord = (record) => {
    // Prefill form values
    setFormValues({
      ...formValues,
      name: record.name || formValues.name,
      dob: record.dob || formValues.dob,
      full_address: record.full_address || record["full address"] || formValues.full_address,
      city: record.city || formValues.city,
      district: record.district || formValues.district,
      state: record.state || formValues.state,
      pin: record.pin || formValues.pin,
      email_id: record.email || formValues.email_id
    });

    // Set duplicate case state
    setIsDuplicate(true);
    setDuplicateLeadId(record.id);
    setDuplicateSectionIdentifier(record.section_name);

    // Show success message
    toast.info(`Form prefilled with ${record.section_type} data from Lead ID: ${record.lead_id}`, {
      position: "top-right",
    });
  };

  // Handle removing duplicate case
  const handleRemoveDuplicateCase = () => {
    // Reset duplicate state
    setIsDuplicate(false);
    setDuplicateLeadId(null);
    setDuplicateSectionIdentifier(null);
  };


  const handleAgreementDetails = () => {
     
     const params = { lead_id: leadId, AgreementNo: formValues.AgreementNo };
    const requestData = encryptData(params);
    const response = actions.updateLeadAgreementNoDetails(requestData);

    response
      .then((result) => { 
        if (result.data.success === 1) {
          // console.log("karza pan response = ", result.data.data);
           
            setPreloaderStatus(false);
            toast.success(result.data.message, {
              position: "top-right",
            }); 
           
        } else {
          setPreloaderStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };



  const fetchLeadPermissions = async () => {
    try {

      const payload = {
        role_id: roleId,
      };

      console.log("Payload", payload);

      const res = await fetch(
        `${config.API_BASE_URL}get_logged_in_user_lead_permissions`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: encryptData(payload),
        }
      );

      const result = await res.json();

        console.log('total nav values', result);

      return result;

    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const handlePanDetails = () => {
    // alert(`leadId = ${leadId}, formValues.pan = ${formValues.pan}`);
    if(camLatestStatus ==='1'){
              toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
                    position: "top-right",
                });
                return;
          }

    if(formValues.pan !== ''){
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (!panRegex.test(formValues.pan.toUpperCase())) { 
          toast.error('Invalid PAN number. Please enter a valid alphanumeric PAN (e.g., ABCDE1234F).', {
            position: "top-right",
          });
          return;
      }  
    }      
    setPreloaderStatus(true);
    const params = { lead_id: leadId, pan_number: formValues.pan };
    const requestData = encryptData(params);
    const response = actions.updateLeadKarzaPanDetails(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadPanDetails("");
        setPanDetailsInfoName("");
        setPanDetailsInfoDoB("");
        setPanDetailsInfoGender("");
        setPanDetailsInfoAddress("");
        if (result.data.success === 1) {
          // console.log("karza pan response = ", result.data.data);
          if (result.data.data.data.statusCode === 101) {
            setPreloaderStatus(false);
            toast.success(result.data.message, {
              position: "top-right",
            });

            // alert('karza = 1');
            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data.data.result,
                "address"
              )
            ) {
              const panDetailsAddress = `${result.data.data.data.result.address.buildingName} ${result.data.data.data.result.address.city} ${result.data.data.data.result.address.country} ${result.data.data.data.result.address.streetName} ${result.data.data.data.result.address.state} ${result.data.data.data.result.address.pinCode}`;

              setPanDetailsInfoName(result.data.data.data.result.name);
              setPanDetailsInfoDoB(result.data.data.data.result.dob);
              setPanDetailsInfoGender(result.data.data.data.result.gender);
              setPanDetailsInfoAddress(panDetailsAddress); 
              removeHighlightedFields();
             // if(result.data.data.data.result.name !==''){

                handlePrefillDataFromApi('pan', {
                  name: result.data.data.data.result.name,
                  dob: result.data.data.data.result.dob,
                  full_address: panDetailsAddress,
                  city: result.data.data.data.result.address.city,
                  pin: result.data.data.data.result.address.pinCode,
                  state: result.data.data.data.result.address.state,
                });
             // }
              

              setLeadPanDetails(result.data.data.data);
            }
          } else if (
            Object.prototype.hasOwnProperty.call(
              result.data.data.data,
              "statusMessage"
            )
          ) {
            setPreloaderStatus(false);
            toast.error(result.data.data.data.statusMessage, {
              position: "top-right",
            });
          } else {
            setPreloaderStatus(false);
            toast.error("No response from api", {
              position: "top-right",
            });
          }
        } else {
          setPreloaderStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  const handlePhoneDetails = () => {
    if(camLatestStatus ==='1'){
              toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
                    position: "top-right",
                });
                return;
          }
    setPreloaderStatusPhone(true);
    const params = { lead_id: leadId, phone_number: formValues.phone };
    const requestData = encryptData(params);
    const response = actions.validateBefiscPhoneDetails(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadPanDetails("");

        if (result.data.success === 1) {
           // console.log("Befisc phone response = ", result.data.data);
          setPreloaderStatusPhone(false);
          toast.success(result.data.message, {
            position: "top-right",
          });

          let BefiscHtml = "";
          let BefiscStatus = "";

          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "befiscApiRunStatus"
            ) &&
            result.data.data.befiscApiRunStatus
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data,
                "mobileage_response"
              )
            ) {
              const mobileageObj = result.data.data.mobileage_response;

              if (mobileageObj.length === 0) {
                BefiscHtml += `<span class="text-danger">Phone Number Age not found.</span>`;
              } else if (
                Object.prototype.hasOwnProperty.call(mobileageObj, "result") &&
                Object.prototype.hasOwnProperty.call(
                  mobileageObj.result,
                  "mobile_age"
                )
              ) {
                BefiscHtml += `<div>Mobile Age : ${mobileageObj.result.mobile_age}</div>`;
                BefiscStatus = "true";
              }
            }

            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data,
                "multiple_upi_response"
              )
            ) {
              const upiObj = result.data.data.multiple_upi_response;

              if (upiObj.length === 0) {
                BefiscHtml += `<span class="text-danger">UPI Handle not found.</span>`;
              } else {
                if (
                  Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                  Object.prototype.hasOwnProperty.call(upiObj.result, "name")
                ) {
                  BefiscHtml += `<div>Name : ${upiObj.result.name}</div>`;
                  BefiscStatus = "true";
                }

                if (
                  Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                  Object.prototype.hasOwnProperty.call(upiObj.result, "upi") &&
                  Array.isArray(upiObj.result.upi)
                ) {
                  BefiscHtml += `<div>UPIs : ${upiObj.result.upi.join(
                    ", "
                  )}</div>`;
                  BefiscStatus = "true";
                }
              }
            }
          } else {
            BefiscHtml += `<span class="text-danger">UPI Handle and Phone Number API not run.</span><span>Please click the <b>'Get Phone Number Age + UPI Handle'</b> button.</span> `;
          }

          setOutputBefiscHtml(BefiscHtml);
          setPhoneDetailsInfoName(BefiscStatus);
        } else {
          setPreloaderStatusPhone(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderStatusPhone(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  const handleChangeAssignedGroup = (event, actionName = "") => {
    const selectedValue = event.target.value;
    setSelectedAssignedGroup(selectedValue);

    if (selectedValue !== "") {
      const userRoleTypeVal = userRoleType;

      const obj = {
        start: "0",
        length: config.MAX_RECORDS,
        group_id: selectedValue,
        user_role_type: userRoleTypeVal,
      };
      const requestData = encryptData(obj);

      const response = actions.groupsUsersData(requestData);
      response
        .then((result) => {
          // console.log("Promise resolved -  groupsUsersData list:", result);
          if (result.data.success === 1) {
            const usersListData = result.data.data.data;
            // console.log("usersListData = ", usersListData);

            if (
              Object.prototype.hasOwnProperty.call(
                usersListData[0],
                "users_list"
              )
            ) {
              const resultArr = usersListData[0].users_list.sort((a, b) =>
                a.name.localeCompare(b.name)
              );
              setAllUsersListData(resultArr);
              // setAllUsersListData(usersListData[0].users_list);
            }
            setSelectedAssignedGroup(selectedValue);

            if (actionName !== "selectedUser") {
              const userSetReset = { user: "" };
              setFormValues((prevValues) => ({
                ...prevValues,
                ...userSetReset,
              }));
            }
          }
        })
        .catch((error) => {
          // console.error("Promise rejected -  groupsUsersData list:", error);
        });
    } else {
      setAllUsersListData([]);
    }
  };

  const handleIframeLoad = () => {
        setIframeLoaded(true);
    };

  const handleCampaign = (event, actionName = "") => {
    const selectedCampaignId = event.target.value;
    setSelectedCampaign(selectedCampaignId);
    const selectedCampaignInfo = allCampaigns.find(
      (campaign) => campaign.id === selectedCampaignId
    );

    if (selectedCampaignInfo) {
      setSelectedAssignedGroup(selectedCampaignInfo.assigned_group);
      setAssignedUser(selectedCampaignInfo.assigned_user);

      handleAssignedUser({
        target: { value: selectedCampaignInfo.assigned_user },
      });
      handleChangeAssignedGroup({
        target: { value: selectedCampaignInfo.assigned_group },
      });
    }
  };

  const handleAssignedUser = (event) => {
    const user = event.target.value;
    setAssignedUser(user);
  };

  const handleCrifAPI = (actionName, sectionId, formRemarkData) => {
    if (formRemarkData.purpose_deployment_vehicle.trim() === "") {
      toast.error("Purpose and deployment of vehicle is blank.", {
        position: "top-right",
      });
    } else if (formRemarkData.investor_profile.trim() === "") {
      toast.error("Investor profile is blank.", {
        position: "top-right",
      });
    } else if (
      formRemarkData.purpose_deployment_vehicle.trim() === "ATTACHED" &&
      formRemarkData.remarks.trim() === ""
    ) {
      toast.error("Remarks is required.", {
        position: "top-right",
      });
    } else if (!formRemarkData.consentDetailsStatus) {
      toast.error(
        "Please check the consent details checkbox if you want to proceed for bureau.",
        {
          position: "top-right",
        }
      );
    } else if (formRemarkData.consentDetails.trim() === "") {
      toast.error("Consent Details is required.", {
        position: "top-right",
      });
    } else if (
      formRemarkData.dob.trim() === "" ||
      formRemarkData.dob === "0000-00-00"
    ) {
      toast.error("DoB is required.", {
        position: "top-right",
      });
    } else if (formRemarkData.full_address.trim() === "") {
      toast.error("Address is required.", {
        position: "top-right",
      });
    } else if (formRemarkData.city.trim() === "") {
      toast.error("City is required.", {
        position: "top-right",
      });
    } else if (formRemarkData.state.trim() === "") {
      toast.error("State is required.", {
        position: "top-right",
      });
    } else if (formRemarkData.pin.trim() === "") {
      toast.error("Pin is required.", {
        position: "top-right",
      });
      /* }else if(formRemarkData.addressTypeId.trim() === ''){
                 toast.error("Address Type is required.", {
                     position: "top-right",
                 });  */
    } else if (formRemarkData.pan_number.trim() === "") {
      toast.error("Pan is required.", {
        position: "top-right",
      });
    } else {
      // alert(`${actionName} - ${sectionId}`);
      const params = {
        'action': actionName,
        id: sectionId,
        lead_id: leadId,
        'formRemarkData': formRemarkData,
      };
      const requestData = encryptData(params);
      const response = actions.callCrifAPI(requestData);

      response
        .then((result) => {
          //  console.log("Promise resolved - CRIF form:", result);
          if (result.data.success === 1) {
             // console.log("crif response = ", result.data.data);
            toast.success(result.data.message, {
              position: "top-right",
            });
            updateParentState(false);
          } else {
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          // console.error("Promise rejected - CRIF form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    }
  };

  const handleCrifOTPAPI = (actionName, sectionId, formOTPData) => {
    if (formOTPData.otp.trim() === "") {
      toast.error("OTP is blank.", {
        position: "top-right",
      });
    } else {
      // alert(`${actionName} - ${sectionId}`);
      const params = {
        action: actionName,
        id: sectionId,
        lead_id: leadId,
        'formOTPData': formOTPData,
        brief: "otp_verification",
        verifed_side: "ViaLms",
      };
      const requestData = encryptData(params);
      const response = actions.callCrifAPI(requestData);

      response
        .then((result) => {
           // console.log("Promise resolved - CRIF form:", result);
          if (result.data.success === 1) {
            //  console.log("crif response = ", result.data.data);
            toast.success(result.data.message, {
              position: "top-right",
            });
            updateParentState(false);
          } else {
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          // console.error("Promise rejected - CRIF form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    }
  };

  const handleCrifResedOTPAPI = (actionName, sectionId, formOTPData) => {
    if (actionName.trim() === "") {
      toast.error("Please try again.", {
        position: "top-right",
      });
    } else {
      // alert(`${actionName} - ${sectionId}`);
      const params = {
        action: actionName,
        id: sectionId,
        lead_id: leadId,
        'formOTPData': formOTPData,
        brief: "resend_otp",
        verifed_side: "ViaLms",
      };
      const requestData = encryptData(params);
      const response = actions.callCrifAPI(requestData);

      response
        .then((result) => {
           // console.log("Promise resolved - CRIF form:", result);
          if (result.data.success === 1) {
            //  console.log("crif response = ", result.data.data);
            toast.success(result.data.message, {
              position: "top-right",
            });
            updateParentState(false);
          } else {
            toast.error(result.data.message, {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          // console.error("Promise rejected - CRIF form:", error);
          toast.error(error, {
            position: "top-right",
          });
        });
    }
  };

  function handleCredit(actionName) {
    const params = { lead_id: leadId, "action" : actionName , "userRoleType" :userRoleType };
    // console.log("handleCredit = ", params);
    const requestData = encryptData(params);
    const response = actions.addCredit(requestData);
    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        if (result.data.success === 1) {
          toast.success(result.data.message, {
            position: "top-right",
          });
          const addCreditInfo = result.data.data;
          if (addCreditInfo !== "") {
            if (
              Object.prototype.hasOwnProperty.call(
                addCreditInfo,
                "created_date"
              )
            ) {

              
              if(actionName === 'sent_for_cam_preparation'){

                const showResNote = `Sent for CAM preparation to User On ${addCreditInfo.created_date} `;
                 setShowSentForCAMPreparationNote(showResNote);
              }else  if(actionName === 'review_for_do'){

                const showResNote = `Sent Review For DO to User On ${addCreditInfo.created_date} `;
                 setShowSentReviewForDoNote(showResNote);  
               }else  if(actionName === 'sent_for_do'){

                const showResNote = `Sent For DO On ${addCreditInfo.created_date} `;
                 setShowSentForDONote(showResNote);    
              }else{
                const showResNote = `Sent to Credit On ${addCreditInfo.created_date} `;
                setShowNote(showResNote);
              }
            }
            fetchLeads();
          }
        } else {
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  }

  const onShowHistoryClickAction = () => {
    setShowHistory(true);
  };

  const backToLeadHandler = (tabName) => {
    setShowHistory(false);
    setActiveTab(tabName);

    setOpen(false);
    // updateParentState(false);
  };
  

  const enableCamDetailsHandler = (tabStatus) => {
    setEnableCamDetailsStatus(tabStatus);
    // updateParentState(false);
  };

  const vivritiChecklistStatusHandler = (tabStatus) => {
    setVivritiChecklistStatus(tabStatus);
    // updateParentState(false);
  };

  const reFiChecklistStatusHandler = (tabStatus) => {
    setReFiChecklistStatus(tabStatus);
    // updateParentState(false);
  };

  const handleSLDOVersioningChange = (e,actionName) => { 

    if(actionName === 'sl'){        
        selectRefDO.current.value = '';
    }else if( actionName === 'do' ){  
        selectRefSL.current.value = '';
    } 
    setSelectionVersioningID(e.target.value); 
    setPreloaderStatus(true);
     backToLeadHandler('cam');
        enableCamDetailsHandler(true); 
        setActiveTab("communication");       
        const timer = setTimeout(() => {
            setActiveTab("cam");
            const divElement = document.getElementById("pills-disbursement_memo-tab");
            if (divElement) {
              divElement.click(); 
            }
            setPreloaderStatus(false);
          }, 2000);       
          return () => clearTimeout(timer); 
   };

  useEffect(() => {
    if (isExternalUser) {
      if (allInteractions && allInteractions.length > 0) {
        if (
          Object.prototype.hasOwnProperty.call(
            allInteractions[0],
            "lead_status"
          ) &&
          allInteractions[0].lead_status !== ""
        ) {
          if (allInteractions[0].lead_status === "Need Documents") {
            const noteIsExternalUserContent = `${allInteractions[0].lead_status} - ${allInteractions[0].subLeadStatus} Updated On ${allInteractions[0].DateOfInteraction} `;
            setIsExternalUserContent(noteIsExternalUserContent);
          } else {
            setIsExternalUserContent("");
          }
        }
      }
    }
  }, [allInteractions, setIsExternalUserContent,setFilteredSubDealers]);

  const handleAadharDetails = () => {
    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);

    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }
    
    // if (!formValues.name) {
    //   toast.error("Name cannot be blank.", {
    //     position: "top-right",
    //   });
    //   return;
    // }

    // if (!formValues.dob) {
    //   toast.error("DoB cannot be blank.", {
    //     position: "top-right",
    //   });
    //   return;
    // }

    if (!formValues.aadhar) {
      toast.error("Aadhar cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    setPreloaderAadharStatus(true);
   
    const params = {
      section_id: leadId,
      aadhar_number: formValues.aadhar,
      name: formValues.name,
      dob: formValues.dob,
      action: "befisc_sent_otp",
      section_name: "lead",
      "referenceId" : referenceId
    };

     setReferenceId("");
    const requestData = encryptData(params);
    const response = actions.aadharValidation(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails("");
        setAadharVerifiedByName("");
        setAadharOTPSentStatus("0");

         // console.log("aadhar validation response = ", result.data);
        if (result.data.success === 1) {
          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "aadhar_otp_sent_status"
            ) &&
            result.data.data.aadhar_otp_sent_status !== ""
          ) {
            setAadharOTPSentStatus(result.data.data.aadhar_otp_sent_status);

            if (result.data.data.aadhar_otp_sent_status === "2") {
              // setAadharVerifiedByName('Verified Successfully');

              const aadharVerifiedBy = result?.data?.data?.aadhar_verified_by;
              if (aadharVerifiedBy !== "") {
                setAadharVerifiedByName(aadharVerifiedBy);
              }
              const aadharVerifiedOn = result?.data?.data?.aadhar_verified_on;
              if (aadharVerifiedOn !== "") {
                setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
              }

              if (aadharVerifiedBy !== "") {
                setAadharDigiVerifiedByName(aadharVerifiedBy);
              } 
                if (aadharVerifiedOn !== "") {
                setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
              }
            }
          }

          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "aadhar_validation_id"
            ) &&
            result.data.data.aadhar_validation_id !== ""
          ) {
            setAadharValidationID(result.data.data.aadhar_validation_id);
          }

          const requestId =
            result?.data?.data?.sendOTPResponse?.result?.requestId;

          setReferenceId(requestId);

          setPreloaderAadharStatus(false);
          toast.success(result.data.message, {
            position: "top-right",
          });
        } else {
          setPreloaderAadharStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderAadharStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };


  const startInterval = (requestId) => {
    // Clear any previous interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    aadharPrefillHandledRef.current = false;
    // Start a new interval
    intervalRef.current = setInterval(() => {
      console.log("This runs every 5 seconds =", requestId);
     // getAadharDetailsDigiLocker(requestId);
      getAadharTimbleDetailsDigiLocker(requestId);
    }, 2000);
  };

  const getAadharDetailsDigiLocker = (requestId='') => {

    if(referenceId === ''){ 
      setReferenceId(requestId);
    }
     
    console.log("Ready to run getAadharDetailsDigiLocker after 5 seconds ", requestId);
    setPreloaderAadharStatus(false);  
    if ( requestId === '') { 
      return;
    } 
     const params = {
      section_id: leadId,
      aadhar_number: formValues.aadhar,
      name: formValues.name,
      dob: formValues.dob,
      action: "digi_locker_other_details",
      section_name: "lead",
      'referenceId': requestId,
    };
    const requestData = encryptData(params);
    const response = actions.getAadharDetailsDigiLocker(requestData); 
    setAadharDigiAadhaarError('');
    setAadharRefid('');
    response
      .then((result) => { 
         // console.log("aadhar validation response = ", result.data);
        // alert(result.data.success); 
         const responseData = result?.data?.data; 
         setAadharApiResponse(responseData);
         console.log("getAadharTimbleDetailsDigiLocker responseData =", responseData);
        if (result.data.success === 1) {  
          console.log("getAadharDetailsDigiLocker responseData = ",responseData)
          if( responseData?.eaadhaarDocumentInXMLStatus === 'generated'){

           if (responseData?.aadhar_otp_sent_status === "2") {
                 const aadharVerifiedBy = responseData?.aadhar_verified_by;
                if (aadharVerifiedBy !== "") {
                  setAadharDigiVerifiedByName(aadharVerifiedBy);
                } 
                const aadharVerifiedOn =  responseData?.aadhar_verified_on;
                if (aadharVerifiedOn !== "") {
                  setAadharDigiVerifiedDate(formatDateForValue(aadharVerifiedOn));
                }
                setAadharOTPSentStatus(responseData?.aadhar_otp_sent_status);
                setAadharRefid(responseData?.referenceId);
                if (
                    Object.prototype.hasOwnProperty.call(
                      responseData,
                      "aadhar_validation_id"
                    ) &&
                    responseData.aadhar_validation_id !== ""
                  ) {
                    setAadharValidationID(responseData.aadhar_validation_id);
                  }
                   
            }
           // else{
            //   setAadharDigiVerifiedByName("");
           // }
          }
        } else {
          setPreloaderAadharStatus(false); 
           if (responseData?.eaadhaarDocumentInXMLStatus === "generated") { 
              setAadharDigiAadhaarError(result.data.message);
           } 
        }
      })
      .catch((error) => {
        setPreloaderAadharStatus(false);
        
      });
  }

  const handleAadharDetailsDigiLocker = () => {
    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    setIsModalOpen(false);
    setIframeUrl('');
    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }
    
    if (!formValues.name) {
      toast.error("Name cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.dob) {
      toast.error("DoB cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.aadhar) {
      toast.error("Aadhar cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    setPreloaderAadharStatus(true);
   
    const params = {
      section_id: leadId,
      aadhar_number: formValues.aadhar,
      name: formValues.name,
      dob: formValues.dob,
      action: "digi_locker_access_token_generation",
      section_name: "lead",
      "referenceId" : referenceId,
      "previousTokenVal" : previousTokenVal
    };
     setReferenceId("");
    const requestData = encryptData(params);
    const response = actions.aadharDigiLockerValidation(requestData);
    
    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails("");
        setAadharVerifiedByName("");
        setAadharOTPSentStatus("0");

         // console.log("aadhar validation response = ", result.data);
        if (result.data.success === 1) { 
          const responseData = result?.data?.data?.responseInfo?.data;

          const requestId = responseData?.data?.refid;
          const authorizationUrl = responseData?.data?.authorization_url;
          const requestMessage = responseData?.message;
          const previousToken = result?.data?.data?.previous_token; 
          
         
          setPreloaderAadharStatus(false);
          if (requestMessage) { 
            toast.success(requestMessage, {
              position: "top-right",
            });
          }else{
             toast.error(requestMessage, {
              position: "top-right",
            });
          }

          if(authorizationUrl !== '' && requestId !==''){  
             setReferenceId(requestId);
             setPreviousTokenVal(previousToken);
              setTimeout(() => { 
               const urlNew =  `${authorizationUrl}&forceRefresh=${Date.now()}`;
               // alert(urlNew);
              // setIsOpen(true);
              //  setIframeSrc(`${urlNew}`);
              //  setIframeLoaded(true);
                 window.open(urlNew, '_blank');
              }, 500);
 
              /* const interval = setInterval(() => {
                console.log("This runs every 5 seconds = ",requestId);
                getAadharDetailsDigiLocker(requestId);
              }, 5000);  */ 
              startInterval(requestId);
                
          }else{
             toast.error(requestMessage, {
              position: "top-right",
            });
          }
        } else {
          setPreloaderAadharStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderAadharStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };


const getAadharTimbleDetailsDigiLocker = (requestId = "") => {
  if (referenceId === "") {
    setReferenceId(requestId);
  }

  console.log(
    "Ready to run getAadharTimbleDetailsDigiLocker after 5 seconds ",
    requestId
  );

  setPreloaderAadharStatus(false);

  if (requestId === "") {
    return;
  }

  const params = {
    section_id: leadId,
    aadhar_number: formValues.aadhar,
    name: formValues.name,
    dob: formValues.dob,
    action: "digi_locker_other_details",
    section_name: "lead",
    referenceId: requestId,
  };

  const requestData = encryptData(params);
  const response = actions.getAadharTimbleDetailsDigiLocker(requestData);

  setAadharDigiAadhaarError("");
  setAadharRefid("");

  response
    .then((result) => {
      console.log("FULL RESPONSE:", result);

      const responseData = result?.data?.data;

      console.log("responseData:", responseData);
      console.log("apiName from response:", responseData?.apiName);

      if (!responseData) {
        console.log("Aadhaar response data not found");
        return;
      }

      setAadharApiResponse(responseData);

      // ================================
      // DOB FORMAT
      // ================================

      const formatDOB = (dob) => {
        if (!dob || typeof dob !== "string") return "";

        const cleaned = dob.trim();
        const separator = cleaned.includes("/") ? "/" : "-";
        const parts = cleaned.split(separator);

        if (parts.length !== 3) return "";

        // YYYY-MM-DD
        if (parts[0].length === 4) {
          const [year, month, day] = parts;

          return `${year}-${month.padStart(
            2,
            "0"
          )}-${day.padStart(2, "0")}`;
        }

        // DD-MM-YYYY
        const [day, month, year] = parts;

        if (!year || year.length !== 4) {
          return "";
        }

        return `${year}-${month.padStart(
          2,
          "0"
        )}-${day.padStart(2, "0")}`;
      };

      const formattedDob = formatDOB(responseData?.apiDob);

      console.log("formattedDob:", formattedDob);

      // ================================
      // ADDRESS PARSING
      // ================================

      const apiAddress = responseData?.apiAddress || "";

      const addressParts = apiAddress
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);

      console.log("ADDRESS PARTS:", addressParts);

      // ================================
      // STATE DETECTION
      // ================================

      const indianStates = [
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chhattisgarh",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
        "Delhi",
        "Jammu and Kashmir",
        "Ladakh",
        "Chandigarh",
        "Puducherry",
        "Andaman and Nicobar Islands",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Lakshadweep",
      ];

      const detectedState =
        addressParts.find((part) =>
          indianStates.some(
            (state) =>
              state.toLowerCase() === part.toLowerCase()
          )
        ) || "";

         const matchedState = allStates.find(
          (stateItem) =>
            stateItem?.state_name?.trim().toLowerCase() ===
            detectedState?.trim().toLowerCase()
        );

        const detectedStateId = matchedState?.state_code
          ? matchedState.state_code
          : "";

        console.log("STATE MATCH:", {
          detectedState,
          detectedStateId,
          matchedState,
        });

      // ================================
      // PINCODE DETECTION
      // ================================

      const pinMatch = apiAddress.match(/\b\d{6}\b/);

      const detectedPin = pinMatch
        ? pinMatch[0]
        : "";

      // ================================
      // CLEAN LOCATION PARTS
      // ================================

      const locationParts = addressParts.filter(
        (part) => {
          const lowerPart = part.toLowerCase();

          return (
            lowerPart !== "india" &&
            lowerPart !== detectedState.toLowerCase() &&
            !lowerPart.startsWith("s/o") &&
            !lowerPart.startsWith("d/o") &&
            !lowerPart.startsWith("w/o") &&
            !lowerPart.startsWith("c/o") &&
            !/\b\d{6}\b/.test(part)
          );
        }
      );

      // Remove duplicate values
      // Bokaro Steel City and BOKARO STEEL CITY
      // will be considered same

      const uniqueLocationParts = [
        ...new Map(
          locationParts.map((part) => [
            part.toLowerCase(),
            part,
          ])
        ).values(),
      ];

      console.log(
        "UNIQUE LOCATION PARTS:",
        uniqueLocationParts
      );

      // ================================
      // DISTRICT DETECTION
      // ================================

      const detectedDistrict =
        uniqueLocationParts.find((part) => {
          const lower = part.toLowerCase();

          return (
            !lower.includes("sector") &&
            !lower.includes("nagar") &&
            !lower.includes("/") &&
            !lower.includes("-") &&
            !lower.includes("steel city")
          );
        }) || "";

      // ================================
      // CITY DETECTION
      // ================================

      const detectedCity =
        uniqueLocationParts.find((part) => {
          const lower = part.toLowerCase();

          return (
            lower !==
              detectedDistrict.toLowerCase() &&
            !lower.includes("sector") &&
            !lower.includes("nagar") &&
            !lower.includes("/") &&
            !lower.includes("-")
          );
        }) || "";

      console.log("PARSED AADHAAR ADDRESS:", {
        fullAddress: apiAddress,
        city: detectedCity,
        district: detectedDistrict,
        state: detectedState,
        pin: detectedPin,
      });

      // ================================
      // PREPARE PREFILL DATA
      // ================================

      // ================================
      // CLEAN PERMANENT ADDRESS
      // (only house/landmark/S-O line — city, district, state, pin, "India"
      // are excluded since they already have their own fields)
      // ================================

      // relationLine (S/O, D/O, W/O, C/O) is intentionally NOT added to the
      // address anymore — it is excluded completely, per business requirement.

      const remainingLineParts = uniqueLocationParts.filter((part) => {
        const lower = part.toLowerCase();

        return (
          lower !== detectedCity.toLowerCase() &&
          lower !== detectedDistrict.toLowerCase() &&
          !lower.startsWith("s/o") &&
          !lower.startsWith("d/o") &&
          !lower.startsWith("w/o") &&
          !lower.startsWith("c/o") &&
        
          !/^\d{6}$/.test(part) &&
          lower !== "india" &&
          part !== ""
        );
      });

      const cleanedFullAddress = remainingLineParts.join(", ").trim();

      console.log("CLEANED PERMANENT ADDRESS (no S/O):", cleanedFullAddress);

      console.log("CLEANED PERMANENT ADDRESS:", cleanedFullAddress);

      // ================================
      // PREPARE PREFILL DATA
      // ================================

      const aadharPrefillData = {
        ...(responseData?.apiName && {
          name: responseData.apiName,
        }),

        ...(formattedDob && {
          dob: formattedDob,
        }),

        ...(cleanedFullAddress && {
          full_address: cleanedFullAddress,
        }),

        ...(detectedCity && {
          city: detectedCity,
        }),

        ...(detectedDistrict && {
          district: detectedDistrict,
        }),

        ...(detectedStateId && {
          state: detectedStateId,
        }),

        ...(detectedPin && {
          pin: detectedPin,
        }),
      };

      console.log(
        "FINAL AADHAAR PREFILL:",
        aadharPrefillData
      );

      // ================================
      // DIRECT FORM PREFILL
      // ================================

      if (
        Object.keys(aadharPrefillData).length > 0
      ) {
        if (Object.keys(aadharPrefillData).length > 0) {
  handlePrefillDataFromApi("aadhar", aadharPrefillData);

  aadharPrefillHandledRef.current = true;

  if (intervalRef.current) {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }
}

        aadharPrefillHandledRef.current = true;

        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }

      // ================================
      // EXISTING AADHAAR VERIFICATION
      // ================================

      if (result.data.success === 1) {
        if (
          responseData
            ?.eaadhaarDocumentInXMLStatus ===
          "generated"
        ) {
          if (
            responseData?.aadhar_otp_sent_status ===
            "2"
          ) {
            const aadharVerifiedBy =
              responseData?.aadhar_verified_by;

            if (aadharVerifiedBy !== "") {
              setAadharDigiVerifiedByName(
                aadharVerifiedBy
              );
            }

            const aadharVerifiedOn =
              responseData?.aadhar_verified_on;

            if (aadharVerifiedOn !== "") {
              setAadharDigiVerifiedDate(
                formatDateForValue(
                  aadharVerifiedOn
                )
              );
            }

            setAadharOTPSentStatus(
              responseData?.aadhar_otp_sent_status
            );

            setAadharRefid(
              responseData?.referenceId
            );

            if (
              Object.prototype.hasOwnProperty.call(
                responseData,
                "aadhar_validation_id"
              ) &&
              responseData.aadhar_validation_id !==
                ""
            ) {
              setAadharValidationID(
                responseData.aadhar_validation_id
              );
            }
          }
        }
      } else {
        setPreloaderAadharStatus(false);

        if (
          responseData
            ?.eaadhaarDocumentInXMLStatus ===
          "generated"
        ) {
          setAadharDigiAadhaarError(
            result.data.message
          );
        }
      }
    })
    .catch((error) => {
      console.error(
        "AADHAAR DIGILOCKER ERROR:",
        error
      );

      setPreloaderAadharStatus(false);
    });
};

  const handleAadharDetailsTimbleDigiLocker = () => {
    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    setIsModalOpen(false);
    setIframeUrl('');
    if(camLatestStatus ==='1'){
        toast.error("This lead has been approved by the Credit Head, you cannot modify the details", {
              position: "top-right",
          });
          return;
    }
    
    // if (!formValues.name) {
    //   toast.error("Name cannot be blank.", {
    //     position: "top-right",
    //   });
    //   return;
    // }

    // if (!formValues.dob) {
    //   toast.error("DoB cannot be blank.", {
    //     position: "top-right",
    //   });
    //   return;
    // }

    if (!formValues.aadhar) {
      toast.error("Aadhar cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    setPreloaderAadharStatus(true);
   
    const params = {
      lead_id: leadId,
      section_id: leadId,
      aadhar_number: formValues.aadhar,
      name: formValues.name,
      dob: formValues.dob,
      action: "digi_locker_access_token_generation",
      section_name: "lead",
      "referenceId" : referenceId,
      "previousTokenVal" : previousTokenVal
    };
     setReferenceId("");
    const requestData = encryptData(params);
    const response = actions.aadharTimbleDigiLockerValidation(requestData);
    
    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails("");
        setAadharVerifiedByName("");
        setAadharOTPSentStatus("0");

         // console.log("aadhar validation response = ", result.data);
        if (result.data.success === 1) { 
          const responseData = result?.data?.data?.responseInfo?.data;

          const requestId = responseData?.x_unique_Id;
          const authorizationUrl = responseData?.UrlforAuth;
          const requestMessage = responseData?.message;
          const previousToken = result?.data?.data?.previous_token; 
          
         
          setPreloaderAadharStatus(false);
          if (requestMessage) { 
            toast.success(requestMessage, {
              position: "top-right",
            });
          }else{
             toast.error(requestMessage, {
              position: "top-right",
            });
          }

          if(authorizationUrl !== '' && requestId !==''){  
             setReferenceId(requestId);
             setPreviousTokenVal(previousToken);
              setTimeout(() => { 
             //  const urlNew =  `${authorizationUrl}&forceRefresh=${Date.now()}`;
               const urlNew =  `${authorizationUrl}`;
               // alert(urlNew);
              // setIsOpen(true);
              //  setIframeSrc(`${urlNew}`);
              //  setIframeLoaded(true);
                 window.open(urlNew, '_blank');
              }, 500);
 
              /* const interval = setInterval(() => {
                console.log("This runs every 5 seconds = ",requestId);
                getAadharDetailsDigiLocker(requestId);
              }, 5000);  */ 
              startInterval(requestId);
                
          }else{
             toast.error(requestMessage, {
              position: "top-right",
            });
          }
        } else {
          setPreloaderAadharStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderAadharStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

  const formatDateForValue = (date) => {
    if (!date || Number.isNaN(new Date(date).getTime())) {
      return ""; // Return an empty string for invalid or empty dates
    }

    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  };

  const formatDateTimeForValue = (date) => {
    if (!date || Number.isNaN(new Date(date).getTime())) {
      return ""; // Return an empty string for invalid or empty dates
    }
  
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");
  
    let hours = newDate.getHours();
    const minutes = String(newDate.getMinutes()).padStart(2, "0");
    const seconds = String(newDate.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
  
    hours %= 12;
    hours = hours || 12; // Convert 0 to 12
    hours = String(hours).padStart(2, "0");
  
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const handleAadharOTPVerifyDetails = () => {
    if (!formValues.name) {
      toast.error("Name cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.dob) {
      toast.error("DoB cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    if (!formValues.aadhar) {
      toast.error("Aadhar cannot be blank.", {
        position: "top-right",
      });
      return;
    }

    // alert(`leadId = ${leadId}, formValues.aadhar = ${formValues.aadhar}`);
    setPreloaderAadharOTPVerifyStatus(true);
    setAadharVerifiedStatus(false);
    const params = {
      section_id: leadId,
      aadhar_number: formValues.aadhar,
      name: formValues.name,
      dob: formValues.dob,
      otp: formValues.aadhar_otp,
      'referenceId': referenceId,
      action: "download_aadhar",
      section_name: "lead",
    };
    const requestData = encryptData(params);
    const response = actions.aadharValidation(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadAadharDetails("");
        setAadharVerifiedByName("");
        if (result.data.success === 1) {
          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "aadhar_otp_sent_status"
            ) &&
            result.data.data.aadhar_otp_sent_status !== ""
          ) {
            // if(result.data.data.aadhar_otp_sent_status === '1'){
            setAadharOTPSentStatus(result.data.data.aadhar_otp_sent_status);
            // }

            if (result.data.data.aadhar_otp_sent_status === "2") {
              const aadharVerifiedBy = result?.data?.data?.aadhar_verified_by;
              if (aadharVerifiedBy !== "") {
                setAadharVerifiedByName(aadharVerifiedBy);
              } 
              const aadharVerifiedOn = result?.data?.data?.aadhar_verified_on;
              if (aadharVerifiedOn !== "") {
                setAadharVerifiedDate(formatDateForValue(aadharVerifiedOn));
              }


              setAadharVerifiedStatus(true);
              setSkipAadharNumberToSave(false);


              const aadharResponse = result?.data?.data?.aadharResponse;
              const aadharResponseResult = aadharResponse?.result;
              const aadharResponseResultSplitAddress = aadharResponseResult?.splitAddress;

              if (formValues.full_address === '' && aadharResponseResult?.address !== '') {
                  removeHighlightedFields(); 
                  setFormValues({
                    ...formValues,
                    full_address: aadharResponseResult.address,
                    pin: aadharResponseResult.pincode,
                    city: aadharResponseResultSplitAddress.dist,
                    district: aadharResponseResultSplitAddress.dist    
                  });
 
                  if(aadharResponseResult.address!==''){
                    setIsAddressStyled(true);
                  }
  
                  if(aadharResponseResultSplitAddress.dist !==''){
                    setIsCityStyled(true);
                  }

                  if(aadharResponseResultSplitAddress.dist !==''){
                    setIsDistrictStyled(true);
                  }
                  
                  if(aadharResponseResult.pincode !==''){
                    setIsPinStyled(true);
                  } 
              }
 
            }
          }

          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "aadhar_validation_id"
            ) &&
            result.data.data.aadhar_validation_id !== ""
          ) {
            setAadharValidationID(result.data.data.aadhar_validation_id);
          }
          setPreloaderAadharOTPVerifyStatus(false);
          toast.success(result.data.message, {
            position: "top-right",
          });
        } else {
          setPreloaderAadharOTPVerifyStatus(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderAadharOTPVerifyStatus(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };


  const [fileInputs, setFileInputs] = useState([
        { id: 0, element: <input key={0} type='file' id='report_file_0' name='report_file_0' className='form-control' onChange={(e) => handleFileChange(e, fileInputs)} disabled={isEditableIncidentCurrentStatus || isEditableStatus} /> }
    ]);

  const handleFileChange = (e, fileInputs) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file, index) => { // Use index to assign unique id
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;

                const parts = base64Data.split(',');
                const base64WithoutHeader = parts[1];

                const extension = fileName.split('.').pop().toLowerCase();
                if (extension === 'docx' || extension === 'doc') {
                    base64Files.push({ id: selectedFiles.length + index, data: `data:application/document;base64,${base64WithoutHeader}`, name: fileName });
                } else if (extension === 'xlsx' || extension === 'xls') {
                    base64Files.push({ id: selectedFiles.length + index, data: `data:application/sheet;base64,${base64WithoutHeader}`, name: fileName });
                } else {
                    base64Files.push({ id: selectedFiles.length + index, data: base64Data, name: fileName });
                }

                if (base64Files.length === files.length) {
                    setSelectedFiles([...selectedFiles, ...base64Files]);
                }
            };
            reader.readAsDataURL(file);
        });
    };  

    const maskAadharNumber = (value) => {
      if (!value) return value;
      const str = String(value);
      if (str.length <= 4) return str; // safety check
      return "x".repeat(str.length - 4) + str.slice(-4);
    };

    const isAadharVerified = aadharOTPSentStatus === "2" || aadharVerifiedStatus === true || aadharDigiVerifiedByName !== "";

  const fetchModule = useCallback(() => {
          const defaultInput = fileInputs[0]; // Save the default input
          setFileInputs([defaultInput]);
          
          const params = new URLSearchParams(location.search); 
          setShowIncidentReporte(false);
        
          if (id !== undefined ) { 
              const decodedId = atob(id);
              setIncidentReportId(decodedId);
              const obj = { 'start': '0', 'length': config.MAX_RECORDS, 'incident_report_id': decodedId, "api_calling_module" : "lead" };
              const requestData = encryptData(obj);
              const response = actions.getModuleDataWithcomments(requestData);
              response.then((result) => {
                  // console.log("Promise resolved -  incidentReporteData list:", result);
                  if (result.data.success === 1) {
                      const incidentReporte = result.data.data;
                     
                      setIncidentReport(incidentReporte?.incident_report);
                      setComment(incidentReporte?.all_activity);
                      setCommentCount((incidentReporte?.all_activity || []).length);
  
                      setCreatedBy(`${incidentReporte?.incident_report?.[0]?.createdByName} on ${incidentReporte?.incident_report?.[0]?.created_date}`);
                      setincIdentCategory(`${incidentReporte?.incident_report?.[0]?.incidentCategory}`);
                      setDescription(`${incidentReporte?.incident_report?.[0]?.description}`);
                      setTypeTopic(`${incidentReporte?.incident_report?.[0]?.type_topic}`);
                      setTicketNumber(`${incidentReporte?.incident_report?.[0]?.id}`);
  
                      setPhoneNumber(`${incidentReporte?.incident_report?.[0]?.mobile}`);
                      setName(`${incidentReporte?.incident_report?.[0]?.name}`);
                      setEmail(`${incidentReporte?.incident_report?.[0]?.email}`);
                      setAddress(`${incidentReporte?.incident_report?.[0]?.address}`);
                      setPriority(`${incidentReporte?.incident_report?.[0]?.priorityType}`);
                      setIncidetFiles(`${incidentReporte?.incident_report?.[0]?.files}`);
  
                      setAssignedUser(`${incidentReporte?.incident_report?.[0]?.assigned_user}`);
                      handleChangeAssignedGroup({ target: { value: incidentReporte?.incident_report?.[0]?.assigned_group } }, 'selectedUser');
  
                      setValue("assigned_group", incidentReporte?.incident_report?.[0]?.assigned_group);
                      // setValue("assigned_user", );
  
                      const assignToString = incidentReporte?.incident_report?.[0]?.assigned_user || '';
                      const assignToArray = assignToString.split(',');
                      setSelectedAssignTo(assignToArray);
                      setNumbersArray(incidentReporte?.incident_report?.[0]?.selected_assigned_user);
  
                      setSelectedAssignedUser(incidentReporte?.incident_report?.[0]?.assigned_user);
  
                      const checkListsResults = incidentReporte?.incident_report?.[0]?.all_checklists || [];
                      const checkListsResultsArr = Object.keys(checkListsResults).map((key) => checkListsResults[key]);
                      setAllIncidentCheckLists(checkListsResultsArr);
  
                      setAllIncidentTask(incidentReporte?.incident_task);
                     
                      setDueDate(`${incidentReporte?.incident_report?.[0]?.dueDate}`);
                      setIncidentCreatedBy(`${incidentReporte?.incident_report?.[0]?.created_by}`);
                      setIncidentCurrentStatus(`${incidentReporte?.incident_report?.[0]?.statusName}`);
  
                      if(Object.prototype.hasOwnProperty.call(incidentReporte, 'childIds') && incidentReporte?.childIds !==''){
                          setAllchildIds(incidentReporte?.childIds);
                      }
  
                      setShowIncidentReporte(true);
                  } else {
                      setShowIncidentReporte(true);
                  }
              }).catch((error) => {
                  console.error("Promise rejected -  incidentReporteData list:", error);
              });
          } 
  
      }, [incidentReportId, setValue, setIncidentReport, setComment, setShowIncidentReporte, setCreatedBy, setincIdentCategory, setDescription, setTicketNumber, setAssignedUser, setSelectedAssignedUser, setPhoneNumber, setName, setEmail, setAddress, setPriority, setIncidetFiles, setCommentCount, setTypeTopic, setAllIncidentCheckLists, setAllIncidentTask, setDueDate, setIncidentCreatedBy, setIncidentCurrentStatus]);

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }



  return (
    <>
      <Helmet>
        <title> {leadId === "" ? "Add" : "Edit"} Lead | Ckers </title>
      </Helmet>
      <Container>
        <div className="row align-items-center">

           { leadFiAddressNotifications?.message && ( 
              <>
                <div className="col-md-12"> 
                          <div style={{
                                  border: "1px solid rgb(250 156 151)",
                                  padding: "10px 20px",
                                  width: "auto",
                                  borderRadius: "5px",
                                  background: "rgb(255 209 209)",
                                  fontSize: "11px",
                                  marginBottom: "10px"
                              }}
                            dangerouslySetInnerHTML={{
                              __html: leadFiAddressNotifications?.message.replace(
                                /\n/g,
                                ""
                              ),
                            }}
                          />
                  </div>       
              </> 
            )}

          <div className="col-md-6">&nbsp;</div>
          <div className="col-md-6 flex-container">
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                window.open(
                  "https://www.loom.com/share/7e08b5c9445740e49a6deb1db65e338f?sid=2cd51dae-4278-4167-8309-c397108f35eb",
                  "_blank"
                )
              }
            >
              Tutorial Video 1
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                window.open(
                  "https://www.loom.com/share/57212dd4839b40f690fc7f18f8ace8c2?sid=62d15608-140a-4a2a-98ad-b0bd170c9a4d",
                  "_blank"
                )
              }
            >
              Tutorial Video 2
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                window.open(
                  "https://www.loom.com/share/6c8b84a8440c4e9e88dbd02f2057ae90?sid=c09d945b-ad2e-4680-919d-25ad937868a7",
                  "_blank"
                )
              }
            >
              Tutorial Video 3
            </Button>
          </div>

          <div className="col-md-6">
            <Typography variant="h4" sx={{ mb: 5 }}>
              {leadId === "" ? (
                "Add Lead"
              ) : (
                <>
                  {pageHeading}
                  
                  <br />
                  <Typography variant="body3" sx={{ color: "red" }}>
                    {isExternalUserContent}
                  </Typography>
                
                  { fastTrackCaseStatus && ( 
                    <span className="blinkClass-star" style={{ color:   "rgb(63 239 229)"  }}>Fast Track Case </span>
                  )} 
                  { fastTrackCaseStatus && greenChannelCaseStatus && ( <> <span className="blinkClass-star" > + </span> </>)} 
                  { greenChannelCaseStatus && ( 
                    <> 
                    <span className="blinkClass-star" >Green Channel Case </span>
                    </>
                  )}
                 
                  
                </>
              )}
            </Typography>
          </div> 

          <div
            className={!showLeadDetails ? "col-md-6 hide " : "col-md-6 show"}
          >
            {userRoleType !== "Credit" ? (
              showNote !== "" ? (
                <div className="text-end">{showNote}</div>
              ) : showNoteNoteByCredit !== "" ? (
                <>
                  <div
                    className="text-end"
                    role="button"
                    tabIndex={0}
                    onClick={() => onShowHistoryClickAction()}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === "Space") {
                        onShowHistoryClickAction();
                      }
                    }}
                    disabled={leadId === ""}
                  >
                    {showNoteNoteByCredit}
                    <i className="bi bi-eye">&nbsp;</i>
                  </div>
                  {isExternalUser ||
                    (!isSentToCredit && (
                      <div>
                        <div className="col-md-12 py-2">
                          <div className="form-group text-end mb-2">
                            {leadFieldPermissions?.send_to_credit_permission && (
                            <button
                              className="btn btn-primary"
                              onClick={() => handleCredit('sent_to_credit')}
                              disabled={
                                leadId === "" || leadStatusFlag === true
                              }
                            >
                              {" "}
                              Send To Credit{" "}
                            </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <div>
                  {!isExternalUser &&
                    leadFieldPermissions?.send_to_credit_permission && (
                      <>
                        <div className="col-md-12 py-2">
                          <div className="form-group text-end mb-2">
                            <button
                              className="btn btn-primary"
                              onClick={() => handleCredit('sent_to_credit')}
                              disabled={leadId === "" || leadStatusFlag === true}
                            >
                              Send To Credit
                            </button>
                          </div>
                        </div>
                      </>
                  )}
                </div>
              )
            ) : (
              <></>
            )}
 
            { /* Sent for CAM preparation : start */ }
              {(userRoleType === "CPA" || userRoleType === "Manager" ) ? (
              showSentForCAMPreparationNote !== "" ? (
                <div className="text-end">{showSentForCAMPreparationNote}</div>
              ) : ( 
                <div>
                  {!isExternalUser && (
                    <>
                      <div className="col-md-12 py-2">
                        <div className="form-group text-end mb-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => handleCredit('sent_for_cam_preparation')}
                            disabled={leadId === "" || leadStatusFlag === true}
                          >
                            {" "}
                            Sent for CAM Preparation{" "}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )
            ) : ( 
              showSentForCAMPreparationNote !== "" && (
                <div className="text-end">{showSentForCAMPreparationNote}</div>
               )
            )}
            { /* Sent for CAM preparation End */ }


            { /* Sent Review For Do  : start */ }
              {(userRoleType === "CPA" || userRoleType === "Manager" || userRoleType === "Credit") ? (
              showSentReviewForDoNote !== "" ? (
                <div className="text-end">{showSentReviewForDoNote}</div>
              ) : ( 
                <div>
                  {!isExternalUser && (
                    <>
                      <div className="col-md-12 py-2">
                        <div className="form-group text-end mb-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => handleCredit('review_for_do')}
                            disabled={leadId === "" || leadStatusFlag === true}
                          >
                            {" "}
                            Review For DO{" "}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )
            ) : ( 
              showSentReviewForDoNote !== "" && (
                <div className="text-end">{showSentReviewForDoNote}</div>
               )
            )}
            { /* Sent Review For Do  End */ }

            { /* Sent for DO : start */ }
              {(userRoleType === "User" ) ? (
              showSentForDONote !== "" ? (
                <div className="text-end">{showSentForDONote}</div>
              ) : ( 
                <div>
                  {!isExternalUser && isSentForDO==='yes' && (
                    <>
                      <div className="col-md-12 py-2">
                        <div className="form-group text-end mb-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => handleCredit('sent_for_do')}
                            disabled={leadId === "" || leadStatusFlag === true}
                          >
                            {" "}
                            Sent for DO{" "}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )
            ) : ( 
              showSentForDONote !== "" && (
                <div className="text-end">{showSentForDONote}</div>
               )
            )}
            { /* Sent for DO End */ }


          </div>

           { markLeadAsFastTrack?.message && ( 
                  <>
                    <div className="col-md-6"> 
                              <div style={{
                                      border: "2px solid #ffc720",
                                      padding: "5px 20px",
                                      width: "auto",
                                      borderRadius: "5px",
                                      background: "#ffeaaa",
                                      float: "left",
                                      fontSize: "11px"
                                  }}
                                dangerouslySetInnerHTML={{
                                  __html: markLeadAsFastTrack?.message.replace(
                                    /\n/g,
                                    ""
                                  ),
                                }}
                              />
                      </div>       
                  </> 
                )}

                 { markLeadAsGreenChannel?.message && ( 
                  <>
                    <div className="col-md-6"> 
                              <div style={{
                                      border: "2px solid #ffe920",
                                      padding: "5px 20px",
                                      width: "auto",
                                      borderRadius: "5px",
                                      background: "#ffddaa",
                                      float: "right",
                                      fontSize: "11px"
                                  }}
                                dangerouslySetInnerHTML={{
                                  __html: markLeadAsGreenChannel?.message.replace(
                                    /\n/g,
                                    ""
                                  ),
                                }}
                              />
                      </div>       
                  </> 
                )}
        </div>

        <div id="main-wrap" className="mb-5">
          <ul className="nav nav-pills mb-4" id="pills-tab" role="tablist">
            <li className="nav-item mb-2" role="presentation">
              <button
                className={
                  activeTabName === "basic" ? "nav-link active" : "nav-link"
                }
                id="pills-lead-info-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-lead-info"
                type="button"
                role="tab"
                aria-controls="pills-lead-info"
                aria-selected={activeTabName === "basic" ? "true" : "false"}
                onClick={backToLeadHandler}
              >
                Lead Information
              </button>
            </li>

            {/* {!isExternalUser && ( */}
              {/* <> */}
                {leadFieldPermissions?.lead_checklist?.view && (
                  <li
                    className=" nav-item mb-2"
                    role="presentation"
                    title={
                      leadId === ""
                        ? "Please enter the basic lead informations."
                        : ""
                    }
                  >
                    <button
                      className={
                        activeTab === "checklist" ? "nav-link active" : "nav-link"
                      }
                      id="pills-lead-check-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-lead-check"
                      type="button"
                      role="tab"
                      aria-controls="pills-lead-check"
                      aria-selected={activeTab === "checklist" ? "true" : "false"}
                      disabled={leadId === ""}
                      onClick={() => backToLeadHandler("checklist")}
                    >
                      Lead Checklist
                    </button>
                  </li>
                )}
              {/* </> */}
            {/* )} */}
            {/* <li className=" nav-item mb-2" role="presentation" title={leadId === '' ? "Please enter the basic lead informations." : ""}>
                            <button className="nav-link active" id="pills-communication-tab" data-bs-toggle="pill" data-bs-target="#pills-communication" type="button" role="tab" aria-controls="pills-communication" aria-selected="true"                       
                            >Communication</button>
                        </li> */}

            {isExternalUser && (
              <>
                <li
                  className=" nav-item mb-2"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className={
                      activeTabName === "communication" &&
                      activeTab === "document"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-document-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-document"
                    type="button"
                    role="tab"
                    aria-controls="pills-document"
                    aria-selected={
                      activeTabName === "document" ? "true" : "false"
                    }
                    disabled={leadId === ""}
                    onClick={() => backToLeadHandler("document")}
                  >
                    Document
                  </button>
                </li>
              </>
            )}

            {!isExternalUser && (
              <>
                {leadFieldPermissions?.scorecard?.view && (
                <li
                  className=" nav-item mb-2"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className={
                      activeTabName === "communication" &&
                      activeTab === "scorecard"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-dynamic-lead-score-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-dynamic-lead-score"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "score" ? "true" : "false"}
                    disabled={leadId === ""}
                    onClick={() => backToLeadHandler("scorecard")}
                  >
                    Scorecard
                  </button>
                </li>
                )}

               {!isExternalUser && (
                  <>
                    {leadFieldPermissions?.fi_upload?.view && (
                      <li className="nav-item" role="presentation">
                        <button
                          className={
                            activeTab === "fi_checklist"
                              ? "nav-link active"
                              : "nav-link"
                          }
                          id="pills-lead-fi-check-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-lead-fi-check"
                          type="button"
                          role="tab"
                          aria-controls="pills-lead-fi-check"
                          aria-selected={
                            activeTab === "fi_checklist" ? "true" : "false"
                          }
                          disabled={leadId === "" || mobileReadOnly === false}
                          onClick={() => backToLeadHandler("fi_checklist")}
                        >
                          FI
                        </button>
                      </li>
                    )}
                  </>
                )}

{!isExternalUser && vivritiChecklistStatus && (
        <>
        {leadFieldPermissions?.vivriti_checklist?.view && (
          <li
            className=" nav-item mb-2"
            role="presentation"
            title={
              leadId === ""  || mobileReadOnly === false
                ? "Please enter the basic lead informations and bureau."
                : ""
            }
          >
            <button
              className={
                activeTab === "vivriti_checklist"
                  ? "nav-link active"
                  : "nav-link"
              }
              id="pills-lead-vivriti-check-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-lead-vivriti-check"
              type="button"
              role="tab"
              aria-controls="pills-lead-vivriti-check"
              aria-selected={
                activeTab === "vivriti_checklist" ? "true" : "false"
              }
              disabled={leadId === "" || mobileReadOnly === false }
              onClick={() => backToLeadHandler("vivriti_checklist")}
            >
              Vivriti Checklist
            </button>
          </li>
        )}
        </>
      )}

        {leadFieldPermissions?.fi_details?.view && (
                <li
                  className=" nav-item mb-2"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className={
                      activeTabName === "communication" &&
                      activeTab === "fi_details"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-dynamic-fi-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-dynamic-fi-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "fi" ? "true" : "false"}
                    disabled={leadId === ""}
                    onClick={() => backToLeadHandler("fi_details")}
                  >
                    FI Details
                  </button>
                </li>
        )}
           
             {leadFieldPermissions?.bank_statement?.view && (
                <li
                  className=" nav-item mb-2"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className={
                      activeTabName === "communication" &&
                      activeTab === "bank_statement"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-bank_statement_tab-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-bank_statement_tab-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={
                      activeTabName === "bank_statement" ? "true" : "false"
                    }
                    disabled={leadId === ""}
                    onClick={() => backToLeadHandler("bank_statement")}
                  >
                    Bank Statement
                  </button>
                </li>
             )}
              { /*  {userRoleType !== "User" && ( */ }
              {leadFieldPermissions?.cam?.view && (
                  <li
                    className=" nav-item mb-2"
                    role="presentation"
                    title={
                      leadId === ""
                        ? "Please enter the basic lead informations."
                        : ""
                    }
                  >
                    <button
                      className={
                        activeTab === "cam" ? "nav-link active" : "nav-link"
                      }
                      id="pills-cam_tab-details-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-cam_tab-details"
                      type="button"
                      role="tab"
                      aria-controls="pills-score"
                      aria-selected={activeTabName === "cam" ? "true" : "false"}
                      disabled={leadId === ""}
                      onClick={() => backToLeadHandler("cam")}
                    >
                      CAM
                    </button>
                  </li>
              )}
               { /* )} */ }

                {leadFieldPermissions?.additional_documents?.view && (
                  <li
                    className="nav-item mb-2"
                    role="presentation"
                    title={
                      leadId === ""
                        ? "Please enter the basic lead informations."
                        : ""
                    }
                  >
                    <button
                      className={
                        activeTabName === "communication" &&
                        activeTab === "additional_documents"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      id="pills-additional_documents-details-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-additional_documents-details"
                      type="button"
                      role="tab"
                      aria-controls="pills-score"
                      aria-selected={activeTabName === "fi" ? "true" : "false"}
                      disabled={leadId === ""}
                      onClick={() => backToLeadHandler("additional_documents")}
                    >
                      Additional Documents
                    </button>
                  </li>
                )}

               {leadFieldPermissions?.sanction_letter?.view && (
                  <li
                    className="nav-item mb-2 d-none-"
                    role="presentation"
                  >
                    <button
                      className={
                        activeTabName === "communication" &&
                        activeTab === "sanction_letter"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      id="pills-sanction_letter-details-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-sanction_letter-details"
                      type="button"
                      role="tab"
                      aria-controls="pills-score"
                      aria-selected={activeTabName === "sanction_letter"}
                      disabled={leadId === ""}
                      onClick={() => backToLeadHandler("sanction_letter")}
                    >
                      Sanction Letter
                    </button>
                  </li>
                )}
 
              {leadFieldPermissions?.delivery_order?.view && (
                <li
                  className=" nav-item mb-2 d-none-"
                  role="presentation"
                 /* title={
                    userRoleType === "Credit" || userRoleType === "Superadmin"
                      ? "Enabled for Credit and Superadmin"
                      : camLatestStatus !== "1"
                      ? "Please enter the basic lead information and ensure CAM is approved."
                      : ""
                  } */
                >
                  <button
                    className={
                      activeTabName === "communication" && activeTab === "delivery_order"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-delivery_order-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-delivery_order-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "delivery_order"}
                    disabled={leadId === ""}
                   /* disabled={
                      !(userRoleType === "Credit" || userRoleType === "Superadmin") &&
                      camLatestStatus !== "1"
                    } */
                    onClick={() => backToLeadHandler("delivery_order")}
                  >
                    Delivery Order
                  </button>
                </li>
              )}

              {leadFieldPermissions?.disbursement_stage?.view && (
                <li
                  className=" nav-item mb-2 d-none-"
                  role="presentation"
                 /* title={
                    userRoleType === "Credit" || userRoleType === "Superadmin"
                      ? "Enabled for Credit and Superadmin"
                      : camLatestStatus !== "1"
                      ? "Please enter the basic lead information and ensure CAM is approved."
                      : ""
                  } */
                >
                  <button
                    className={
                      activeTabName === "communication" && activeTab === "disbursement_stage"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-delivery_order-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-disbursement_stage-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "disbursement_stage"}
                    disabled={leadId === ""}
                   /* disabled={
                      !(userRoleType === "Credit" || userRoleType === "Superadmin") &&
                      camLatestStatus !== "1"
                    } */
                    onClick={() => backToLeadHandler("disbursement_stage")}
                  >
                    Disbursement Stage 
                  </button>
                </li>
              )}
         
              {leadFieldPermissions?.pdd?.view && (
                <li
                  className=" nav-item mb-2 d-none-"
                  role="presentation"
                 /* title={
                    userRoleType === "Credit" || userRoleType === "Superadmin"
                      ? "Enabled for Credit and Superadmin"
                      : camLatestStatus !== "1"
                      ? "Please enter the basic lead information and ensure CAM is approved."
                      : ""
                  } */
                >
                  <button
                    className={
                      activeTabName === "communication" && activeTab === "post_disbursal_document"
                        ? "nav-link active d-none-"
                        : "nav-link d-none-"
                    }
                    id="pills-delivery_order-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-post_disbursal_document-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "post_disbursal_document"}
                    disabled={leadId === ""}
                   /* disabled={
                      !(userRoleType === "Credit" || userRoleType === "Superadmin") &&
                      camLatestStatus !== "1"
                    } */
                    onClick={() => backToLeadHandler("post_disbursal_document")}
                  >
                    Post Disbursal Document  
                  </button>   
                   </li> 
              )}

                {!isExternalUser && reFiChecklistStatus &&  ( userRoleType === "Super Admin" ||userRoleType === "Superadmin" || userRoleType === "Credit Head" || userRoleType === "Regional Sales Manager" || userRoleType === "Regional Head" || userRoleType === "Cluster Head"  ) && (
                <>
                  <li
                    className=" nav-item mb-2"
                    role="presentation"
                    title={
                      leadId === ""  || mobileReadOnly === false
                        ? "Please enter the basic lead informations and bureau."
                        : ""
                    }
                  >
                    <button
                      className={
                        activeTab === "re_fi_checklist"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      id="pills-lead-re_fi-check-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-lead-re_fi-check"
                      type="button"
                      role="tab"
                      aria-controls="pills-lead-re_fi-check"
                      aria-selected={
                        activeTab === "re_fi_checklist" ? "true" : "false"
                      }
                      disabled={leadId === "" || mobileReadOnly === false }
                      onClick={() => backToLeadHandler("re_fi_checklist")}
                    >
                      Re-FI
                    </button>
                  </li>
                </>
              )}
 
              {leadFieldPermissions?.application_details?.view && (
                <li
                  className=" nav-item mb-2 d-none-"
                  role="presentation"
                 
                >
                  <button
                    className={
                      activeTabName === "communication" && activeTab === "application_details"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-application_details-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-application_details-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "application_details"}
                    disabled={leadId === ""}
                   /* disabled={
                      !(userRoleType === "Credit" || userRoleType === "Superadmin") &&
                      camLatestStatus !== "1"
                    } */
                    onClick={() => backToLeadHandler("application_details")}
                  >
                    Application Details
                  </button>
                </li>
              )}

                <li
                  className=" nav-item mb-2 d-none"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className={
                      activeTabName === "communication" &&
                      activeTab === "agreement"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-agreement-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-agreement-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "fi" ? "true" : "false"}
                    disabled={leadId === ""}
                    onClick={() => backToLeadHandler("agreement")}
                  >
                    Agreement
                  </button>
                </li>
                 {leadFieldPermissions?.delivery_order?.view && (
                <li
                  className=" nav-item mb-2 d-none"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className={
                      activeTabName === "communication" &&
                      activeTab === "delivery_order"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-bank_statement-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-bank_statement-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "fi" ? "true" : "false"}
                    disabled={leadId === ""}
                    onClick={() => backToLeadHandler("delivery_order")}
                  >
                    Delivery Order
                  </button>
                </li>
                 )}

                {leadFieldPermissions?.activity?.view && (
                  <li
                    className=" nav-item mb-2"
                    role="presentation"
                    title={
                      leadId === ""
                        ? "Please enter the basic lead informations."
                        : ""
                    }
                  >
                    <button
                      className={
                        activeTabName === "communication"  &&
                        activeTab === "communication"
                          ? "nav-link active"
                          : "nav-link"
                      }
                      id="pills-communication-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-communication"
                      type="button"
                      role="tab"
                      aria-controls="pills-communication"
                      aria-selected={
                        activeTabName === "communication" ? "true" : "false"
                      }
                      disabled={leadId === ""}
                      onClick={() => backToLeadHandler("communication")}
                    >
                      Activity
                    </button>
                  </li>
                )}


                 {/* {userRoleType === 'Credit' || userRoleType === 'Superadmin'  && (  
                            <li className=" nav-item mb-2" role="presentation" title={leadId === '' ? "Please enter the basic lead informations." : ""}>
                                <button className={activeTabName === 'communication' && activeTab === 'tvr' ? "nav-link active" : "nav-link"} id="pills-tvr-tab" data-bs-toggle="pill" data-bs-target="#pills-tvr" type="button" role="tab" aria-controls="pills-tvr" aria-selected={activeTabName === 'tvr' ? "true" : "false"}
                                    disabled={leadId === ''} onClick={() => backToLeadHandler('tvr')}>TVR</button>
                            </li>
                            )} */}
                            

                            { leadInfo?.data?.length > 0 && senttoCreditStatus && (
                            (userRoleType === 'Credit' || userRoleType === "Super Admin" || userRoleType === 'Superadmin' ) && (
                                <li className=" nav-item mb-2" role="presentation" title={leadId === '' ? "Please enter the basic lead informations." : ""}>
                                <button 
                                    className={activeTabName === 'communication' && activeTab === 'tvr' ? "nav-link active" : "nav-link"} 
                                    id="pills-tvr-tab" 
                                    data-bs-toggle="pill" 
                                    data-bs-target="#pills-tvr" 
                                    type="button" 
                                    role="tab" 
                                    aria-controls="pills-tvr" 
                                    aria-selected={activeTabName === 'tvr' ? "true" : "false"}
                                    disabled={leadId === ''}
                                    onClick={() => backToLeadHandler('tvr')}
                                >
                                    TVR
                                </button>
                                </li>
                            )
                            )}
                          

                <li
                  className=" nav-item mb-2 d-none"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className="nav-link"
                    id="pills-activity-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-activity"
                    type="button"
                    role="tab"
                    aria-controls="pills-activity"
                    aria-selected={
                      activeTabName === "activity" ? "true" : "false"
                    }
                    disabled={leadId === ""}
                    onClick={backToLeadHandler}
                  >
                    Activity
                  </button>
                </li>

                <li
                  className=" nav-item mb-2 d-none"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className="nav-link"
                    id="pills-shipment-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-shipment"
                    type="button"
                    role="tab"
                    aria-controls="pills-shipment"
                    aria-selected={
                      activeTabName === "shipment" ? "true" : "false"
                    }
                    disabled={leadId === ""}
                    onClick={backToLeadHandler}
                  >
                    Shipment
                  </button>
                </li>

                <li
                  className=" nav-item mb-2 d-none"
                  role="presentation"
                  title={
                    leadId === ""
                      ? "Please enter the basic lead informations."
                      : ""
                  }
                >
                  <button
                    className="nav-link"
                    id="pills-reference-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-reference-check"
                    type="button"
                    role="tab"
                    aria-controls="pills-upload-reference-check"
                    aria-selected={
                      activeTabName === "reference" ? "true" : "false"
                    }
                    disabled={leadId === ""}
                    onClick={backToLeadHandler}
                  >
                    Reference
                  </button>
                </li>

                {/* <li className=" nav-item mb-2 d-none" role="presentation" title={leadId === '' ? "Please enter the basic lead informations." : ""}>
                            <button className="nav-link" id="pills-incident-tab" data-bs-toggle="pill" data-bs-target="#pills-incident-check" type="button" role="tab" aria-controls="pills-upload-incident-check" aria-selected="false"
                                disabled={leadId === ''}
                                onClick={backToLeadHandler}>Incident Reporting</button>
                        </li> */}
              </>
            )}

              { /* {userRoleType === 'Superadmin'  && (  */ }
              {leadFieldPermissions?.case_management?.view && (
             <li
                  className=" nav-item mb-2  float-right"
                  role="presentation"
                 
                >
                  <button
                    className={
                      activeTabName === "communication" && activeTab === "case_management_system"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-case_management_system-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-case_management_system-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "case_management_system"}
                    disabled={leadId === ""}
                   /* disabled={
                      !(userRoleType === "Credit" || userRoleType === "Superadmin") &&
                      camLatestStatus !== "1"
                    } */
                    onClick={() => backToLeadHandler("case_management_system")}
                  >
                    Case Management
                  </button>
                </li>
              )}
           { /* )} */ }


           { /* {userRoleType === 'Superadmin'  && (  */ }
           {leadFieldPermissions?.tasks?.view && (
             <li
                  className=" nav-item mb-2  float-right"
                  role="presentation"
                 
                >
                  <button
                    className={
                      activeTabName === "communication" && activeTab === "tasks"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    id="pills-tasks-details-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-tasks-details"
                    type="button"
                    role="tab"
                    aria-controls="pills-score"
                    aria-selected={activeTabName === "tasks"}
                    disabled={leadId === ""}
                   /* disabled={
                      !(userRoleType === "Credit" || userRoleType === "Superadmin") &&
                      camLatestStatus !== "1"
                    } */
                    onClick={() => backToLeadHandler("tasks")}
                  >
                   Tasks
                  </button>
                </li>
           )}
           { /* )} */ }

           {leadFieldPermissions?.communication?.view && (
           <li className="nav-item mb-2 float-right" role="presentation">
              <button
                className={
                  activeTabName === "communication" && activeTab === "cam_communication"
                    ? "nav-link active"
                    : "nav-link"
                }
                id="pills-cam_communication-details-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-cam_communication-details"
                type="button"
                role="tab"
                aria-selected={activeTab === "cam_communication"}
                disabled={leadId === ""}
                onClick={() => backToLeadHandler("cam_communication")}
              >
                Communication
              </button>
            </li>
           )}

          {leadFieldPermissions?.call_log?.view && (
            <li className="nav-item mb-2 float-right" role="presentation">
              <button
                className={
                  activeTabName === "communication" && activeTab === "call_to_lead"
                    ? "nav-link active"
                    : "nav-link"
                }
                id="pills-call_to_lead-details-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-call_to_lead-details"
                type="button"
                role="tab"
                aria-selected={activeTab === "call_to_lead"}
                disabled={leadId === ""}
                onClick={() => backToLeadHandler("call_to_lead")}
              >
                Call Log
              </button>
            </li>
          )}
           {leadFieldPermissions?.beat_plan?.view && (
            <li className="nav-item mb-2 float-right" role="presentation">
              <button
                className={
                  activeTabName === "communication" && activeTab === "beat_plan"
                    ? "nav-link active"
                    : "nav-link"
                }
                id="pills-beat_plan-details-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-beat_plan-details"
                type="button"
                role="tab"
                aria-selected={activeTab === "beat_plan"}
                disabled={leadId === ""}
                onClick={() => backToLeadHandler("beat_plan")}
              >
                Beat Plan
              </button>
            </li>
           )}


         {formValues?.AgreementNo !== '' && (
            leadFieldPermissions?.beat_plan?.view && (
              <li
                className="nav-item mb-2 float-right"
                role="presentation"
              >
                <button
                  className={
                    activeTabName === "communication" &&
                    activeTab === "repayment_schedule_tab"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  id="pills-repayment_schedule_tab-details-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-repayment_schedule_tab-details"
                  type="button"
                  role="tab"
                  aria-controls="pills-score"
                  aria-selected={activeTabName === "repayment_schedule_tab"}
                  disabled={leadId === ""}
                  onClick={() => backToLeadHandler("repayment_schedule_tab")}
                >
                  Repayment Schedule
                </button>
              </li>
            )
          )}

            { /* Enable versioning dropdown if case has multiple SL and DO copies */ }
            { ( sanctionLetterVersioningArr.length > 0 || deliveryOrderVersioningArr.length > 0 ) && (
              <>
            <li>
              <div><b>Saved Sanction Letter</b> </div>
              <select
              id='version_id_sl'
              name='version_id_sl'
              className="form-select blink-dropdown"
              onChange={(event) => handleSLDOVersioningChange(event,'sl')}
              ref={selectRefSL}
              >
              <option value="">Select SL Versioning</option>
              {sanctionLetterVersioningArr.length > 0 &&
                sanctionLetterVersioningArr.map((option, index) => (
                  <option key={`sanction-${option.id}`} value={option.id}>
                    Sanction Letter (Created On : {formatDateTimeForValue(option.created_at)})
                  </option>
                ))} 
              </select>
            </li>
 

            </>
            )}

            { ( deliveryOrderVersioningArr.length > 0) && (
              <> 
            <li className="pl-2">
              <div><b>Saved Delivery Order</b> </div>
              <select
              id='version_id_do'
              name='version_id_do'
              className="form-select blink-dropdown"
              onChange={(event) => handleSLDOVersioningChange(event,'do')}
              ref={selectRefDO}
              >
              <option value="">Select DO Versioning</option> 
              {deliveryOrderVersioningArr.length > 0 &&
                deliveryOrderVersioningArr.map((option, index) => (
                  <option key={`delivery-${option.id}`} value={option.id}>
                    Delivery Order (Created On : {formatDateTimeForValue(option.created_at_do)})
                  </option>
                ))}
              </select>
            </li>

            </>
            )}

         


          </ul>

          {showHistory ? (
            <NoteHistoryPage
              props={props}
              leadId={leadId}
              setShowHistory={setShowHistory}
            />
          ) : (
            <></>
          )}

          <div
            className={!showHistory ? "tab-content show " : "tab-content hide"}
            id="pills-tabContent"
          >
            <div
              className={
                activeTabName === "basic"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-lead-info"
              role="tabpanel"
              aria-labelledby="pills-lead-info-tab"
              tabIndex="0"
            >
              <ul className="nav nav-pills mb-4" id="pills-tab" role="tablist">
                <li className=" nav-item mb-2" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-basic-info-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-basic-info"
                    type="button"
                    role="tab"
                    aria-controls="pills-basic-info"
                    aria-selected="true"
                  >
                    Basic Information
                  </button>
                </li>

                {leadFieldPermissions?.bureau?.view && (
                    <li className="nav-item mb-2" role="presentation">
                      <button
                        className="nav-link"
                        id="pills-summary-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-summary"
                        type="button"
                        role="tab"
                        aria-controls="pills-summary"
                        aria-selected={leadId === "" ? "true" : "false"}
                        disabled={leadId === ""}
                      >
                        Summary
                      </button>
                    </li>
                  )}
              </ul>
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-basic-info"
                  role="tabpanel"
                  aria-labelledby="pills-basic-info-tab"
                  tabIndex="0"
                >
                  <div className="accordion first-level" id="accordionLI">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#LI-1"
                          aria-expanded="true"
                          aria-controls="LI-1"
                          role="tab"
                          aria-selected={leadId === "" ? "true" : "false"}
                          disabled={leadId === ""}
                        >
                          Basic Information
                        </button>
                      </h2>
                      <div
                        id="LI-1"
                        className="accordion-collapse collapse show"
                        data-bs-parent="#accordionLI"
                      >
                        <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                          <h5 className="fw-bold mb-3"> Basic Information </h5>

                          {/* Duplicate Case Label */}
                          {isDuplicate && (
                            <div className="alert alert-warning d-flex justify-content-between align-items-center mb-3" role="alert" style={{ backgroundColor: '#fff3cd', border: '1px solid #ffc107' }}>
                              <div>
                                <strong>Duplicate Case</strong>
                                <span className="ms-2" style={{ fontSize: '0.9em' }}>
                                  (Linked to Lead ID: <strong>{duplicateLeadId}</strong>)
                                </span>
                              </div>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={handleRemoveDuplicateCase}
                                aria-label="Close"
                                title="Remove duplicate case"
                              >&nbsp;</button>
                            </div>
                          )}

                          {/* Validation Alert Section - Only show when not in duplicate mode */}
                          {!isDuplicate && (panDuplicateRecords.length > 0 || phoneDuplicateRecords.length > 0) && (
                            <div className="alert alert-danger alert-dismissible fade show mb-3" role="alert">
                              <strong>Duplicate Entry Detected!</strong>
                              <div className="mt-2">
                                {/* Display PAN Duplicate Records */}
                                {panDuplicateRecords.map((record, index) => (
                                  <div key={`pan-${index}`} className="d-flex justify-content-between align-items-center mb-2 pb-2" style={{ borderBottom: index < panDuplicateRecords.length - 1 ? '1px solid #f8d7da' : 'none' }}>
                                    <span>
                                      <strong>{record.section_type}</strong> already exists in the system. Lead ID: <strong>{record.lead_id}</strong>
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary ms-2"
                                      onClick={() => handleUseDuplicateRecord(record)}
                                      style={{ minWidth: '60px' }}
                                    >
                                      Use
                                    </button>
                                  </div>
                                ))}

                                {/* Display Phone Duplicate Records */}
                                {phoneDuplicateRecords.map((record, index) => (
                                  <div key={`phone-${index}`} className="d-flex justify-content-between align-items-center mb-2 pb-2" style={{ borderBottom: index < phoneDuplicateRecords.length - 1 ? '1px solid #f8d7da' : 'none' }}>
                                    <span>
                                      <strong>{record.section_type}</strong> already exists in the system. Lead ID: <strong>{record.lead_id}</strong>
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary ms-2"
                                      onClick={() => handleUseDuplicateRecord(record)}
                                      style={{ minWidth: '60px' }}
                                    >
                                      Use
                                    </button>
                                  </div>
                                ))}
                              </div>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => {
                                  setPanDuplicateRecords([]);
                                  setPhoneDuplicateRecords([]);
                                }}
                                aria-label="Close"
                              >&nbsp;</button>
                            </div>
                          )}

                          <form onSubmit={handleSubmit(handleSubmitBasicInfo)}>
                            <div className="row">
                               
                            <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="pan">
                                    <span>PAN Card Number </span>
                                    <input
                                      type="text"
                                      id="pan"
                                      name="pan"
                                      className="form-control"
                                      {...register("pan")}
                                      value={formValues.pan}
                                      onChange={handleChange}
                                      onBlur={handlePanBlur}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true ||
                                        isBasicInfoLocked === true
                                      }
                                    />
                                  </label>
                                </div>

                                {panDetailsInfoName === "" ||
                                !isExternalUser ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-success float-right pan_fetch"
                                      onClick={() => handlePanDetails()}
                                    >
                                      {preloaderStatus && (
                                        <>
                                          <div
                                            className="spinner-border small-preloader"
                                            role="status"
                                          >
                                            <span className="visually-hidden">
                                              {" "}
                                              Loading...
                                            </span>
                                          </div>
                                        </>
                                      )}
                                      PAN Profile Details
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <div className="f-14px rounded overflow-hidden">
                                  {panDetailsInfoName !== "" ? (
                                    <div className="py-1 px-2 bg-light">
                                      {" "}
                                      <b>Name : </b> {panDetailsInfoName}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {panDetailsInfoDoB !== "" ? (
                                    <div className="pb-1 px-2 bg-light">
                                      {" "}
                                      <b>DoB : </b> {panDetailsInfoDoB}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {panDetailsInfoGender !== "" ? (
                                    <div className="pb-1 px-2 bg-light">
                                      {" "}
                                      <b>Gender : </b> {panDetailsInfoGender}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {panDetailsInfoAddress !== "" ? (
                                    <div className="pb-1 px-2 bg-light">
                                      {" "}
                                      <b>Address : </b> {panDetailsInfoAddress}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>

                              
                                {/* Aadhar  validation :start here */}
                                <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="aadhar">
                                    <span style={{ width: "auto",float: "left"}}>Aadhar Card Number <a style={{ color: "red" }}>* </a> </span>
                                  
                                  <span style={{ width: "auto",float: "right"}}> Click <a href="https://www.digilocker.gov.in/" target="_blank" rel="noopener noreferrer">here</a> to upload Aadhaar to DigiLocker</span>
                                    {/* <input
                                      type="tel"
                                      id="aadhar"
                                      name="aadhar"
                                      className="form-control"
                                      {...register("aadhar")}
                                      value={formValues.aadhar}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    /> */}
                                    <input
                                      type="tel"
                                      id="aadhar"
                                      name="aadhar"
                                      className="form-control"
                                      {...register("aadhar")}
                                      value={isAadharVerified ? maskAadharNumber(formValues.aadhar) : formValues.aadhar}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true ||
                                        isAadharVerified
                                      }
                                    />
                                  </label>
                                </div>

                                {aadharVerifiedByName === "" ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-success float-right pan_fetch d-none"
                                      onClick={() => handleAadharDetails()}
                                    >
                                      {preloaderAadharStatus && (
                                        <>
                                          <div
                                            className="spinner-border small-preloader"
                                            role="status"
                                          >
                                            <span className="visually-hidden">
                                              {" "}
                                              Loading...
                                            </span>
                                          </div>
                                        </>
                                      )}
                                      Aadhar Validation
                                    </button>
 
                                  </>
                                ) : (
                                  <></>
                                )}
                                <div className="f-14px rounded overflow-hidden d-none">
                                  {aadharVerifiedByName !== "" ? (
                                    <div className="py-1 px-2 bg-light">
                                      {" "}
                                      <b>Verified By : </b>{" "}
                                      {aadharVerifiedByName}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {aadharVerifiedDate !== "" ? (
                                    <div className="py-1 px-2 bg-light">
                                      {" "}
                                      <b>Verified On : </b> {aadharVerifiedDate}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>


                                 {aadharDigiVerifiedByName === "" ? (
                                  <> 
                                     <button
                                      type="button"
                                      className="btn btn-warning float-right pan_fetch"
                                      onClick={() => handleAadharDetailsTimbleDigiLocker()}
                                    >
                                      {preloaderAadharStatus && (
                                        <>
                                          <div
                                            className="spinner-border small-preloader"
                                            role="status"
                                          >
                                            <span className="visually-hidden">
                                              {" "}
                                              Loading...
                                            </span>
                                          </div>
                                        </>
                                      )}
                                      Aadhar Validation
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                                <div className="f-14px rounded overflow-hidden">
                                  {aadharDigiVerifiedByName !== "" ? (
                                    <div className="py-1 px-2 bg-light">
                                      {" "}
                                      <b>Verified By : </b>{" "}
                                      {aadharDigiVerifiedByName}
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  {aadharDigiVerifiedDate !== "" ? (
                                    <div className="py-1 px-2 bg-light">
                                      {" "}
                                      <b>Verified On : </b> {aadharDigiVerifiedDate}
                                    </div>
                                  ) : (
                                    <></>
                                  )}

                                  {aadharDigiAadhaarError !== "" && (
                                    <div className="py-1 px-2 text-danger"> 
                                      {aadharDigiAadhaarError} 
                                    </div>
                                  )}
                                </div>


                                {/* Aadhar  validation :end here */}

                                {!aadharVerifiedStatus &&
                                  aadharOTPSentStatus > 0 && (
                                    <>
                                      <div className="form-group d-none">
                                        <label htmlFor="aadhar_otp">
                                          <span>
                                            Enter OTP to Verify Aadhar{" "}
                                          </span>
                                          <input
                                            type="tel"
                                            id="aadhar_otp"
                                            name="aadhar_otp"
                                            className="form-control"
                                            {...register("aadhar_otp")}
                                            value={formValues.aadhar_otp}
                                            onChange={handleChange}
                                          />
                                        </label>
                                      </div>

                                      <button
                                        type="button"
                                        className="btn btn-warning float-right pan_fetch d-none"
                                        onClick={() =>
                                          handleAadharOTPVerifyDetails()
                                        }
                                      >
                                        {preloaderAadharOTPVerifyStatus && (
                                          <>
                                            <div
                                              className="spinner-border small-preloader"
                                              role="status"
                                            >
                                              <span className="visually-hidden">
                                                {" "}
                                                Loading...
                                              </span>
                                            </div>
                                          </>
                                        )}
                                        Verify
                                      </button>
                                    </>
                                  )}
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="phone">
                                    <span>
                                      Phone Number{" "}
                                      <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <input
                                      type="tel"
                                      id="phone"
                                      name="phone"
                                      className="form-control "
                                      {...register("phone")}
                                      value={formValues.phone}
                                      onChange={handleChange}
                                      onBlur={handlePhoneBlur}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true ||
                                        mobileReadOnly === true
                                      }
                                    />

                                    {!isExternalUser && (
                                      <>
                                        {phoneDetailsInfoName === "" ? (
                                          <>
                                            <button
                                              type="button"
                                              className="btn btn-success float-right validate-phone"
                                              onClick={() =>
                                                handlePhoneDetails()
                                              }
                                            >
                                              {preloaderStatusPhone && (
                                                <>
                                                  <div
                                                    className="spinner-border small-preloader"
                                                    role="status"
                                                  >
                                                    <span className="visually-hidden">
                                                      {" "}
                                                      Loading...
                                                    </span>
                                                  </div>
                                                </>
                                              )}
                                              Get Phone Number Age + UPI Handle
                                            </button>
                                          </>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    )}
                                  </label>
                                  {errors.phone && (
                                    <span className="required">
                                      {" "}
                                      This field is required.
                                    </span>
                                  )}
                                </div>

                                {!isExternalUser && (
                                  <>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: outputBefiscHtml.replace(
                                          /\n/g,
                                          "<br />"
                                        ),
                                      }}
                                    />
                                  </>
                                )}
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="final_outcome">
                                    <span>Vehicle Type</span>
                                    <select
                                      id="lead_type"
                                      className="form-select"
                                      {...register("vehicle_type")}
                                      value={formValues.vehicle_type}
                                      onChange={handleChange}
                                    >
                                      <option value="New">New</option>
                                      <option value="Used">Used</option> 
                                    </select>
                                  </label> 
                                </div>
                              </div>

                             { /* <div className="col-md-6">&nbsp;</div> */ }

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="name">
                                    <span>
                                      Name <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <input
                                      type="text"
                                      id="name"
                                      name="name"
                                      className={isNameStyled ? "styled-input form-control" : " form-control "}
                                      {...register("name")}
                                      value={formValues.name}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                  {errors.name && (
                                    <span className="required">
                                      {" "}
                                      This field is required.
                                    </span>
                                  )}
                                </div>
                              </div>
                             
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="dob">
                                    <span>Date Of Birth </span>
                                    <input
                                      type="date"
                                      id="dob"
                                      name="dob"
                                      className={isDobStyled ? "styled-input form-control" : " form-control "}
                                      {...register("dob")}
                                      value={formValues.dob}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="full_address">
                                    <span>
                                     Permanent Address <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <input
                                      type="text"
                                      id="full_address"
                                      name="full_address"
                                      className={isAddressStyled ? "styled-input form-control" : " form-control "}
                                      {...register("full_address")}
                                      value={formValues.full_address}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="city">
                                    <span>City </span>
                                    <input
                                      type="text"
                                      id="city"
                                      name="city"
                                      className={isCityStyled ? "styled-input form-control" : " form-control "}
                                      {...register("city")}
                                      value={formValues.city}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                              {leadId !== "" && (
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="communication_address">
                                    <span>
                                      Communication Address <small style={{ color: "#6c757d" }}>(Auto-filled based on FI Address)</small>
                                    </span>
                                    <input
                                      type="text"
                                      id="communication_address"
                                      name="communication_address"
                                      className="form-control"
                                      value={communicationAddress}
                                      readOnly
                                      style={{
                                        backgroundColor: "#e9ecef",
                                        color: "#495057",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </label>
                                </div>
                              </div>
                            )}
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="district">
                                    <span>District <a style={{ color: "red" }}>* </a></span>
                                    <input
                                      type="text"
                                      id="district"
                                      name="district"
                                      className={isDistrictStyled ? "styled-input form-control" : " form-control "}
                                      {...register("district")}
                                      value={formValues.district}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="lead-profile">
                                    <span>State </span>
                                    <select
                                      id="state"
                                      name="state"
                                      className="form-select"
                                      {...register("state")}
                                      value={formValues.state}
                                      onChange={handleChange}
                                      disabled={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    >
                                      <option value=""> Select State </option>
                                      {allStates.length > 0 &&
                                        allStates.map((option) => (
                                          <option value={option.state_code}>
                                            {option.state_name}
                                          </option>
                                        ))}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="pin">
                                    <span>
                                      Pincode <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <input
                                      type="number"
                                      id="pin"
                                      name="pin"
                                      className={isPinStyled ? "styled-input form-control" : " form-control "}
                                      {...register("pin")}
                                      value={formValues.pin}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
       

                              

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="email">
                                    <span>Email ID </span>
                                    <input
                                      type="email"
                                      id="email_id"
                                      name="email_id"
                                      className="form-control"
                                      {...register("email_id")}
                                      value={formValues.email_id}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>
                              
                             

                           

                              <div className="col-md-6 d-none">
                                <div className="form-group">
                                  <label htmlFor="lead-profile">
                                    <span>Address Type </span>
                                    <select
                                      id="addressTypeId"
                                      name="addressTypeId"
                                      className="form-select"
                                      {...register("addressTypeId")}
                                      value={formValues.addressTypeId}
                                      onChange={handleChange}
                                    >
                                      <option value="">
                                        {" "}
                                        Select Address Type{" "}
                                      </option>
                                      {allAddressTypes.length > 0 &&
                                        allAddressTypes.map((option) => (
                                          <option value={option.id}>
                                            {option.type_name}
                                          </option>
                                        ))}
                                    </select>
                                  </label>
                                </div>
                              </div>

                            
                            

                             
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label htmlFor="query">
                                    <span>Lead Query </span>
                                    <textarea
                                      id="query"
                                      name="query"
                                      className="form-control"
                                      {...register("query")}
                                      value={formValues.query}
                                      onChange={handleChange}
                                      readOnly={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    />
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6" id="next_action_div">
                                <div className="form-group">
                                  <label htmlFor="lead-profile">
                                    <span>
                                      Lead Profile{" "}
                                      <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <select
                                      id="lead_profile"
                                      name="lead_profile"
                                      className="form-select"
                                      {...register("lead_profile")}
                                      value={formValues.lead_profile}
                                      onChange={handleChange}
                                      disabled={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    >
                                      <option value="">
                                        {" "}
                                        Select Lead Profile{" "}
                                      </option>
                                      {allMasterProfiles.length > 0 &&
                                        allMasterProfiles.map((option) => (
                                          <option value={option.id}>
                                            {option.lead_profile_name}
                                          </option>
                                        ))}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              {!isExternalUser && (
                                <>
                                  {/* <div className={leadId === '' ? "col-md-6" : " col-md-6 hide"}> */}
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label htmlFor="campaign">
                                        <span>Campaign </span>
                                        <select
                                          id="campaign"
                                          name="campaign"
                                          className="form-select"
                                          {...register("campaign")}
                                          value={selectedCampaign}
                                          onChange={handleCampaign}
                                          readOnly={
                                            userRoleType === "Credit" ||
                                            leadStatusFlag === true
                                          }
                                        >
                                          <option value="">
                                            {" "}
                                            Select Campaign{" "}
                                          </option>
                                          {allCampaigns.map((option) => (
                                            <option value={option.id}>
                                              {option.campaign_name}
                                            </option>
                                          ))}
                                        </select>
                                      </label>
                                    </div>
                                  </div>
                                </>
                              )}

                              <div
                                className={
                                  userRoleType !== "User"
                                    ? "col-md-6"
                                    : " col-md-6 hide"
                                }
                              >
                                <div className="form-group">
                                  <label htmlFor="assigned-group">
                                    <span>Assigned group </span>
                                    <select
                                      id="lead_assigned_group"
                                      name="lead_assigned_group"
                                      className="form-select"
                                      {...register("lead_assigned_group")}
                                      value={selectedAssignedGroup}
                                      onChange={handleChangeAssignedGroup}
                                      disabled={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    >
                                      <option value="">
                                        {" "}
                                        Select assigned group{" "}
                                      </option>
                                      {allGroupData.map((option) => (
                                        <option value={option.id}>
                                          {option.group_name}
                                        </option>
                                      ))}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div
                                className={
                                  userRoleType !== "User"
                                    ? "col-md-6"
                                    : " col-md-6 hide"
                                }
                              >
                                <div className="form-group">
                                  <label htmlFor="assigned-user">
                                    <span>Assigned to </span>
                                    <select
                                      id="user"
                                      name="user"
                                      className="form-select"
                                      {...register("user")}
                                      //    value={assignedUser || formValues.user}
                                      value={assignedUser}
                                      onChange={handleAssignedUser}
                                      disabled={
                                        userRoleType === "Credit" ||
                                        leadStatusFlag === true
                                      }
                                    >
                                      <option value=""> Select User </option>
                                      {getAllUsersListData.map((option) => (
                                        <option value={option.user_id}>
                                          {option.name}
                                        </option>
                                      ))}
                                      {getAllUsersListData.length > 0 && (
                                        <option value="any_user">
                                          {" "}
                                          Any User{" "}
                                        </option>
                                      )}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div
                                className="col-md-6 d-none"
                                id="next_action_div"
                              >
                                <div className="form-group">
                                  <label htmlFor="prefill-template-name">
                                    <span>Prefill Template Name </span>
                                    <select
                                      id="prefill_template_name"
                                      name="prefill_template_name"
                                      className="form-select"
                                      {...register("prefill_template_name")}
                                      value={formValues.prefill_template_name}
                                      onChange={handleChange}
                                    >
                                      {/* <option value="1">EV Vehicle Loan</option> */}
                                      <option value="">
                                        {" "}
                                        Select Prefill Template Name{" "}
                                      </option>
                                      {allPrefillTemplateNameData.length > 0 &&
                                        allPrefillTemplateNameData.map(
                                          (option) => (
                                            <option
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {option.prefill_template_name}
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6" id="next_action_div">
                                <div className="form-group">
                                  <label htmlFor="prefill-template-name">
                                    <span>
                                      Type Of Vehicle{" "}
                                      <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <select
                                      id="oem_usage"
                                      name="oem_usage"
                                      className="form-select"
                                      {...register("oem_usage")}
                                      value={formValues.oem_usage}
                                      onChange={handleChange}
                                    >
                                      {/* <option value="1">EV Vehicle Loan</option> */}
                                      <option value=""> Select Usage </option>
                                      {allOemUsage.length > 0 &&
                                        allOemUsage.map((option) => (
                                          <option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.oem_usage_name}
                                          </option>
                                        ))}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6" id="next_action_div">
                                <div className="form-group">
                                  <label htmlFor="prefill-template-name">
                                    <span>
                                      OEM <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <select
                                      id="oem"
                                      name="oem"
                                      className="form-select"
                                      {...register("oem")}
                                      value={formValues.oem}
                                      onChange={handleChange}
                                    >
                                      {/* <option value="1">EV Vehicle Loan</option> */}
                                      <option value=""> Select OEM </option>
                                      {allOem.length > 0 &&
                                        allOem.map((option) => (
                                          <option
                                            key={option.id}
                                            value={option.id}
                                          >
                                            {option.oem_name}
                                          </option>
                                        ))}
                                    </select>
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="dealer_name">
                                    <span>
                                      Dealer Name{" "}
                                      <a style={{ color: "red" }}>* </a>
                                    </span>
                                   {/* <input
                                      type="text"
                                      id="dealer_name"
                                      name="dealer_name"
                                      className="form-control"
                                      {...register("dealer_name")}
                                      value={formValues.dealer_name}
                                      onChange={handleChange}
                                      readOnly={leadStatusFlag === true}
                                    /> */}  

                                    <select
                                      id='dealer_name'
                                      name='dealer_name'
                                      className="form-select"
                                      {...register('dealer_name')}
                                      value={formValues.dealer_name}
                                      onChange={handleChange}
                                      readOnly={leadStatusFlag === true}
                                      >
                                      <option value='' >Please Select </option>
                                      {
                                          allDealers.length > 0 && allDealers.map((option) => (
                                          <option value={option.name} >
                                              {option.name}
                                          </option>
                                          ))
                                      }
                                      </select>
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="sub_dealer_name">
                                    <span>Sub Dealer Name </span>
                                {/*   <input
                                      type="text"
                                      id="sub_dealer_name"
                                      name="sub_dealer_name"
                                      className="form-control"
                                      {...register("sub_dealer_name")}
                                      value={formValues.sub_dealer_name}
                                      onChange={handleChange}
                                      readOnly={leadStatusFlag === true}
                                    /> */ }

                                    <select
                                        id="sub_dealer_name"
                                        name="sub_dealer_name"
                                        className="form-select"
                                        {...register('sub_dealer_name')}
                                        value={formValues.sub_dealer_name}
                                        onChange={handleChange}
                                        disabled={!formValues.dealer_name}
                                         readOnly={leadStatusFlag === true}
                                      >
                                        <option value="">Please Select</option>

                                        {filteredSubDealers.map(option => (
                                          <option key={option.id} value={option.name}>
                                            {option.name}
                                          </option>
                                        ))}
                                      </select>
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="dst_name">
                                    <span>
                                      DST Name{" "}
                                      <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <input
                                      type="text"
                                      id="dst_name"
                                      name="dst_name"
                                      className="form-control"
                                      {...register("dst_name")}
                                      value={formValues.dst_name}
                                      onChange={handleChange}
                                      readOnly={leadStatusFlag === true}
                                    />
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="loan_amount">
                                    <span>
                                      Loan Amount{" "}
                                      <a style={{ color: "red" }}>* </a>
                                    </span>
                                    <input
                                      type="text"
                                      id="loan_amount"
                                      name="loan_amount"
                                      className="form-control"
                                      {...register("loan_amount")}
                                      value={formValues.loan_amount}
                                      onChange={handleChange}
                                      readOnly={leadStatusFlag === true}
                                    />
                                  </label>
                                </div>
                              </div>

                               <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="final_outcome">
                                    <span>Tenure</span>
                                    <select
                                      id="lead_type"
                                      className="form-select"
                                      {...register("lead_tenure")}
                                      value={formValues.lead_tenure}
                                      onChange={handleChange}
                                    >
                                      <option value="6">6 Months</option>
                                      <option value="12">12 Months</option>
                                      <option value="18">18 Months</option>
                                      <option value="24">24 Months</option>
                                      <option value="30">30 Months</option>
                                      <option value="36">36 Months</option>
                                      <option value="42">42 Months</option>
                                      <option value="48">48 Months</option>
                                     
                                    </select>
                                  </label>
                                  {/* {errors.final_outcome && <span className="required">This field is required.</span>} */}
                                </div>
                              </div>

                              <div className= {( userRoleType === "Super Admin" || userRoleType === 'Superadmin' || userRoleType === 'Credit Operations') ? "col-md-6" : "col-md-6 d-none"} >
                                <div className="form-group">
                                  <label htmlFor="AgreementNo" title="Superadmin and Ajay Grover can only update the AgreementNo">
                                    <span>
                                      AllCloud Loan Agreement No 
                                    </span>
                                    <input
                                      type="text"
                                      id="AgreementNo"
                                      name="AgreementNo"
                                      className="form-control"
                                      {...register("AgreementNo")}
                                      value={formValues.AgreementNo}
                                      onChange={handleChange}
                                    />
                                  </label>
                                </div>
 
                                    <button
                                      type="button"
                                      className="btn btn-success float-right"
                                      onClick={() => handleAgreementDetails()}
                                    > 
                                      Update Agreement No
                                    </button>
                                   
                              </div>

                              {/* Type of Vehicle Start */}
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="final_outcome">
                                    <span>Type of Lead </span>
                                    <select
                                      id="lead_type"
                                      className="form-select"
                                      {...register("lead_type_id")}
                                      value={formValues.lead_type_id}
                                      onChange={handleChange}
                                    >
                                      <option value="">
                                        {" "}
                                        Select lead Type{" "}
                                      </option>
                                      {getAllChildsData1.length > 0 &&
                                        getAllChildsData1.map((option) => (
                                          <option value={option.id}>
                                            {option.lead_status}
                                          </option>
                                        ))}
                                    </select>
                                  </label>
                                  {/* {errors.final_outcome && <span className="required">This field is required.</span>} */}
                                </div>
                              </div>

                              {/* Type of Vehicle End */}
                              <div className="col-md-12">
                                <div className="form-group mb-2">
                                  <button
                                    disabled={leadStatusFlag === true}
                                    className="btn btn-primary"
                                  >
                                    {" "}
                                    Save{" "}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    {!isExternalUser && (
                      <>
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#LI-2"
                              aria-expanded="true"
                              aria-controls="LI-2"
                              role="tab"
                              aria-selected={leadId === "" ? "true" : "false"}
                              disabled={leadId === ""}
                            >
                              Co-Applicant
                            </button>
                          </h2>
                          <div
                            id="LI-2"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionLI"
                          >
                            <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                              <CoApplicant
                                leadId={leadId}
                                componentLeadId={leadId}
                                updateParentState={updateParentState}
                                showActionLeadInfo={showActionLeadInfo}
                                allStates={allStates}
                                leadStatusFlag={leadStatusFlag}
                                camLatestStatus={camLatestStatus}
                                userRoleType={userRoleType}
                                isExternalUser={isExternalUser}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#LI-3"
                              aria-expanded="true"
                              aria-controls="LI-3"
                              role="tab"
                              aria-selected={leadId === "" ? "true" : "false"}
                              disabled={leadId === ""}
                            >
                              Guarantor
                            </button>
                          </h2>
                          <div
                            id="LI-3"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionLI"
                          >
                            <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                              <Guarantor
                                leadId={leadId}
                                componentLeadId={leadId}
                                updateParentState={updateParentState}
                                showActionLeadInfo={showActionLeadInfo}
                                allStates={allStates}
                                leadStatusFlag={leadStatusFlag}                                
                                camLatestStatus={camLatestStatus}
                                userRoleType={userRoleType}
                                isExternalUser={isExternalUser}
                              />
                            </div>
                          </div>
                        </div>

                        {/* <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#LI-4" aria-expanded="true" aria-controls="LI-4" role="tab" aria-selected={leadId === '' ? "true" : "false"} disabled={leadId === ''}>
                                                        Bank Statement
                                                    </button>
                                                </h2>
                                                <div id="LI-4" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                                                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                                                        <UploadBankStatement
                                                            allLeadBankStatementByLeadData={allLeadBankStatementByLeadData}
                                                            leadId={leadId}
                                                            fetchLeadIdBankStatement={fetchLeadIdBankStatement}
                                                            updateParentState={updateParentState}
                                                            showActionLeadInfo={showActionLeadInfo}
                                                            leadStatusFlag={leadStatusFlag}
                                                        />
                                                    </div>
                                                </div>
                                            </div> 
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#LI-5" aria-expanded="true" aria-controls="LI-5" role="tab" aria-selected={leadId === '' ? "true" : "false"} disabled={leadId === ''}>
                                                        ITR
                                                    </button>
                                                </h2>
                                                <div id="LI-5" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                                                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                                                        <UploadITR
                                                            allLeadItrByLeadData={allLeadItrByLeadData}
                                                            leadId={leadId}
                                                            fetchLeadIdItr={fetchLeadIdItr}
                                                            updateParentState={updateParentState}
                                                            showActionLeadInfo={showActionLeadInfo}
                                                            leadStatusFlag={leadStatusFlag}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion-item">
                                                <h2 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#LI-6" aria-expanded="true" aria-controls="LI-6" role="tab" aria-selected={leadId === '' ? "true" : "false"} disabled={leadId === ''}>
                                                        GST
                                                    </button>
                                                </h2>
                                                <div id="LI-6" className="accordion-collapse collapse" data-bs-parent="#accordionLI">
                                                    <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                                                        <UploadGST
                                                            allLeadGstByLeadData={allLeadGstByLeadData}
                                                            leadId={leadId}
                                                            fetchLeadIdGst={fetchLeadIdGst}
                                                            updateParentState={updateParentState}
                                                            showActionLeadInfo={showActionLeadInfo}
                                                            leadStatusFlag={leadStatusFlag}
                                                        />
                                                    </div>
                                                </div>
                                            </div> */}

                        <div className="accordion-item d-none-">
                          <h2 className="accordion-header">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#LI-7"
                              aria-expanded="true"
                              aria-controls="LI-7"
                              role="tab"
                              aria-selected={leadId === "" ? "true" : "false"}
                              disabled={leadId === ""}
                            >
                              Document
                            </button>
                          </h2>
                          <div
                            id="LI-7"
                            className="accordion-collapse collapse"
                            data-bs-parent="#accordionLI"
                          >
                            <div className="accordion-body p-md-3 px-2 pt-2 pb-4">
                              <UploadDocument
                                leadId={leadId}
                                componentLeadId={leadId}
                                updateParentState={updateParentState}
                                showActionLeadInfo={showActionLeadInfo}
                                allStates={allStates}
                                leadStatusFlag={leadStatusFlag}
                                camLatestStatus={camLatestStatus}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div
                  className="tab-pane fade first-level"
                  id="pills-summary"
                  role="tabpanel"
                  aria-labelledby="pills-summary-tab"
                  tabIndex="0"
                >
                  <SummaryInfo
                    props={props}
                    leadId={leadId}
                    leadInfo={leadInfo}
                    updateParentState={updateParentState}
                    handleCrifAPI={handleCrifAPI}
                    handleCrifOTPAPI={handleCrifOTPAPI}
                    handleCrifResedOTPAPI={handleCrifResedOTPAPI}
                    userRoleType={userRoleType}
                    isCrifUser={isCrifUser}
                    allStates={allStates}
                    scoreCard={scoreCard}
                    leadStatusFlag={leadStatusFlag}
                    isExternalUser={isExternalUser}
                    camLatestStatus={camLatestStatus}
                    leadFieldPermissions={leadFieldPermissions} 
                  />
                </div>
              </div>
            </div>

            {/* <div className="tab-pane fade" id="pills-lead-check" role="tabpanel" aria-labelledby="pills-lead-check-tab" tabIndex="0"> */}

            <div
              className={
                activeTab === "checklist"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-lead-check"
              role="tabpanel"
              aria-labelledby="pills-lead-check-tab"
              tabIndex="0"
            >
              {!open && activeTab === "checklist" ? (
                <LeadChecklists
                  props={props}
                  allLeadCheckLists={allLeadCheckLists}
                  setOpen={setOpen}
                  setViewModalInfo={setViewModalInfo}
                  setQuestions={setQuestions}
                  setOpenQue={setOpenQue}
                  userRoleType={userRoleType}
                  creditAllLeadCheckLists={creditAllLeadCheckLists}
                  leadStatusFlag={leadStatusFlag}
                  setSectionName="checklist"
                  camLatestStatus={camLatestStatus}
                  leadFieldPermissions={leadFieldPermissions}
                />
              ) : (
                <>
                  {/* <Questionnaire
                                    questions={questions}
                                    checklistInfo={viewModalInfo}
                                    props={props}
                                    setOpen={setOpen}
                                    fetchLeads={fetchLeads}
                                    updateParentState={updateParentState}
                            /> */}

                  <LeadQuestionnaire
                    questions={questions}
                    checklistInfo={viewModalInfo}
                    props={props}
                    setOpen={setOpen}
                    fetchLeads={fetchLeads}
                    updateParentState={updateParentState}
                    userRoleType={userRoleType}
                    scoreCard={scoreCard}
                    leadStatusFlag={leadStatusFlag}
                    setSectionName="checklist"
                    camLatestStatus={camLatestStatus}
                    leadFieldPermissions={leadFieldPermissions}
                    skipPhotoMandatory
                  />
                </>
              )}
            </div>

            <div
              className={
                activeTab === "fi_checklist"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-lead-fi-check"
              role="tabpanel"
              aria-labelledby="pills-lead-fi-check-tab"
              tabIndex="0"
            >
              {!open && activeTab === "fi_checklist" ? (
                <LeadChecklists
                  props={props}
                  allLeadCheckLists={allLeadCheckLists}
                  setOpen={setOpen}
                  setViewModalInfo={setViewModalInfo}
                  setQuestions={setQuestions}
                  setOpenQue={setOpenQue}
                  userRoleType={userRoleType}
                  creditAllLeadCheckLists={creditAllLeadCheckLists}
                  leadStatusFlag={leadStatusFlag}
                  setSectionName="fi_checklist"
                  camLatestStatus={camLatestStatus}
                />
              ) : (
                <>
                  {/* <Questionnaire
                                    questions={questions}
                                    checklistInfo={viewModalInfo}
                                    props={props}
                                    setOpen={setOpen}
                                    fetchLeads={fetchLeads}
                                    updateParentState={updateParentState}
                            /> */}

                  <LeadQuestionnaire
                    questions={questions}
                    checklistInfo={viewModalInfo}
                    props={props}
                    setOpen={setOpen}
                    fetchLeads={fetchLeads}
                    updateParentState={updateParentState}
                    userRoleType={userRoleType}
                    scoreCard={scoreCard}
                    leadStatusFlag={leadStatusFlag}
                    setSectionName="fi_checklist"
                    camLatestStatus={camLatestStatus}
                  />
                </>
              )}
            </div>

            <div
              className={
                activeTab === "vivriti_checklist"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-lead-vivriti-check"
              role="tabpanel"
              aria-labelledby="pills-lead-vivriti-check-tab"
              tabIndex="0"
            >
              {!open && activeTab === "vivriti_checklist" ? (
                <LeadChecklists
                  props={props}
                  allLeadCheckLists={allLeadCheckLists}
                  setOpen={setOpen}
                  setViewModalInfo={setViewModalInfo}
                  setQuestions={setQuestions}
                  setOpenQue={setOpenQue}
                  userRoleType={userRoleType}
                  creditAllLeadCheckLists={creditAllLeadCheckLists}
                  leadStatusFlag={leadStatusFlag}
                  setSectionName="vivriti_checklist"
                  camLatestStatus={camLatestStatus}
                  leadFieldPermissions={leadFieldPermissions}
                />
              ) : (
                <>
                  {/* <Questionnaire
                                    questions={questions}
                                    checklistInfo={viewModalInfo}
                                    props={props}
                                    setOpen={setOpen}
                                    fetchLeads={fetchLeads}
                                    updateParentState={updateParentState}
                            /> */}

                  <LeadQuestionnaire
                    questions={questions}
                    checklistInfo={viewModalInfo}
                    props={props}
                    setOpen={setOpen}
                    fetchLeads={fetchLeads}
                    updateParentState={updateParentState}
                    userRoleType={userRoleType}
                    scoreCard={scoreCard}
                    leadStatusFlag={leadStatusFlag}
                    setSectionName="vivriti_checklist"
                    camLatestStatus={camLatestStatus}
                    leadFieldPermissions={leadFieldPermissions}
                  />
                </>
              )}
            </div> 


            {!isExternalUser && reFiChecklistStatus &&  ( userRoleType === "Super Admin" || userRoleType === "Superadmin" || userRoleType === "Credit Head" || userRoleType === "Regional Sales Manager" || userRoleType === "Regional Head" || userRoleType === "Cluster Head"  ) && (
                <>
            <div
              className={
                activeTab === "re_fi_checklist"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-lead-re_fi_checklist-check"
              role="tabpanel"
              aria-labelledby="pills-lead-re_fi_checklist-check-tab"
              tabIndex="0"
            >
              { activeTab === "re_fi_checklist" && (  
                <>
               <h5 className='fw-bold mb-3'>Re-FI History</ h5>                                  
                <FiDetils 
                    props={props}
                    pageTitle= ""
                    allFiSaveHistory={allReFISaveHistory}
                    leadId={leadId}
                    camLatestStatus={camLatestStatus}
                    setSectionName="re_fi_checklist"
                  /> 
                  <br/>
                  <hr/>
                  <br/>
                  </>
              )}

              {!open && activeTab === "re_fi_checklist" ? (
                <LeadChecklists
                  props={props}
                  allLeadCheckLists={allLeadCheckLists}
                  setOpen={setOpen}
                  setViewModalInfo={setViewModalInfo}
                  setQuestions={setQuestions}
                  setOpenQue={setOpenQue}
                  userRoleType={userRoleType}
                  creditAllLeadCheckLists={creditAllLeadCheckLists}
                  leadStatusFlag={leadStatusFlag}
                  setSectionName="re_fi_checklist"
                  camLatestStatus={camLatestStatus}
                />
              ) : (
                <>
                  
                  <LeadQuestionnaire
                    questions={questions}
                    checklistInfo={viewModalInfo}
                    props={props}
                    setOpen={setOpen}
                    fetchLeads={fetchLeads}
                    updateParentState={updateParentState}
                    userRoleType={userRoleType}
                    scoreCard={scoreCard}
                    leadStatusFlag={leadStatusFlag}
                    setSectionName="re_fi_checklist"
                    camLatestStatus={camLatestStatus}
                  />
                </>
              )}


               { activeTab === "re_fi_checklist" &&  ( userRoleType === "Superadmin" || userRoleType === "Credit Head" || userRoleType === "Super Admin"  ) && (  
                <>
                <div style={{background: "aliceblue",padding: "10px"}}>
                <br/>
                <hr/>
                <br/>
               <h5 className='fw-bold mb-3'>Re-FI Review</ h5>                                  
                <ReFIReview 
                    props={props}
                    pageTitle= ""
                    allFiSaveHistory={allReFIReviewdHistory}
                    leadId={leadId}
                    camLatestStatus={camLatestStatus}
                    userRoleType ={userRoleType}
                    setSectionName="re_fi_checklist"
                     questions={questions}
                    checklistInfo={viewModalInfo}
                    setOpen={setOpen}
                    fetchLeads={fetchLeads}
                    updateParentState={updateParentState}
                    scoreCard={scoreCard}
                    leadStatusFlag={leadStatusFlag}
                  /> 
                  
                  </div>
                  </>
              )}
            </div> 
            </>
            )}
            
            <div
              className={
                activeTabName === "communication" && activeTab === "communication"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-communication"
              role="tabpanel"
              aria-labelledby="pills-communication-tab"
              tabIndex="0"
            >
              <LeadCommunication
                allInteractions={allInteractions}
                leadId={leadId}
                allInteractionTypeData={allInteractionTypeData}
                fetchInteractions={fetchInteractions}
                leadStatusFlag={leadStatusFlag}
                updateParentState={updateParentState}
                isExternalUser={isExternalUser}
                camLatestStatus={camLatestStatus}
                userRoleType={userRoleType}
                escalationToUsers={escalationToUsers}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div>

            <div
              className={
                activeTabName === "activity"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-activity"
              role="tabpanel"
              aria-labelledby="pills-activity-tab"
              tabIndex="0"
            >
              <LeadUploadAcivity
                props={props}
                allLeadActivity={allLeadActivity}
                setOpen={setOpen}
                camLatestStatus={camLatestStatus}
              />
            </div>

            <div
              className={
                activeTabName === "shipment"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-shipment"
              role="tabpanel"
              aria-labelledby="pills-shipment-tab"
              tabIndex="0"
            >
              <ManageShipmentByLeadListingPage
                props={props}
                allShipment={allShipment}
                leadId={leadId}
                camLatestStatus={camLatestStatus}
                // setOpen={setOpen}
              />
            </div>

            {/* <div style={{border: '1px solid red'}} className={activeTabName === 'score' ? "tab-pane fade show active" : "tab-pane fade"} id="pills-dynamic-lead-score" role="tabpanel" aria-labelledby="pills-dynamic-lead-score-tab" tabIndex="0"> */}

            <div
              className={
                activeTabName === "communication" && activeTab === "scorecard"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-dynamic-lead-score"
              role="tabpanel"
              aria-labelledby="pills-dynamic-lead-score-tab"
              tabIndex="0"
            >
              <LeadChecklistDynamicScore
                props={props}
                leadInfo={leadInfo}
                allLeadCheckListDynamicScore={allLeadCheckListDynamicScore}
                setOpen={setOpen}
                leadId={leadId}
                allLeadCheckLists={allLeadCheckLists}
                userRoleType={userRoleType}
                creditAllLeadCheckLists={creditAllLeadCheckLists}
                scoreCard={scoreCard}
                allLeadCheckListScore={allLeadCheckListScore}
                camLatestStatus={camLatestStatus}
                fetchScoreCardDetails={fetchScoreCardDetails}
              />
            </div>


              <div className={activeTabName === 'communication' && activeTab === 'tvr' ? "tab-pane fade show active" : "tab-pane fade"} id="pills-tvr" role="tabpanel" aria-labelledby="pills-tvr-tab" tabIndex="0">
                <LeadChecklistTvr
                    props={props}
                     // allLeadCheckList{allLeadCheckListDynamicScore}
                    setOpen={setOpen}
                    leadId={leadId}
                    // allLeadCheckLists={allLeadCheckLists}
                    userRoleType={userRoleType}
                    creditAllLeadCheckLists={creditAllLeadCheckLists}
                    // scoreCard={scoreCard}
                    // allLeadCheckListScore={allLeadCheckListScore}
                />
              </div>


            {/* <div className={activeTabName === 'fi' ? "tab-pane fade show active" : "tab-pane fade"} id="pills-dynamic-fi-details" role="tabpanel" aria-labelledby="pills-dynamic-fi-details-tab" tabIndex="0"> */}

            <div
              className={
                activeTabName === "communication" && activeTab === "fi_details"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-dynamic-fi-details"
              role="tabpanel"
              aria-labelledby="pills-dynamic-fi-details-tab"
              tabIndex="0"
            >
              <FiDetils
                props={props}
                pageTitle= "FI Details"
                allFiSaveHistory={allFiSaveHistory}
                leadId={leadId}
                camLatestStatus={camLatestStatus}
              />
            </div>

            <div
              className="tab-pane fade"
              id="pills-bank_statement-details"
              role="tabpanel"
              aria-labelledby="pills-bank_statement-details-tab"
              tabIndex="0"
            >
              In progress...
            </div>

            <div
              className={
                activeTabName === "communication" &&
                activeTab === "additional_documents"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-additional_documents-details"
              role="tabpanel"
              aria-labelledby="pills-additional_documents-details-tab"
              tabIndex="0"
            >
              <UploadDocument
                leadId={leadId}
                componentLeadId={leadId}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div>

            <div
              className={
                activeTabName === "communication" &&
                activeTab === "bank_statement"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-bank_statement_tab-details"
              role="tabpanel"
              aria-labelledby="pills-bank_statement_tab-details-tab"
              tabIndex="0"
            >
              <BankStatementParser
                     camLatestStatus={camLatestStatus}
                     leadInfo={leadInfo}
                     leadFieldPermissions={leadFieldPermissions}
              />
            </div>

            <div
              className={
                activeTabName === "communication" &&
                activeTab === "sanction_letter"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-sanction_letter-details"
              role="tabpanel"
              aria-labelledby="pills-sanction_letter-details-tab"
              tabIndex="0"
            >   
              <SanctionLetter
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "sanction_letter"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}                
                selectionVersioningID ={selectionVersioningID}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div>

            <div
              className={
                activeTabName === "communication" &&
                activeTab === "delivery_order"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-delivery_order-details"
              role="tabpanel"
              aria-labelledby="pills-delivery_order-details-tab"
              tabIndex="0"
            >   
              <DeliveryOrder
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "delivery_order"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}
                selectionVersioningID ={selectionVersioningID}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div>

           <div
              className={
                activeTabName === "communication" &&
                activeTab === "disbursement_stage"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-disbursement_stage-details"
              role="tabpanel"
              aria-labelledby="pills-disbursement_stage-details-tab"
              tabIndex="0"
            >   
              <DisbursementStage
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "disbursement_stage"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}
                selectionVersioningID ={selectionVersioningID}
                fetchLeads={fetchLeads}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div>

            <div
              className={
                activeTabName === "communication" &&
                activeTab === "post_disbursal_document"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-post_disbursal_document-details"
              role="tabpanel"
              aria-labelledby="pills-post_disbursal_document-details-tab"
              tabIndex="0"
            >   
              <PostDisbursalDocument
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "post_disbursal_document"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}
                selectionVersioningID ={selectionVersioningID}
                activeTab={activeTab}
                props={props}
                allLeadCheckLists={allLeadCheckLists}
                open={open}           // the boolean
                setOpen={setOpen} 
                viewModalInfo={setViewModalInfo}
                setViewModalInfo={setViewModalInfo}
                setQuestions={setQuestions}
                setOpenQue={setOpenQue} 
                creditAllLeadCheckLists={creditAllLeadCheckLists}
                setSectionName="post_disbursal_document"
                questions={questions}
                checklistInfo={viewModalInfo}
                fetchLeads={fetchLeads}
                scoreCard={scoreCard}
                onRowClickActionWL={onRowClickActionWL}
                leadFieldPermissions={leadFieldPermissions}

              />
            </div> 

            <div
              className={
                activeTabName === "communication" &&
                activeTab === "application_details"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-application_details-details"
              role="tabpanel"
              aria-labelledby="pills-application_details-details-tab"
              tabIndex="0"
            >   
              <ApplicationDetails
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "application_details"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}                
                selectionVersioningID ={selectionVersioningID}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div> 

            <div
              className={
                activeTabName === "communication" && activeTab === "cam"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-cam_tab-details"
              role="tabpanel"
              aria-labelledby="pills-cam_tab-details-tab"
              tabIndex="0"
            >
              <CamPage
                leadInfo={leadInfo}
                isActive={activeTab === "cam"}
                setUserRoleType={setUserRoleType}
                userRoleType={userRoleType}
                camLatestStatus={camLatestStatus}
                allLeadBankStatementCount = {allLeadBankStatementCount}
                enableCamDetailsStatus = {enableCamDetailsStatus}
                vivritiChecklistStatusHandler = {vivritiChecklistStatusHandler}
                fetchLeads = {fetchLeads}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}
                selectionVersioningID ={selectionVersioningID}
                leadFieldPermissions={leadFieldPermissions}
               />
            </div>

            {/* FI SHEET */}
            {/* <div className="tab-pane fade" id="pills-fi_sheet_tab-details" role="tabpanel" aria-labelledby="pills-fi_sheet_tab-details-tab" tabIndex="0"> */}

            <div
              className={
                activeTabName === "document"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-document"
              role="tabpanel"
              aria-labelledby="pills-communication-tab"
              tabIndex="0"
            >
              <UploadDocument
                leadId={leadId}
                componentLeadId={leadId}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
              />
            </div>


            <div
              className={
                activeTabName === "communication" &&
                activeTab === "case_management_system"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-case_management_system-details"
              role="tabpanel"
              aria-labelledby="pills-case_management_system-details-tab"
              tabIndex="0"
            >   
              <CaseManagementSystem
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "case_management_system"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}                
                selectionVersioningID ={selectionVersioningID}
              />
            </div> 

             <div
              className={
                activeTabName === "communication" &&
                activeTab === "tasks"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-tasks-details"
              role="tabpanel"
              aria-labelledby="pills-tasks-details-tab"
              tabIndex="0"
            >   
              <LeadTasks
                leadId={leadId}
                componentLeadId={leadId}
                getIncidentTaskId={leadId}
                getIncidentReportId={leadId}
                fetchModule={fetchModule}
                isActive={activeTab === "tasks"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}                
                selectionVersioningID ={selectionVersioningID}
              
                setOpen={setOpen}
                allIncidentTask={allIncidentTask}
                overrideRequestFlow={overrideRequestFlow}
                isEditableIncidentCurrentStatus={isEditableIncidentCurrentStatus}
                isEditableStatus={isEditableStatus}
                loggedInUserId={loggedInUserId} 
                leadFieldPermissions={leadFieldPermissions}
              />
            </div> 

            {/* <div className="tab-pane fade" id="pills-reference-check" role="tabpanel" aria-labelledby="pills-reference-tab" tabIndex="0">
                            <h5 className='fw-bold mb-3'>Reference</h5>
                            <form>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <label htmlFor="r_name">
                                            <span>Name</span>
                                            <input
                                            type='text'
                                            id='r_name'
                                            name='r_name'
                                            className='form-control'
                                            />
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <label htmlFor="r_email">
                                            <span>Email ID</span>
                                            <input
                                            type='email'
                                            id='r_email'
                                            name='r_email'
                                            className='form-control'
                                            />
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <label htmlFor="r_phone">
                                            <span>Phone Number</span>
                                            <input
                                            type='tel'
                                            id='r_phone'
                                            name='r_phone'
                                            className='form-control'
                                            />
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <label htmlFor="r_file">
                                            <span>File Upload</span>
                                            <input
                                            type='file'
                                            multiple
                                            id='r_file'
                                            name='r_file'
                                            className='form-control'
                                            />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className='form-group mt-2'>
                                    <button className="btn btn-primary">Save</button>
                                </div>
                            </form>
                        </div> */}

            {/* <div className="tab-pane fade" id="pills-incident-check" role="tabpanel" aria-labelledby="pills-incident-tab" tabIndex="0">

                            <IncidentReporteCreate
                                allTicketData={allTicketData}
                                leadId={leadId}
                                fetchIncidentReporte={fetchIncidentReporte}
                                allGroupData={allGroupData}
                            /> */}

            {/* <div className='d-flex justify-content-between mb-3'>
                                <h5 className='fw-bold mb-3'>Incident Reporting</h5>
                                <RouterLink to={`/dashboard/create-incident-reporting/${btoa(String(leadId))}`} className='add-btn btn-primary no-effect btn'><i className="bi bi-plus">&nbsp;</i> Create Report</RouterLink>
                            </div> 
                            <div className='form-group mt-2'>
                                <RouterLink to={`/dashboard/incident-reporting/${btoa(String(leadId))}`} className='add-btn btn-primary no-effect btn'><i className="bi bi-plus">&nbsp;</i>View Reports</RouterLink>
                            </div> */}
            {/* </div> */}


            <div
              className={
                activeTabName === "communication" &&
                activeTab === "repayment_schedule_tab"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-repayment_schedule_tab-details"
              role="tabpanel"
              aria-labelledby="pills-repayment_schedule_tab-details-tab"
              tabIndex="0"
            >   
              <RepaymentSchedule
                leadId={leadId}
                componentLeadId={leadId}
                isActive={activeTab === "repayment_schedule_tab"}
                updateParentState={updateParentState}
                showActionLeadInfo={showActionLeadInfo}
                allStates={allStates}
                leadStatusFlag={leadStatusFlag}
                camLatestStatus={camLatestStatus}
                userRoleType = {userRoleType}
                leadInfo={leadInfo}
                backToLeadHandler={backToLeadHandler} 
                enableCamDetailsHandler = {enableCamDetailsHandler}                
                selectionVersioningID ={selectionVersioningID}
                leadFieldPermissions={leadFieldPermissions} 
              />
            </div>

            <div
              className={
                activeTabName === "communication" && activeTab === "cam_communication"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-cam_communication-details"
              role="tabpanel"
              tabIndex="0"
            >
              <Communication
                leadId={leadId}
                userId={loggeInUserID}
                leadFieldPermissions={leadFieldPermissions}
              />
            </div>

            <div
              className={
                activeTabName === "communication" && activeTab === "call_to_lead"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-call_to_lead-details"
              role="tabpanel"
              tabIndex="0"
            >
              {activeTab === "call_to_lead" && (
                <CallToLead leaddetails={leadInfo} leadId={leadId} leadFieldPermissions={leadFieldPermissions} />
              )}
          </div>

          <div
              className={
                activeTabName === "communication" && activeTab === "beat_plan"
                  ? "tab-pane fade show active"
                  : "tab-pane fade"
              }
              id="pills-beat_plan-details"
              role="tabpanel"
              tabIndex="0"
            >
              {activeTab === "beat_plan" && (
                <BeatPlanTab leaddetails={leadInfo} leadId={leadId} />
              )}
          </div>
                          
          <div className='table-wrap'>
                     {isOpen && (
                      <div style={styles.overlay}>
                        <div style={styles.modal}>
                          <button style={styles.closeButton} onClick={() => setIsOpen(false)}>×</button>
                          <iframe
                            title="Report"
                            width="100%"
                            height="430"
                            src={iframeSrc}
                            frameBorder="0"
                            allowFullScreen
                            onLoad={handleIframeLoad}
                            style={{ display: iframeLoaded ? 'block' : 'none' }}
                        />
                        </div>
                      </div>
                    
                    )}
                </div>
                
          </div>
        </div>
        {prefillConfirmModal.open && (
          <div style={confirmModalStyles.overlay}>
            <div style={confirmModalStyles.box}>
              <div style={confirmModalStyles.iconWrap}>
                <span style={confirmModalStyles.icon}>!</span>
              </div>
              <h5 style={confirmModalStyles.title}>Are you sure?</h5>
              <p style={confirmModalStyles.message}>
                {prefillConfirmModal.source === 'aadhar'
                  ? 'Do you want to use Aadhaar data to prefill the form?'
                  : 'Do you want to use PAN data to prefill the form?'}
              </p>
              <div style={confirmModalStyles.btnRow}>
                <button type="button" style={confirmModalStyles.yesBtn} onClick={handlePrefillConfirmYes}>
                  Yes, use it!
                </button>
                <button type="button" style={confirmModalStyles.noBtn} onClick={handlePrefillConfirmNo}>
                  No, cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </Container>

       

    </>
  );
};
function mapStateToProps(state) {
  return {
    leadsData: state.leadsData,
    usersData: state.usersData,
    leadInfo: state.leadInfo,
    sourceData: state.sourceData,
    masterProfileData: state.masterProfileData,
    leadChecklistData: state.leadChecklistData,
    interactionTypeData: state.interactionTypeData,
    leadStatusData: state.leadStatusData,
    getUserModuleData: state.getUserModuleData,
    incidentReporteData: state.incidentReporteData,
    leadGstByLeadData: state.leadGstByLeadData,
    leadItrByLeadData: state.leadItrByLeadData,
    leadBankStatementByLeadData: state.leadBankStatementByLeadData,
    campaignData: state.campaignData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(
        leadActions.default,
        userActions.default,
        incidentReporteActions.default,
        groupsUsersActions.default,
        leadGstActions.default,
        leadItrActions.default,
        leadBankStatementActions.default,
        campaignsActions.default,
        masterAction.default, 
        moduleAction.default
      ),
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEditLeadV2Page);